export default [
  {
    text: "Abbeville, SC",
    value: "abbeville:south carolina",
  },
  {
    text: "Acadia, LA",
    value: "acadia:louisiana",
  },
  {
    text: "Accomack, VA",
    value: "accomack:virginia",
  },
  {
    text: "Ada, ID",
    value: "ada:idaho",
  },
  {
    text: "Adair, KY",
    value: "adair:kentucky",
  },
  {
    text: "Adair, MO",
    value: "adair:missouri",
  },
  {
    text: "Adair, OK",
    value: "adair:oklahoma",
  },
  {
    text: "Adair, IA",
    value: "adair:iowa",
  },
  {
    text: "Adams, IL",
    value: "adams:illinois",
  },
  {
    text: "Adams, IN",
    value: "adams:indiana",
  },
  {
    text: "Adams, MS",
    value: "adams:mississippi",
  },
  {
    text: "Adams, OH",
    value: "adams:ohio",
  },
  {
    text: "Adams, PA",
    value: "adams:pennsylvania",
  },
  {
    text: "Adams, IA",
    value: "adams:iowa",
  },
  {
    text: "Adams, NE",
    value: "adams:nebraska",
  },
  {
    text: "Adams, WI",
    value: "adams:wisconsin",
  },
  {
    text: "Adams, ND",
    value: "adams:north dakota",
  },
  {
    text: "Adams, CO",
    value: "adams:colorado",
  },
  {
    text: "Adams, WA",
    value: "adams:washington",
  },
  {
    text: "Adams, ID",
    value: "adams:idaho",
  },
  {
    text: "Addison, VT",
    value: "addison:vermont",
  },
  {
    text: "Aiken, SC",
    value: "aiken:south carolina",
  },
  {
    text: "Aitkin, MN",
    value: "aitkin:minnesota",
  },
  {
    text: "Alachua, FL",
    value: "alachua:florida",
  },
  {
    text: "Alamance, NC",
    value: "alamance:north carolina",
  },
  {
    text: "Alameda, CA",
    value: "alameda:california",
  },
  {
    text: "Alamosa, CO",
    value: "alamosa:colorado",
  },
  {
    text: "Albany, NY",
    value: "albany:new york",
  },
  {
    text: "Albany, WY",
    value: "albany:wyoming",
  },
  {
    text: "Albemarle, VA",
    value: "albemarle:virginia",
  },
  {
    text: "Alcona, MI",
    value: "alcona:michigan",
  },
  {
    text: "Alcorn, MS",
    value: "alcorn:mississippi",
  },
  {
    text: "Aleutians East, AK",
    value: "aleutians east:alaska",
  },
  {
    text: "Aleutians West, AK",
    value: "aleutians west:alaska",
  },
  {
    text: "Alexander, IL",
    value: "alexander:illinois",
  },
  {
    text: "Alexander, NC",
    value: "alexander:north carolina",
  },
  {
    text: "Alexandria, VA",
    value: "alexandria city:virginia",
  },
  {
    text: "Alfalfa, OK",
    value: "alfalfa:oklahoma",
  },
  {
    text: "Alger, MI",
    value: "alger:michigan",
  },
  {
    text: "Allamakee, IA",
    value: "allamakee:iowa",
  },
  {
    text: "Allegan, MI",
    value: "allegan:michigan",
  },
  {
    text: "Allegany, MD",
    value: "allegany:maryland",
  },
  {
    text: "Allegany, NY",
    value: "allegany:new york",
  },
  {
    text: "Alleghany, VA",
    value: "alleghany:virginia",
  },
  {
    text: "Alleghany, NC",
    value: "alleghany:north carolina",
  },
  {
    text: "Allegheny, PA",
    value: "allegheny:pennsylvania",
  },
  {
    text: "Allen, IN",
    value: "allen:indiana",
  },
  {
    text: "Allen, KS",
    value: "allen:kansas",
  },
  {
    text: "Allen, KY",
    value: "allen:kentucky",
  },
  {
    text: "Allen, LA",
    value: "allen:louisiana",
  },
  {
    text: "Allen, OH",
    value: "allen:ohio",
  },
  {
    text: "Allen, IN",
    value: "allen parish:indiana",
  },
  {
    text: "Allen, KS",
    value: "allen parish:kansas",
  },
  {
    text: "Allen, KY",
    value: "allen parish:kentucky",
  },
  {
    text: "Allen, LA",
    value: "allen parish:louisiana",
  },
  {
    text: "Allen, OH",
    value: "allen parish:ohio",
  },
  {
    text: "Allendale, SC",
    value: "allendale:south carolina",
  },
  {
    text: "Alpena, MI",
    value: "alpena:michigan",
  },
  {
    text: "Alpine, CA",
    value: "alpine:california",
  },
  {
    text: "Amador, CA",
    value: "amador:california",
  },
  {
    text: "Amelia, VA",
    value: "amelia:virginia",
  },
  {
    text: "Amherst, VA",
    value: "amherst:virginia",
  },
  {
    text: "Amite, MS",
    value: "amite:mississippi",
  },
  {
    text: "Anchorage, AK",
    value: "anchorage:alaska",
  },
  {
    text: "Anderson, TX",
    value: "anderson:texas",
  },
  {
    text: "Anderson, KS",
    value: "anderson:kansas",
  },
  {
    text: "Anderson, KY",
    value: "anderson:kentucky",
  },
  {
    text: "Anderson, TN",
    value: "anderson:tennessee",
  },
  {
    text: "Anderson, SC",
    value: "anderson:south carolina",
  },
  {
    text: "Andrew, MO",
    value: "andrew:missouri",
  },
  {
    text: "Andrews, TX",
    value: "andrews:texas",
  },
  {
    text: "Androscoggin, ME",
    value: "androscoggin:maine",
  },
  {
    text: "Angelina, TX",
    value: "angelina:texas",
  },
  {
    text: "Anne Arundel, MD",
    value: "anne arundel:maryland",
  },
  {
    text: "Anoka, MN",
    value: "anoka:minnesota",
  },
  {
    text: "Anson, NC",
    value: "anson:north carolina",
  },
  {
    text: "Antelope, NE",
    value: "antelope:nebraska",
  },
  {
    text: "Antrim, MI",
    value: "antrim:michigan",
  },
  {
    text: "Apache, AZ",
    value: "apache:arizona",
  },
  {
    text: "Appanoose, IA",
    value: "appanoose:iowa",
  },
  {
    text: "Appling, GA",
    value: "appling:georgia",
  },
  {
    text: "Appomattox, VA",
    value: "appomattox:virginia",
  },
  {
    text: "Aransas, TX",
    value: "aransas:texas",
  },
  {
    text: "Arapahoe, CO",
    value: "arapahoe:colorado",
  },
  {
    text: "Archer, TX",
    value: "archer:texas",
  },
  {
    text: "Archuleta, CO",
    value: "archuleta:colorado",
  },
  {
    text: "Arenac, MI",
    value: "arenac:michigan",
  },
  {
    text: "Arkansas, AR",
    value: "arkansas:arkansas",
  },
  {
    text: "Arlington, VA",
    value: "arlington:virginia",
  },
  {
    text: "Armstrong, TX",
    value: "armstrong:texas",
  },
  {
    text: "Armstrong, PA",
    value: "armstrong:pennsylvania",
  },
  {
    text: "Aroostook, ME",
    value: "aroostook:maine",
  },
  {
    text: "Arthur, NE",
    value: "arthur:nebraska",
  },
  {
    text: "Ascension, LA",
    value: "ascension:louisiana",
  },
  {
    text: "Ashe, NC",
    value: "ashe:north carolina",
  },
  {
    text: "Ashland, OH",
    value: "ashland:ohio",
  },
  {
    text: "Ashland, WI",
    value: "ashland:wisconsin",
  },
  {
    text: "Ashley, AR",
    value: "ashley:arkansas",
  },
  {
    text: "Ashtabula, OH",
    value: "ashtabula:ohio",
  },
  {
    text: "Asotin, WA",
    value: "asotin:washington",
  },
  {
    text: "Assumption, LA",
    value: "assumption:louisiana",
  },
  {
    text: "Atascosa, TX",
    value: "atascosa:texas",
  },
  {
    text: "Atchison, KS",
    value: "atchison:kansas",
  },
  {
    text: "Atchison, MO",
    value: "atchison:missouri",
  },
  {
    text: "Athens, OH",
    value: "athens:ohio",
  },
  {
    text: "Atkinson, GA",
    value: "atkinson:georgia",
  },
  {
    text: "Atlantic, NJ",
    value: "atlantic:new jersey",
  },
  {
    text: "Atoka, OK",
    value: "atoka:oklahoma",
  },
  {
    text: "Attala, MS",
    value: "attala:mississippi",
  },
  {
    text: "Audrain, MO",
    value: "audrain:missouri",
  },
  {
    text: "Audubon, IA",
    value: "audubon:iowa",
  },
  {
    text: "Auglaize, OH",
    value: "auglaize:ohio",
  },
  {
    text: "Augusta, VA",
    value: "augusta:virginia",
  },
  {
    text: "Aurora, SD",
    value: "aurora:south dakota",
  },
  {
    text: "Austin, TX",
    value: "austin:texas",
  },
  {
    text: "Autauga, AL",
    value: "autauga:alabama",
  },
  {
    text: "Avery, NC",
    value: "avery:north carolina",
  },
  {
    text: "Avoyelles, LA",
    value: "avoyelles:louisiana",
  },
  {
    text: "Avoyelles, LA",
    value: "avoyelles parish:louisiana",
  },
  {
    text: "Baca, CO",
    value: "baca:colorado",
  },
  {
    text: "Bacon, GA",
    value: "bacon:georgia",
  },
  {
    text: "Bailey, TX",
    value: "bailey:texas",
  },
  {
    text: "Baker, FL",
    value: "baker:florida",
  },
  {
    text: "Baker, GA",
    value: "baker:georgia",
  },
  {
    text: "Baker, OR",
    value: "baker:oregon",
  },
  {
    text: "Baldwin, AL",
    value: "baldwin:alabama",
  },
  {
    text: "Baldwin, GA",
    value: "baldwin:georgia",
  },
  {
    text: "Ballard, KY",
    value: "ballard:kentucky",
  },
  {
    text: "Baltimore, MD",
    value: "baltimore:maryland",
  },
  {
    text: "Baltimore, MD",
    value: "baltimore city:maryland",
  },
  {
    text: "Bamberg, SC",
    value: "bamberg:south carolina",
  },
  {
    text: "Bandera, TX",
    value: "bandera:texas",
  },
  {
    text: "Banks, GA",
    value: "banks:georgia",
  },
  {
    text: "Banner, NE",
    value: "banner:nebraska",
  },
  {
    text: "Bannock, ID",
    value: "bannock:idaho",
  },
  {
    text: "Baraga, MI",
    value: "baraga:michigan",
  },
  {
    text: "Barber, KS",
    value: "barber:kansas",
  },
  {
    text: "Barbour, AL",
    value: "barbour:alabama",
  },
  {
    text: "Barbour, WV",
    value: "barbour:west virginia",
  },
  {
    text: "Barnes, ND",
    value: "barnes:north dakota",
  },
  {
    text: "Barnstable, MA",
    value: "barnstable:massachusetts",
  },
  {
    text: "Barnwell, SC",
    value: "barnwell:south carolina",
  },
  {
    text: "Barren, KY",
    value: "barren:kentucky",
  },
  {
    text: "Barron, WI",
    value: "barron:wisconsin",
  },
  {
    text: "Barrow, GA",
    value: "barrow:georgia",
  },
  {
    text: "Barry, MO",
    value: "barry:missouri",
  },
  {
    text: "Barry, MI",
    value: "barry:michigan",
  },
  {
    text: "Bartholomew, IN",
    value: "bartholomew:indiana",
  },
  {
    text: "Barton, KS",
    value: "barton:kansas",
  },
  {
    text: "Barton, MO",
    value: "barton:missouri",
  },
  {
    text: "Bartow, GA",
    value: "bartow:georgia",
  },
  {
    text: "Bastrop, TX",
    value: "bastrop:texas",
  },
  {
    text: "Bates, MO",
    value: "bates:missouri",
  },
  {
    text: "Bath, VA",
    value: "bath:virginia",
  },
  {
    text: "Bath, KY",
    value: "bath:kentucky",
  },
  {
    text: "Baxter, AR",
    value: "baxter:arkansas",
  },
  {
    text: "Bay, FL",
    value: "bay:florida",
  },
  {
    text: "Bay, MI",
    value: "bay:michigan",
  },
  {
    text: "Bayfield, WI",
    value: "bayfield:wisconsin",
  },
  {
    text: "Baylor, TX",
    value: "baylor:texas",
  },
  {
    text: "Beadle, SD",
    value: "beadle:south dakota",
  },
  {
    text: "Bear Lake, ID",
    value: "bear lake:idaho",
  },
  {
    text: "Beaufort, NC",
    value: "beaufort:north carolina",
  },
  {
    text: "Beaufort, SC",
    value: "beaufort:south carolina",
  },
  {
    text: "Beauregard, LA",
    value: "beauregard:louisiana",
  },
  {
    text: "Beauregard, LA",
    value: "beauregard parish:louisiana",
  },
  {
    text: "Beaver, OK",
    value: "beaver:oklahoma",
  },
  {
    text: "Beaver, PA",
    value: "beaver:pennsylvania",
  },
  {
    text: "Beaver, UT",
    value: "beaver:utah",
  },
  {
    text: "Beaverhead, MT",
    value: "beaverhead:montana",
  },
  {
    text: "Becker, MN",
    value: "becker:minnesota",
  },
  {
    text: "Beckham, OK",
    value: "beckham:oklahoma",
  },
  {
    text: "Bedford, VA",
    value: "bedford:virginia",
  },
  {
    text: "Bedford, TN",
    value: "bedford:tennessee",
  },
  {
    text: "Bedford, PA",
    value: "bedford:pennsylvania",
  },
  {
    text: "Bee, TX",
    value: "bee:texas",
  },
  {
    text: "Belknap, NH",
    value: "belknap:new hampshire",
  },
  {
    text: "Bell, TX",
    value: "bell:texas",
  },
  {
    text: "Bell, KY",
    value: "bell:kentucky",
  },
  {
    text: "Belmont, OH",
    value: "belmont:ohio",
  },
  {
    text: "Beltrami, MN",
    value: "beltrami:minnesota",
  },
  {
    text: "Ben Hill, GA",
    value: "ben hill:georgia",
  },
  {
    text: "Benewah, ID",
    value: "benewah:idaho",
  },
  {
    text: "Bennett, SD",
    value: "bennett:south dakota",
  },
  {
    text: "Bennington, VT",
    value: "bennington:vermont",
  },
  {
    text: "Benson, ND",
    value: "benson:north dakota",
  },
  {
    text: "Bent, CO",
    value: "bent:colorado",
  },
  {
    text: "Benton, AR",
    value: "benton:arkansas",
  },
  {
    text: "Benton, IN",
    value: "benton:indiana",
  },
  {
    text: "Benton, MO",
    value: "benton:missouri",
  },
  {
    text: "Benton, MS",
    value: "benton:mississippi",
  },
  {
    text: "Benton, TN",
    value: "benton:tennessee",
  },
  {
    text: "Benton, IA",
    value: "benton:iowa",
  },
  {
    text: "Benton, MN",
    value: "benton:minnesota",
  },
  {
    text: "Benton, OR",
    value: "benton:oregon",
  },
  {
    text: "Benton, WA",
    value: "benton:washington",
  },
  {
    text: "Benzie, MI",
    value: "benzie:michigan",
  },
  {
    text: "Bergen, NJ",
    value: "bergen:new jersey",
  },
  {
    text: "Berkeley, WV",
    value: "berkeley:west virginia",
  },
  {
    text: "Berkeley, SC",
    value: "berkeley:south carolina",
  },
  {
    text: "Berks, PA",
    value: "berks:pennsylvania",
  },
  {
    text: "Berkshire, MA",
    value: "berkshire:massachusetts",
  },
  {
    text: "Bernalillo, NM",
    value: "bernalillo:new mexico",
  },
  {
    text: "Berrien, GA",
    value: "berrien:georgia",
  },
  {
    text: "Berrien, MI",
    value: "berrien:michigan",
  },
  {
    text: "Bertie, NC",
    value: "bertie:north carolina",
  },
  {
    text: "Bethel, AK",
    value: "bethel:alaska",
  },
  {
    text: "Bexar, TX",
    value: "bexar:texas",
  },
  {
    text: "Bexar, TX",
    value: "bexar county:texas",
  },
  {
    text: "Bibb, AL",
    value: "bibb:alabama",
  },
  {
    text: "Bibb, GA",
    value: "bibb:georgia",
  },
  {
    text: "Bienville, LA",
    value: "bienville:louisiana",
  },
  {
    text: "Big Horn, MT",
    value: "big horn:montana",
  },
  {
    text: "Big Horn, WY",
    value: "big horn:wyoming",
  },
  {
    text: "Big Stone, MN",
    value: "big stone:minnesota",
  },
  {
    text: "Billings, ND",
    value: "billings:north dakota",
  },
  {
    text: "Bingham, ID",
    value: "bingham:idaho",
  },
  {
    text: "Black Hawk, IA",
    value: "black hawk:iowa",
  },
  {
    text: "Blackford, IN",
    value: "blackford:indiana",
  },
  {
    text: "Bladen, NC",
    value: "bladen:north carolina",
  },
  {
    text: "Blaine, OK",
    value: "blaine:oklahoma",
  },
  {
    text: "Blaine, NE",
    value: "blaine:nebraska",
  },
  {
    text: "Blaine, ID",
    value: "blaine:idaho",
  },
  {
    text: "Blaine, MT",
    value: "blaine:montana",
  },
  {
    text: "Blair, PA",
    value: "blair:pennsylvania",
  },
  {
    text: "Blanco, TX",
    value: "blanco:texas",
  },
  {
    text: "Bland, VA",
    value: "bland:virginia",
  },
  {
    text: "Bleckley, GA",
    value: "bleckley:georgia",
  },
  {
    text: "Bledsoe, TN",
    value: "bledsoe:tennessee",
  },
  {
    text: "Blount, AL",
    value: "blount:alabama",
  },
  {
    text: "Blount, TN",
    value: "blount:tennessee",
  },
  {
    text: "Blue Earth, MN",
    value: "blue earth:minnesota",
  },
  {
    text: "Boise, ID",
    value: "boise:idaho",
  },
  {
    text: "Bolivar, MS",
    value: "bolivar:mississippi",
  },
  {
    text: "Bollinger, MO",
    value: "bollinger:missouri",
  },
  {
    text: "Bon Homme, SD",
    value: "bon homme:south dakota",
  },
  {
    text: "Bond, IL",
    value: "bond:illinois",
  },
  {
    text: "Bonner, ID",
    value: "bonner:idaho",
  },
  {
    text: "Bonneville, ID",
    value: "bonneville:idaho",
  },
  {
    text: "Boone, WV",
    value: "boone:west virginia",
  },
  {
    text: "Boone, AR",
    value: "boone:arkansas",
  },
  {
    text: "Boone, IL",
    value: "boone:illinois",
  },
  {
    text: "Boone, IN",
    value: "boone:indiana",
  },
  {
    text: "Boone, KY",
    value: "boone:kentucky",
  },
  {
    text: "Boone, MO",
    value: "boone:missouri",
  },
  {
    text: "Boone, IA",
    value: "boone:iowa",
  },
  {
    text: "Boone, NE",
    value: "boone:nebraska",
  },
  {
    text: "Borden, TX",
    value: "borden:texas",
  },
  {
    text: "Bosque, TX",
    value: "bosque:texas",
  },
  {
    text: "Bossier, LA",
    value: "bossier:louisiana",
  },
  {
    text: "Botetourt, VA",
    value: "botetourt:virginia",
  },
  {
    text: "Bottineau, ND",
    value: "bottineau:north dakota",
  },
  {
    text: "Boulder, CO",
    value: "boulder:colorado",
  },
  {
    text: "Boundary, ID",
    value: "boundary:idaho",
  },
  {
    text: "Bourbon, KS",
    value: "bourbon:kansas",
  },
  {
    text: "Bourbon, KY",
    value: "bourbon:kentucky",
  },
  {
    text: "Bowie, TX",
    value: "bowie:texas",
  },
  {
    text: "Bowman, ND",
    value: "bowman:north dakota",
  },
  {
    text: "Box Butte, NE",
    value: "box butte:nebraska",
  },
  {
    text: "Box Elder, UT",
    value: "box elder:utah",
  },
  {
    text: "Boyd, KY",
    value: "boyd:kentucky",
  },
  {
    text: "Boyd, NE",
    value: "boyd:nebraska",
  },
  {
    text: "Boyle, KY",
    value: "boyle:kentucky",
  },
  {
    text: "Bracken, KY",
    value: "bracken:kentucky",
  },
  {
    text: "Bradford, FL",
    value: "bradford:florida",
  },
  {
    text: "Bradford, PA",
    value: "bradford:pennsylvania",
  },
  {
    text: "Bradley, AR",
    value: "bradley:arkansas",
  },
  {
    text: "Bradley, TN",
    value: "bradley:tennessee",
  },
  {
    text: "Branch, MI",
    value: "branch:michigan",
  },
  {
    text: "Brantley, GA",
    value: "brantley:georgia",
  },
  {
    text: "Braxton, WV",
    value: "braxton:west virginia",
  },
  {
    text: "Brazoria, TX",
    value: "brazoria:texas",
  },
  {
    text: "Brazos, TX",
    value: "brazos:texas",
  },
  {
    text: "Breathitt, KY",
    value: "breathitt:kentucky",
  },
  {
    text: "Breckinridge, KY",
    value: "breckinridge:kentucky",
  },
  {
    text: "Bremer, IA",
    value: "bremer:iowa",
  },
  {
    text: "Brevard, FL",
    value: "brevard:florida",
  },
  {
    text: "Brewster, TX",
    value: "brewster:texas",
  },
  {
    text: "Briscoe, TX",
    value: "briscoe:texas",
  },
  {
    text: "Bristol, VA",
    value: "bristol:virginia",
  },
  {
    text: "Bristol, MA",
    value: "bristol:massachusetts",
  },
  {
    text: "Bristol, RI",
    value: "bristol:rhode island",
  },
  {
    text: "Bristol Bay, AK",
    value: "bristol bay:alaska",
  },
  {
    text: "Bristol, VA",
    value: "bristol city:virginia",
  },
  {
    text: "Bristol, MA",
    value: "bristol city:massachusetts",
  },
  {
    text: "Bristol, RI",
    value: "bristol city:rhode island",
  },
  {
    text: "Broadwater, MT",
    value: "broadwater:montana",
  },
  {
    text: "Bronx, NY",
    value: "bronx:new york",
  },
  {
    text: "Brooke, WV",
    value: "brooke:west virginia",
  },
  {
    text: "Brookings, SD",
    value: "brookings:south dakota",
  },
  {
    text: "Brooklyn, NY",
    value: "brooklyn:new york",
  },
  {
    text: "Brooks, TX",
    value: "brooks:texas",
  },
  {
    text: "Brooks, GA",
    value: "brooks:georgia",
  },
  {
    text: "Broome, NY",
    value: "broome:new york",
  },
  {
    text: "Broomfield, CO",
    value: "broomfield:colorado",
  },
  {
    text: "Broward, FL",
    value: "broward:florida",
  },
  {
    text: "Brown, TX",
    value: "brown:texas",
  },
  {
    text: "Brown, IL",
    value: "brown:illinois",
  },
  {
    text: "Brown, IN",
    value: "brown:indiana",
  },
  {
    text: "Brown, KS",
    value: "brown:kansas",
  },
  {
    text: "Brown, OH",
    value: "brown:ohio",
  },
  {
    text: "Brown, MN",
    value: "brown:minnesota",
  },
  {
    text: "Brown, NE",
    value: "brown:nebraska",
  },
  {
    text: "Brown, SD",
    value: "brown:south dakota",
  },
  {
    text: "Brown, WI",
    value: "brown:wisconsin",
  },
  {
    text: "Brule, SD",
    value: "brule:south dakota",
  },
  {
    text: "Brunswick, VA",
    value: "brunswick:virginia",
  },
  {
    text: "Brunswick, NC",
    value: "brunswick:north carolina",
  },
  {
    text: "Bryan, GA",
    value: "bryan:georgia",
  },
  {
    text: "Bryan, OK",
    value: "bryan:oklahoma",
  },
  {
    text: "Buchanan, VA",
    value: "buchanan:virginia",
  },
  {
    text: "Buchanan, MO",
    value: "buchanan:missouri",
  },
  {
    text: "Buchanan, IA",
    value: "buchanan:iowa",
  },
  {
    text: "Buckingham, VA",
    value: "buckingham:virginia",
  },
  {
    text: "Bucks, PA",
    value: "bucks:pennsylvania",
  },
  {
    text: "Buena Vista, VA",
    value: "buena vista:virginia",
  },
  {
    text: "Buena Vista, IA",
    value: "buena vista:iowa",
  },
  {
    text: "Buena Vista, VA",
    value: "buena vista city:virginia",
  },
  {
    text: "Buena Vista, IA",
    value: "buena vista city:iowa",
  },
  {
    text: "Buffalo, NE",
    value: "buffalo:nebraska",
  },
  {
    text: "Buffalo, SD",
    value: "buffalo:south dakota",
  },
  {
    text: "Buffalo, WI",
    value: "buffalo:wisconsin",
  },
  {
    text: "Bullitt, KY",
    value: "bullitt:kentucky",
  },
  {
    text: "Bulloch, GA",
    value: "bulloch:georgia",
  },
  {
    text: "Bullock, AL",
    value: "bullock:alabama",
  },
  {
    text: "Buncombe, NC",
    value: "buncombe:north carolina",
  },
  {
    text: "Buncombe, NC",
    value: "buncombe county:north carolina",
  },
  {
    text: "Bureau, IL",
    value: "bureau:illinois",
  },
  {
    text: "Burke, NC",
    value: "burke:north carolina",
  },
  {
    text: "Burke, GA",
    value: "burke:georgia",
  },
  {
    text: "Burke, ND",
    value: "burke:north dakota",
  },
  {
    text: "Burleigh, ND",
    value: "burleigh:north dakota",
  },
  {
    text: "Burleson, TX",
    value: "burleson:texas",
  },
  {
    text: "Burlington, NJ",
    value: "burlington:new jersey",
  },
  {
    text: "Burnet, TX",
    value: "burnet:texas",
  },
  {
    text: "Burnett, WI",
    value: "burnett:wisconsin",
  },
  {
    text: "Burt, NE",
    value: "burt:nebraska",
  },
  {
    text: "Butler, AL",
    value: "butler:alabama",
  },
  {
    text: "Butler, KS",
    value: "butler:kansas",
  },
  {
    text: "Butler, KY",
    value: "butler:kentucky",
  },
  {
    text: "Butler, MO",
    value: "butler:missouri",
  },
  {
    text: "Butler, OH",
    value: "butler:ohio",
  },
  {
    text: "Butler, PA",
    value: "butler:pennsylvania",
  },
  {
    text: "Butler, IA",
    value: "butler:iowa",
  },
  {
    text: "Butler, NE",
    value: "butler:nebraska",
  },
  {
    text: "Butte, SD",
    value: "butte:south dakota",
  },
  {
    text: "Butte, CA",
    value: "butte:california",
  },
  {
    text: "Butte, ID",
    value: "butte:idaho",
  },
  {
    text: "Butts, GA",
    value: "butts:georgia",
  },
  {
    text: "Cabarrus, NC",
    value: "cabarrus:north carolina",
  },
  {
    text: "Cabell, WV",
    value: "cabell:west virginia",
  },
  {
    text: "Cache, UT",
    value: "cache:utah",
  },
  {
    text: "Caddo, LA",
    value: "caddo:louisiana",
  },
  {
    text: "Caddo, OK",
    value: "caddo:oklahoma",
  },
  {
    text: "Calaveras, CA",
    value: "calaveras:california",
  },
  {
    text: "Calcasieu, LA",
    value: "calcasieu:louisiana",
  },
  {
    text: "Calcasieu, LA",
    value: "calcasieu parish:louisiana",
  },
  {
    text: "Caldwell, TX",
    value: "caldwell:texas",
  },
  {
    text: "Caldwell, KY",
    value: "caldwell:kentucky",
  },
  {
    text: "Caldwell, LA",
    value: "caldwell:louisiana",
  },
  {
    text: "Caldwell, MO",
    value: "caldwell:missouri",
  },
  {
    text: "Caldwell, NC",
    value: "caldwell:north carolina",
  },
  {
    text: "Caledonia, VT",
    value: "caledonia:vermont",
  },
  {
    text: "Calhoun, TX",
    value: "calhoun:texas",
  },
  {
    text: "Calhoun, AL",
    value: "calhoun:alabama",
  },
  {
    text: "Calhoun, WV",
    value: "calhoun:west virginia",
  },
  {
    text: "Calhoun, AR",
    value: "calhoun:arkansas",
  },
  {
    text: "Calhoun, FL",
    value: "calhoun:florida",
  },
  {
    text: "Calhoun, IL",
    value: "calhoun:illinois",
  },
  {
    text: "Calhoun, MS",
    value: "calhoun:mississippi",
  },
  {
    text: "Calhoun, GA",
    value: "calhoun:georgia",
  },
  {
    text: "Calhoun, SC",
    value: "calhoun:south carolina",
  },
  {
    text: "Calhoun, IA",
    value: "calhoun:iowa",
  },
  {
    text: "Calhoun, MI",
    value: "calhoun:michigan",
  },
  {
    text: "Callahan, TX",
    value: "callahan:texas",
  },
  {
    text: "Callaway, MO",
    value: "callaway:missouri",
  },
  {
    text: "Calloway, KY",
    value: "calloway:kentucky",
  },
  {
    text: "Calumet, WI",
    value: "calumet:wisconsin",
  },
  {
    text: "Calvert, MD",
    value: "calvert:maryland",
  },
  {
    text: "Camas, ID",
    value: "camas:idaho",
  },
  {
    text: "Cambria, PA",
    value: "cambria:pennsylvania",
  },
  {
    text: "Camden, MO",
    value: "camden:missouri",
  },
  {
    text: "Camden, NC",
    value: "camden:north carolina",
  },
  {
    text: "Camden, GA",
    value: "camden:georgia",
  },
  {
    text: "Camden, NJ",
    value: "camden:new jersey",
  },
  {
    text: "Cameron, TX",
    value: "cameron:texas",
  },
  {
    text: "Cameron, LA",
    value: "cameron:louisiana",
  },
  {
    text: "Cameron, PA",
    value: "cameron:pennsylvania",
  },
  {
    text: "Cameron, TX",
    value: "cameron parish:texas",
  },
  {
    text: "Cameron, LA",
    value: "cameron parish:louisiana",
  },
  {
    text: "Cameron, PA",
    value: "cameron parish:pennsylvania",
  },
  {
    text: "Camp, TX",
    value: "camp:texas",
  },
  {
    text: "Campbell, VA",
    value: "campbell:virginia",
  },
  {
    text: "Campbell, KY",
    value: "campbell:kentucky",
  },
  {
    text: "Campbell, TN",
    value: "campbell:tennessee",
  },
  {
    text: "Campbell, SD",
    value: "campbell:south dakota",
  },
  {
    text: "Campbell, WY",
    value: "campbell:wyoming",
  },
  {
    text: "Canadian, OK",
    value: "canadian:oklahoma",
  },
  {
    text: "Candler, GA",
    value: "candler:georgia",
  },
  {
    text: "Cannon, TN",
    value: "cannon:tennessee",
  },
  {
    text: "Canyon, ID",
    value: "canyon:idaho",
  },
  {
    text: "Cape Girardeau, MO",
    value: "cape girardeau:missouri",
  },
  {
    text: "Cape May, NJ",
    value: "cape may:new jersey",
  },
  {
    text: "Carbon, PA",
    value: "carbon:pennsylvania",
  },
  {
    text: "Carbon, UT",
    value: "carbon:utah",
  },
  {
    text: "Carbon, MT",
    value: "carbon:montana",
  },
  {
    text: "Carbon, WY",
    value: "carbon:wyoming",
  },
  {
    text: "Caribou, ID",
    value: "caribou:idaho",
  },
  {
    text: "Carlisle, KY",
    value: "carlisle:kentucky",
  },
  {
    text: "Carlton, MN",
    value: "carlton:minnesota",
  },
  {
    text: "Caroline, VA",
    value: "caroline:virginia",
  },
  {
    text: "Caroline, MD",
    value: "caroline:maryland",
  },
  {
    text: "Carroll, VA",
    value: "carroll:virginia",
  },
  {
    text: "Carroll, AR",
    value: "carroll:arkansas",
  },
  {
    text: "Carroll, IL",
    value: "carroll:illinois",
  },
  {
    text: "Carroll, IN",
    value: "carroll:indiana",
  },
  {
    text: "Carroll, KY",
    value: "carroll:kentucky",
  },
  {
    text: "Carroll, MD",
    value: "carroll:maryland",
  },
  {
    text: "Carroll, MO",
    value: "carroll:missouri",
  },
  {
    text: "Carroll, MS",
    value: "carroll:mississippi",
  },
  {
    text: "Carroll, TN",
    value: "carroll:tennessee",
  },
  {
    text: "Carroll, GA",
    value: "carroll:georgia",
  },
  {
    text: "Carroll, OH",
    value: "carroll:ohio",
  },
  {
    text: "Carroll, IA",
    value: "carroll:iowa",
  },
  {
    text: "Carroll, NH",
    value: "carroll:new hampshire",
  },
  {
    text: "Carson, TX",
    value: "carson:texas",
  },
  {
    text: "Carson, NV",
    value: "carson:nevada",
  },
  {
    text: "Carson, TX",
    value: "carson city:texas",
  },
  {
    text: "Carson, NV",
    value: "carson city:nevada",
  },
  {
    text: "Carter, KY",
    value: "carter:kentucky",
  },
  {
    text: "Carter, MO",
    value: "carter:missouri",
  },
  {
    text: "Carter, TN",
    value: "carter:tennessee",
  },
  {
    text: "Carter, OK",
    value: "carter:oklahoma",
  },
  {
    text: "Carter, MT",
    value: "carter:montana",
  },
  {
    text: "Carteret, NC",
    value: "carteret:north carolina",
  },
  {
    text: "Carver, MN",
    value: "carver:minnesota",
  },
  {
    text: "Cascade, MT",
    value: "cascade:montana",
  },
  {
    text: "Casey, KY",
    value: "casey:kentucky",
  },
  {
    text: "Cass, TX",
    value: "cass:texas",
  },
  {
    text: "Cass, IL",
    value: "cass:illinois",
  },
  {
    text: "Cass, IN",
    value: "cass:indiana",
  },
  {
    text: "Cass, MO",
    value: "cass:missouri",
  },
  {
    text: "Cass, IA",
    value: "cass:iowa",
  },
  {
    text: "Cass, MN",
    value: "cass:minnesota",
  },
  {
    text: "Cass, NE",
    value: "cass:nebraska",
  },
  {
    text: "Cass, MI",
    value: "cass:michigan",
  },
  {
    text: "Cass, ND",
    value: "cass:north dakota",
  },
  {
    text: "Cass, TX",
    value: "cass county:texas",
  },
  {
    text: "Cass, IL",
    value: "cass county:illinois",
  },
  {
    text: "Cass, IN",
    value: "cass county:indiana",
  },
  {
    text: "Cass, MO",
    value: "cass county:missouri",
  },
  {
    text: "Cass, IA",
    value: "cass county:iowa",
  },
  {
    text: "Cass, MN",
    value: "cass county:minnesota",
  },
  {
    text: "Cass, NE",
    value: "cass county:nebraska",
  },
  {
    text: "Cass, MI",
    value: "cass county:michigan",
  },
  {
    text: "Cass, ND",
    value: "cass county:north dakota",
  },
  {
    text: "Cassia, ID",
    value: "cassia:idaho",
  },
  {
    text: "Castro, TX",
    value: "castro:texas",
  },
  {
    text: "Caswell, NC",
    value: "caswell:north carolina",
  },
  {
    text: "Catahoula, LA",
    value: "catahoula:louisiana",
  },
  {
    text: "Catawba, NC",
    value: "catawba:north carolina",
  },
  {
    text: "Catoosa, GA",
    value: "catoosa:georgia",
  },
  {
    text: "Catron, NM",
    value: "catron:new mexico",
  },
  {
    text: "Cattaraugus, NY",
    value: "cattaraugus:new york",
  },
  {
    text: "Cavalier, ND",
    value: "cavalier:north dakota",
  },
  {
    text: "Cayuga, NY",
    value: "cayuga:new york",
  },
  {
    text: "Cecil, MD",
    value: "cecil:maryland",
  },
  {
    text: "Cedar, MO",
    value: "cedar:missouri",
  },
  {
    text: "Cedar, IA",
    value: "cedar:iowa",
  },
  {
    text: "Cedar, NE",
    value: "cedar:nebraska",
  },
  {
    text: "Centre, PA",
    value: "centre:pennsylvania",
  },
  {
    text: "Cerro Gordo, IA",
    value: "cerro gordo:iowa",
  },
  {
    text: "Chaffee, CO",
    value: "chaffee:colorado",
  },
  {
    text: "Chambers, TX",
    value: "chambers:texas",
  },
  {
    text: "Chambers, AL",
    value: "chambers:alabama",
  },
  {
    text: "Champaign, IL",
    value: "champaign:illinois",
  },
  {
    text: "Champaign, OH",
    value: "champaign:ohio",
  },
  {
    text: "Chariton, MO",
    value: "chariton:missouri",
  },
  {
    text: "Charles, VA",
    value: "charles:virginia",
  },
  {
    text: "Charles, MD",
    value: "charles:maryland",
  },
  {
    text: "Charles, VA",
    value: "charles city:virginia",
  },
  {
    text: "Charles, MD",
    value: "charles city:maryland",
  },
  {
    text: "Charles Mix, SD",
    value: "charles mix:south dakota",
  },
  {
    text: "Charleston, SC",
    value: "charleston:south carolina",
  },
  {
    text: "Charlevoix, MI",
    value: "charlevoix:michigan",
  },
  {
    text: "Charlotte, VA",
    value: "charlotte:virginia",
  },
  {
    text: "Charlotte, FL",
    value: "charlotte:florida",
  },
  {
    text: "Charlottesville, VA",
    value: "charlottesville city:virginia",
  },
  {
    text: "Charlton, GA",
    value: "charlton:georgia",
  },
  {
    text: "Chase, KS",
    value: "chase:kansas",
  },
  {
    text: "Chase, NE",
    value: "chase:nebraska",
  },
  {
    text: "Chatham, NC",
    value: "chatham:north carolina",
  },
  {
    text: "Chatham, GA",
    value: "chatham:georgia",
  },
  {
    text: "Chattahoochee, GA",
    value: "chattahoochee:georgia",
  },
  {
    text: "Chattooga, GA",
    value: "chattooga:georgia",
  },
  {
    text: "Chautauqua, KS",
    value: "chautauqua:kansas",
  },
  {
    text: "Chautauqua, NY",
    value: "chautauqua:new york",
  },
  {
    text: "Chaves, NM",
    value: "chaves:new mexico",
  },
  {
    text: "Cheatham, TN",
    value: "cheatham:tennessee",
  },
  {
    text: "Cheboygan, MI",
    value: "cheboygan:michigan",
  },
  {
    text: "Chelan, WA",
    value: "chelan:washington",
  },
  {
    text: "Chemung, NY",
    value: "chemung:new york",
  },
  {
    text: "Chenango, NY",
    value: "chenango:new york",
  },
  {
    text: "Cherokee, TX",
    value: "cherokee:texas",
  },
  {
    text: "Cherokee, AL",
    value: "cherokee:alabama",
  },
  {
    text: "Cherokee, KS",
    value: "cherokee:kansas",
  },
  {
    text: "Cherokee, NC",
    value: "cherokee:north carolina",
  },
  {
    text: "Cherokee, GA",
    value: "cherokee:georgia",
  },
  {
    text: "Cherokee, OK",
    value: "cherokee:oklahoma",
  },
  {
    text: "Cherokee, SC",
    value: "cherokee:south carolina",
  },
  {
    text: "Cherokee, IA",
    value: "cherokee:iowa",
  },
  {
    text: "Cherry, NE",
    value: "cherry:nebraska",
  },
  {
    text: "Chesapeake, VA",
    value: "chesapeake city:virginia",
  },
  {
    text: "Cheshire, NH",
    value: "cheshire:new hampshire",
  },
  {
    text: "Chester, TN",
    value: "chester:tennessee",
  },
  {
    text: "Chester, PA",
    value: "chester:pennsylvania",
  },
  {
    text: "Chester, SC",
    value: "chester:south carolina",
  },
  {
    text: "Chesterfield, VA",
    value: "chesterfield:virginia",
  },
  {
    text: "Chesterfield, SC",
    value: "chesterfield:south carolina",
  },
  {
    text: "Cheyenne, KS",
    value: "cheyenne:kansas",
  },
  {
    text: "Cheyenne, NE",
    value: "cheyenne:nebraska",
  },
  {
    text: "Cheyenne, CO",
    value: "cheyenne:colorado",
  },
  {
    text: "Chickasaw, MS",
    value: "chickasaw:mississippi",
  },
  {
    text: "Chickasaw, IA",
    value: "chickasaw:iowa",
  },
  {
    text: "Chicot, AR",
    value: "chicot:arkansas",
  },
  {
    text: "Childress, TX",
    value: "childress:texas",
  },
  {
    text: "Chilton, AL",
    value: "chilton:alabama",
  },
  {
    text: "Chippewa, MN",
    value: "chippewa:minnesota",
  },
  {
    text: "Chippewa, WI",
    value: "chippewa:wisconsin",
  },
  {
    text: "Chippewa, MI",
    value: "chippewa:michigan",
  },
  {
    text: "Chisago, MN",
    value: "chisago:minnesota",
  },
  {
    text: "Chittenden, VT",
    value: "chittenden:vermont",
  },
  {
    text: "Choctaw, AL",
    value: "choctaw:alabama",
  },
  {
    text: "Choctaw, MS",
    value: "choctaw:mississippi",
  },
  {
    text: "Choctaw, OK",
    value: "choctaw:oklahoma",
  },
  {
    text: "Chouteau, MT",
    value: "chouteau:montana",
  },
  {
    text: "Chowan, NC",
    value: "chowan:north carolina",
  },
  {
    text: "Christian, IL",
    value: "christian:illinois",
  },
  {
    text: "Christian, KY",
    value: "christian:kentucky",
  },
  {
    text: "Christian, MO",
    value: "christian:missouri",
  },
  {
    text: "Chugach, AK",
    value: "chugach:alaska",
  },
  {
    text: "Churchill, NV",
    value: "churchill:nevada",
  },
  {
    text: "Cibola, NM",
    value: "cibola:new mexico",
  },
  {
    text: "Cimarron, OK",
    value: "cimarron:oklahoma",
  },
  {
    text: "Citrus, FL",
    value: "citrus:florida",
  },
  {
    text: "Clackamas, OR",
    value: "clackamas:oregon",
  },
  {
    text: "Claiborne, LA",
    value: "claiborne:louisiana",
  },
  {
    text: "Claiborne, MS",
    value: "claiborne:mississippi",
  },
  {
    text: "Claiborne, TN",
    value: "claiborne:tennessee",
  },
  {
    text: "Claiborne, LA",
    value: "claiborne parish:louisiana",
  },
  {
    text: "Claiborne, MS",
    value: "claiborne parish:mississippi",
  },
  {
    text: "Claiborne, TN",
    value: "claiborne parish:tennessee",
  },
  {
    text: "Clallam, WA",
    value: "clallam:washington",
  },
  {
    text: "Clare, MI",
    value: "clare:michigan",
  },
  {
    text: "Clarendon, SC",
    value: "clarendon:south carolina",
  },
  {
    text: "Clarion, PA",
    value: "clarion:pennsylvania",
  },
  {
    text: "Clark, AR",
    value: "clark:arkansas",
  },
  {
    text: "Clark, IL",
    value: "clark:illinois",
  },
  {
    text: "Clark, IN",
    value: "clark:indiana",
  },
  {
    text: "Clark, KS",
    value: "clark:kansas",
  },
  {
    text: "Clark, KY",
    value: "clark:kentucky",
  },
  {
    text: "Clark, MO",
    value: "clark:missouri",
  },
  {
    text: "Clark, OH",
    value: "clark:ohio",
  },
  {
    text: "Clark, SD",
    value: "clark:south dakota",
  },
  {
    text: "Clark, WI",
    value: "clark:wisconsin",
  },
  {
    text: "Clark, NV",
    value: "clark:nevada",
  },
  {
    text: "Clark, WA",
    value: "clark:washington",
  },
  {
    text: "Clark, ID",
    value: "clark:idaho",
  },
  {
    text: "Clarke, AL",
    value: "clarke:alabama",
  },
  {
    text: "Clarke, VA",
    value: "clarke:virginia",
  },
  {
    text: "Clarke, MS",
    value: "clarke:mississippi",
  },
  {
    text: "Clarke, GA",
    value: "clarke:georgia",
  },
  {
    text: "Clarke, IA",
    value: "clarke:iowa",
  },
  {
    text: "Clatsop, OR",
    value: "clatsop:oregon",
  },
  {
    text: "Clay, TX",
    value: "clay:texas",
  },
  {
    text: "Clay, AL",
    value: "clay:alabama",
  },
  {
    text: "Clay, WV",
    value: "clay:west virginia",
  },
  {
    text: "Clay, AR",
    value: "clay:arkansas",
  },
  {
    text: "Clay, FL",
    value: "clay:florida",
  },
  {
    text: "Clay, IL",
    value: "clay:illinois",
  },
  {
    text: "Clay, IN",
    value: "clay:indiana",
  },
  {
    text: "Clay, KS",
    value: "clay:kansas",
  },
  {
    text: "Clay, KY",
    value: "clay:kentucky",
  },
  {
    text: "Clay, MO",
    value: "clay:missouri",
  },
  {
    text: "Clay, MS",
    value: "clay:mississippi",
  },
  {
    text: "Clay, NC",
    value: "clay:north carolina",
  },
  {
    text: "Clay, TN",
    value: "clay:tennessee",
  },
  {
    text: "Clay, GA",
    value: "clay:georgia",
  },
  {
    text: "Clay, IA",
    value: "clay:iowa",
  },
  {
    text: "Clay, MN",
    value: "clay:minnesota",
  },
  {
    text: "Clay, NE",
    value: "clay:nebraska",
  },
  {
    text: "Clay, SD",
    value: "clay:south dakota",
  },
  {
    text: "Clayton, GA",
    value: "clayton:georgia",
  },
  {
    text: "Clayton, IA",
    value: "clayton:iowa",
  },
  {
    text: "Clayton, GA",
    value: "clayton, henry, and dekalb:georgia",
  },
  {
    text: "Clear Creek, CO",
    value: "clear creek:colorado",
  },
  {
    text: "Clearfield, PA",
    value: "clearfield:pennsylvania",
  },
  {
    text: "Clearwater, MN",
    value: "clearwater:minnesota",
  },
  {
    text: "Clearwater, ID",
    value: "clearwater:idaho",
  },
  {
    text: "Cleburne, AL",
    value: "cleburne:alabama",
  },
  {
    text: "Cleburne, AR",
    value: "cleburne:arkansas",
  },
  {
    text: "Clermont, OH",
    value: "clermont:ohio",
  },
  {
    text: "Cleveland, AR",
    value: "cleveland:arkansas",
  },
  {
    text: "Cleveland, NC",
    value: "cleveland:north carolina",
  },
  {
    text: "Cleveland, OK",
    value: "cleveland:oklahoma",
  },
  {
    text: "Clinch, GA",
    value: "clinch:georgia",
  },
  {
    text: "Clinton, IL",
    value: "clinton:illinois",
  },
  {
    text: "Clinton, IN",
    value: "clinton:indiana",
  },
  {
    text: "Clinton, KY",
    value: "clinton:kentucky",
  },
  {
    text: "Clinton, MO",
    value: "clinton:missouri",
  },
  {
    text: "Clinton, OH",
    value: "clinton:ohio",
  },
  {
    text: "Clinton, PA",
    value: "clinton:pennsylvania",
  },
  {
    text: "Clinton, IA",
    value: "clinton:iowa",
  },
  {
    text: "Clinton, NY",
    value: "clinton:new york",
  },
  {
    text: "Clinton, MI",
    value: "clinton:michigan",
  },
  {
    text: "Cloud, KS",
    value: "cloud:kansas",
  },
  {
    text: "Coahoma, MS",
    value: "coahoma:mississippi",
  },
  {
    text: "Coal, OK",
    value: "coal:oklahoma",
  },
  {
    text: "Cobb, GA",
    value: "cobb:georgia",
  },
  {
    text: "Cochise, AZ",
    value: "cochise:arizona",
  },
  {
    text: "Cochran, TX",
    value: "cochran:texas",
  },
  {
    text: "Cocke, TN",
    value: "cocke:tennessee",
  },
  {
    text: "Coconino, AZ",
    value: "coconino:arizona",
  },
  {
    text: "Codington, SD",
    value: "codington:south dakota",
  },
  {
    text: "Coffee, AL",
    value: "coffee:alabama",
  },
  {
    text: "Coffee, TN",
    value: "coffee:tennessee",
  },
  {
    text: "Coffee, GA",
    value: "coffee:georgia",
  },
  {
    text: "Coffey, KS",
    value: "coffey:kansas",
  },
  {
    text: "Coke, TX",
    value: "coke:texas",
  },
  {
    text: "Colbert, AL",
    value: "colbert:alabama",
  },
  {
    text: "Cole, MO",
    value: "cole:missouri",
  },
  {
    text: "Coleman, TX",
    value: "coleman:texas",
  },
  {
    text: "Coles, IL",
    value: "coles:illinois",
  },
  {
    text: "Colfax, NE",
    value: "colfax:nebraska",
  },
  {
    text: "Colfax, NM",
    value: "colfax:new mexico",
  },
  {
    text: "Colleton, SC",
    value: "colleton:south carolina",
  },
  {
    text: "Collier, FL",
    value: "collier:florida",
  },
  {
    text: "Collin, TX",
    value: "collin:texas",
  },
  {
    text: "Collingsworth, TX",
    value: "collingsworth:texas",
  },
  {
    text: "Colonial Heights, VA",
    value: "colonial heights city:virginia",
  },
  {
    text: "Colorado, TX",
    value: "colorado:texas",
  },
  {
    text: "Colquitt, GA",
    value: "colquitt:georgia",
  },
  {
    text: "Columbia, AR",
    value: "columbia:arkansas",
  },
  {
    text: "Columbia, FL",
    value: "columbia:florida",
  },
  {
    text: "Columbia, GA",
    value: "columbia:georgia",
  },
  {
    text: "Columbia, PA",
    value: "columbia:pennsylvania",
  },
  {
    text: "Columbia, NY",
    value: "columbia:new york",
  },
  {
    text: "Columbia, WI",
    value: "columbia:wisconsin",
  },
  {
    text: "Columbia, OR",
    value: "columbia:oregon",
  },
  {
    text: "Columbia, WA",
    value: "columbia:washington",
  },
  {
    text: "Columbiana, OH",
    value: "columbiana:ohio",
  },
  {
    text: "Columbus, NC",
    value: "columbus:north carolina",
  },
  {
    text: "Colusa, CA",
    value: "colusa:california",
  },
  {
    text: "Comal, TX",
    value: "comal:texas",
  },
  {
    text: "Comanche, TX",
    value: "comanche:texas",
  },
  {
    text: "Comanche, KS",
    value: "comanche:kansas",
  },
  {
    text: "Comanche, OK",
    value: "comanche:oklahoma",
  },
  {
    text: "Concho, TX",
    value: "concho:texas",
  },
  {
    text: "Concordia, LA",
    value: "concordia:louisiana",
  },
  {
    text: "Conecuh, AL",
    value: "conecuh:alabama",
  },
  {
    text: "Conejos, CO",
    value: "conejos:colorado",
  },
  {
    text: "Contra Costa, CA",
    value: "contra costa:california",
  },
  {
    text: "Converse, WY",
    value: "converse:wyoming",
  },
  {
    text: "Conway, AR",
    value: "conway:arkansas",
  },
  {
    text: "Cook, IL",
    value: "cook:illinois",
  },
  {
    text: "Cook, GA",
    value: "cook:georgia",
  },
  {
    text: "Cook, MN",
    value: "cook:minnesota",
  },
  {
    text: "Cooke, TX",
    value: "cooke:texas",
  },
  {
    text: "Cooper, MO",
    value: "cooper:missouri",
  },
  {
    text: "Coos, NH",
    value: "coos:new hampshire",
  },
  {
    text: "Coos, OR",
    value: "coos:oregon",
  },
  {
    text: "Coosa, AL",
    value: "coosa:alabama",
  },
  {
    text: "Copiah, MS",
    value: "copiah:mississippi",
  },
  {
    text: "Copper River, AK",
    value: "copper river:alaska",
  },
  {
    text: "Corson, SD",
    value: "corson:south dakota",
  },
  {
    text: "Cortland, NY",
    value: "cortland:new york",
  },
  {
    text: "Coryell, TX",
    value: "coryell:texas",
  },
  {
    text: "Coshocton, OH",
    value: "coshocton:ohio",
  },
  {
    text: "Costilla, CO",
    value: "costilla:colorado",
  },
  {
    text: "Cottle, TX",
    value: "cottle:texas",
  },
  {
    text: "Cotton, OK",
    value: "cotton:oklahoma",
  },
  {
    text: "Cottonwood, MN",
    value: "cottonwood:minnesota",
  },
  {
    text: "Covington, AL",
    value: "covington:alabama",
  },
  {
    text: "Covington, VA",
    value: "covington:virginia",
  },
  {
    text: "Covington, MS",
    value: "covington:mississippi",
  },
  {
    text: "Covington, AL",
    value: "covington city:alabama",
  },
  {
    text: "Covington, VA",
    value: "covington city:virginia",
  },
  {
    text: "Covington, MS",
    value: "covington city:mississippi",
  },
  {
    text: "Coweta, GA",
    value: "coweta:georgia",
  },
  {
    text: "Cowley, KS",
    value: "cowley:kansas",
  },
  {
    text: "Cowlitz, WA",
    value: "cowlitz:washington",
  },
  {
    text: "Craig, VA",
    value: "craig:virginia",
  },
  {
    text: "Craig, OK",
    value: "craig:oklahoma",
  },
  {
    text: "Craighead, AR",
    value: "craighead:arkansas",
  },
  {
    text: "Crane, TX",
    value: "crane:texas",
  },
  {
    text: "Craven, NC",
    value: "craven:north carolina",
  },
  {
    text: "Crawford, AR",
    value: "crawford:arkansas",
  },
  {
    text: "Crawford, IL",
    value: "crawford:illinois",
  },
  {
    text: "Crawford, IN",
    value: "crawford:indiana",
  },
  {
    text: "Crawford, KS",
    value: "crawford:kansas",
  },
  {
    text: "Crawford, MO",
    value: "crawford:missouri",
  },
  {
    text: "Crawford, GA",
    value: "crawford:georgia",
  },
  {
    text: "Crawford, OH",
    value: "crawford:ohio",
  },
  {
    text: "Crawford, PA",
    value: "crawford:pennsylvania",
  },
  {
    text: "Crawford, IA",
    value: "crawford:iowa",
  },
  {
    text: "Crawford, WI",
    value: "crawford:wisconsin",
  },
  {
    text: "Crawford, MI",
    value: "crawford:michigan",
  },
  {
    text: "Creek, OK",
    value: "creek:oklahoma",
  },
  {
    text: "Crenshaw, AL",
    value: "crenshaw:alabama",
  },
  {
    text: "Crisp, GA",
    value: "crisp:georgia",
  },
  {
    text: "Crittenden, AR",
    value: "crittenden:arkansas",
  },
  {
    text: "Crittenden, KY",
    value: "crittenden:kentucky",
  },
  {
    text: "Crockett, TX",
    value: "crockett:texas",
  },
  {
    text: "Crockett, TN",
    value: "crockett:tennessee",
  },
  {
    text: "Crook, OR",
    value: "crook:oregon",
  },
  {
    text: "Crook, WY",
    value: "crook:wyoming",
  },
  {
    text: "Crosby, TX",
    value: "crosby:texas",
  },
  {
    text: "Cross, AR",
    value: "cross:arkansas",
  },
  {
    text: "Crow Wing, MN",
    value: "crow wing:minnesota",
  },
  {
    text: "Crowley, CO",
    value: "crowley:colorado",
  },
  {
    text: "Culberson, TX",
    value: "culberson:texas",
  },
  {
    text: "Cullman, AL",
    value: "cullman:alabama",
  },
  {
    text: "Culpeper, VA",
    value: "culpeper:virginia",
  },
  {
    text: "Cumberland, VA",
    value: "cumberland:virginia",
  },
  {
    text: "Cumberland, IL",
    value: "cumberland:illinois",
  },
  {
    text: "Cumberland, KY",
    value: "cumberland:kentucky",
  },
  {
    text: "Cumberland, NC",
    value: "cumberland:north carolina",
  },
  {
    text: "Cumberland, TN",
    value: "cumberland:tennessee",
  },
  {
    text: "Cumberland, NJ",
    value: "cumberland:new jersey",
  },
  {
    text: "Cumberland, PA",
    value: "cumberland:pennsylvania",
  },
  {
    text: "Cumberland, ME",
    value: "cumberland:maine",
  },
  {
    text: "Cuming, NE",
    value: "cuming:nebraska",
  },
  {
    text: "Currituck, NC",
    value: "currituck:north carolina",
  },
  {
    text: "Curry, NM",
    value: "curry:new mexico",
  },
  {
    text: "Curry, OR",
    value: "curry:oregon",
  },
  {
    text: "Custer, OK",
    value: "custer:oklahoma",
  },
  {
    text: "Custer, NE",
    value: "custer:nebraska",
  },
  {
    text: "Custer, SD",
    value: "custer:south dakota",
  },
  {
    text: "Custer, CO",
    value: "custer:colorado",
  },
  {
    text: "Custer, ID",
    value: "custer:idaho",
  },
  {
    text: "Custer, MT",
    value: "custer:montana",
  },
  {
    text: "Cuyahoga, OH",
    value: "cuyahoga:ohio",
  },
  {
    text: "Dade, MO",
    value: "dade:missouri",
  },
  {
    text: "Dade, GA",
    value: "dade:georgia",
  },
  {
    text: "Daggett, UT",
    value: "daggett:utah",
  },
  {
    text: "Dakota, MN",
    value: "dakota:minnesota",
  },
  {
    text: "Dakota, NE",
    value: "dakota:nebraska",
  },
  {
    text: "Dale, AL",
    value: "dale:alabama",
  },
  {
    text: "Dallam, TX",
    value: "dallam:texas",
  },
  {
    text: "Dallas, TX",
    value: "dallas:texas",
  },
  {
    text: "Dallas, AL",
    value: "dallas:alabama",
  },
  {
    text: "Dallas, AR",
    value: "dallas:arkansas",
  },
  {
    text: "Dallas, MO",
    value: "dallas:missouri",
  },
  {
    text: "Dallas, IA",
    value: "dallas:iowa",
  },
  {
    text: "Dane, WI",
    value: "dane:wisconsin",
  },
  {
    text: "Daniels, MT",
    value: "daniels:montana",
  },
  {
    text: "Danville, VA",
    value: "danville city:virginia",
  },
  {
    text: "Dare, NC",
    value: "dare:north carolina",
  },
  {
    text: "Darke, OH",
    value: "darke:ohio",
  },
  {
    text: "Darlington, SC",
    value: "darlington:south carolina",
  },
  {
    text: "Dauphin, PA",
    value: "dauphin:pennsylvania",
  },
  {
    text: "Davidson, NC",
    value: "davidson:north carolina",
  },
  {
    text: "Davidson, TN",
    value: "davidson:tennessee",
  },
  {
    text: "Davie, NC",
    value: "davie:north carolina",
  },
  {
    text: "Daviess, IN",
    value: "daviess:indiana",
  },
  {
    text: "Daviess, KY",
    value: "daviess:kentucky",
  },
  {
    text: "Daviess, MO",
    value: "daviess:missouri",
  },
  {
    text: "Davis, IA",
    value: "davis:iowa",
  },
  {
    text: "Davis, UT",
    value: "davis:utah",
  },
  {
    text: "Davison, SD",
    value: "davison:south dakota",
  },
  {
    text: "Dawes, NE",
    value: "dawes:nebraska",
  },
  {
    text: "Dawson, TX",
    value: "dawson:texas",
  },
  {
    text: "Dawson, GA",
    value: "dawson:georgia",
  },
  {
    text: "Dawson, NE",
    value: "dawson:nebraska",
  },
  {
    text: "Dawson, MT",
    value: "dawson:montana",
  },
  {
    text: "Day, SD",
    value: "day:south dakota",
  },
  {
    text: "De Baca, NM",
    value: "de baca:new mexico",
  },
  {
    text: "DeKalb, AL",
    value: "de kalb:alabama",
  },
  {
    text: "DeKalb, IL",
    value: "de kalb:illinois",
  },
  {
    text: "DeKalb, IN",
    value: "de kalb:indiana",
  },
  {
    text: "DeKalb, MO",
    value: "de kalb:missouri",
  },
  {
    text: "DeKalb, TN",
    value: "de kalb:tennessee",
  },
  {
    text: "DeKalb, GA",
    value: "de kalb:georgia",
  },
  {
    text: "DeSoto, FL",
    value: "de soto:florida",
  },
  {
    text: "DeSoto, LA",
    value: "de soto:louisiana",
  },
  {
    text: "DeSoto, MS",
    value: "de soto:mississippi",
  },
  {
    text: "De Witt, TX",
    value: "de witt:texas",
  },
  {
    text: "De Witt, IL",
    value: "de witt:illinois",
  },
  {
    text: "DeKalb, AL",
    value: "dekalb:alabama",
  },
  {
    text: "DeKalb, IL",
    value: "dekalb:illinois",
  },
  {
    text: "DeKalb, IN",
    value: "dekalb:indiana",
  },
  {
    text: "DeKalb, MO",
    value: "dekalb:missouri",
  },
  {
    text: "DeKalb, TN",
    value: "dekalb:tennessee",
  },
  {
    text: "DeKalb, GA",
    value: "dekalb:georgia",
  },
  {
    text: "DeSoto, FL",
    value: "desoto:florida",
  },
  {
    text: "DeSoto, LA",
    value: "desoto:louisiana",
  },
  {
    text: "DeSoto, MS",
    value: "desoto:mississippi",
  },
  {
    text: "De Witt, TX",
    value: "dewitt:texas",
  },
  {
    text: "De Witt, IL",
    value: "dewitt:illinois",
  },
  {
    text: "Deaf Smith, TX",
    value: "deaf smith:texas",
  },
  {
    text: "Dearborn, IN",
    value: "dearborn:indiana",
  },
  {
    text: "Decatur, IN",
    value: "decatur:indiana",
  },
  {
    text: "Decatur, KS",
    value: "decatur:kansas",
  },
  {
    text: "Decatur, TN",
    value: "decatur:tennessee",
  },
  {
    text: "Decatur, GA",
    value: "decatur:georgia",
  },
  {
    text: "Decatur, IA",
    value: "decatur:iowa",
  },
  {
    text: "Deer Lodge, MT",
    value: "deer lodge:montana",
  },
  {
    text: "Defiance, OH",
    value: "defiance:ohio",
  },
  {
    text: "DeKalb, AL",
    value: "dekalb:alabama",
  },
  {
    text: "DeKalb, IL",
    value: "dekalb:illinois",
  },
  {
    text: "DeKalb, IN",
    value: "dekalb:indiana",
  },
  {
    text: "DeKalb, MO",
    value: "dekalb:missouri",
  },
  {
    text: "DeKalb, TN",
    value: "dekalb:tennessee",
  },
  {
    text: "DeKalb, GA",
    value: "dekalb:georgia",
  },
  {
    text: "Del Norte, CA",
    value: "del norte:california",
  },
  {
    text: "Delaware, IN",
    value: "delaware:indiana",
  },
  {
    text: "Delaware, OH",
    value: "delaware:ohio",
  },
  {
    text: "Delaware, OK",
    value: "delaware:oklahoma",
  },
  {
    text: "Delaware, PA",
    value: "delaware:pennsylvania",
  },
  {
    text: "Delaware, IA",
    value: "delaware:iowa",
  },
  {
    text: "Delaware, NY",
    value: "delaware:new york",
  },
  {
    text: "Delta, TX",
    value: "delta:texas",
  },
  {
    text: "Delta, MI",
    value: "delta:michigan",
  },
  {
    text: "Delta, CO",
    value: "delta:colorado",
  },
  {
    text: "Denali, AK",
    value: "denali:alaska",
  },
  {
    text: "Dent, MO",
    value: "dent:missouri",
  },
  {
    text: "Denton, TX",
    value: "denton:texas",
  },
  {
    text: "Denver, CO",
    value: "denver:colorado",
  },
  {
    text: "Des Moines, IA",
    value: "des moines:iowa",
  },
  {
    text: "Deschutes, OR",
    value: "deschutes:oregon",
  },
  {
    text: "Desha, AR",
    value: "desha:arkansas",
  },
  {
    text: "Deuel, NE",
    value: "deuel:nebraska",
  },
  {
    text: "Deuel, SD",
    value: "deuel:south dakota",
  },
  {
    text: "Dewey, OK",
    value: "dewey:oklahoma",
  },
  {
    text: "Dewey, SD",
    value: "dewey:south dakota",
  },
  {
    text: "De Witt, TX",
    value: "dewitt:texas",
  },
  {
    text: "De Witt, IL",
    value: "dewitt:illinois",
  },
  {
    text: "Dickens, TX",
    value: "dickens:texas",
  },
  {
    text: "Dickenson, VA",
    value: "dickenson:virginia",
  },
  {
    text: "Dickey, ND",
    value: "dickey:north dakota",
  },
  {
    text: "Dickinson, KS",
    value: "dickinson:kansas",
  },
  {
    text: "Dickinson, IA",
    value: "dickinson:iowa",
  },
  {
    text: "Dickinson, MI",
    value: "dickinson:michigan",
  },
  {
    text: "Dickson, TN",
    value: "dickson:tennessee",
  },
  {
    text: "Dillingham, AK",
    value: "dillingham:alaska",
  },
  {
    text: "Dillon, SC",
    value: "dillon:south carolina",
  },
  {
    text: "Dimmit, TX",
    value: "dimmit:texas",
  },
  {
    text: "Dinwiddie, VA",
    value: "dinwiddie:virginia",
  },
  {
    text: "District of Columbia, DC",
    value: "district of columbia:district of columbia",
  },
  {
    text: "Divide, ND",
    value: "divide:north dakota",
  },
  {
    text: "Dixie, FL",
    value: "dixie:florida",
  },
  {
    text: "Dixon, NE",
    value: "dixon:nebraska",
  },
  {
    text: "Doddridge, WV",
    value: "doddridge:west virginia",
  },
  {
    text: "Dodge, GA",
    value: "dodge:georgia",
  },
  {
    text: "Dodge, MN",
    value: "dodge:minnesota",
  },
  {
    text: "Dodge, NE",
    value: "dodge:nebraska",
  },
  {
    text: "Dodge, WI",
    value: "dodge:wisconsin",
  },
  {
    text: "Dolores, CO",
    value: "dolores:colorado",
  },
  {
    text: "Dona Ana, NM",
    value: "dona ana:new mexico",
  },
  {
    text: "Doniphan, KS",
    value: "doniphan:kansas",
  },
  {
    text: "Donley, TX",
    value: "donley:texas",
  },
  {
    text: "Dooly, GA",
    value: "dooly:georgia",
  },
  {
    text: "Door, WI",
    value: "door:wisconsin",
  },
  {
    text: "Dorchester, MD",
    value: "dorchester:maryland",
  },
  {
    text: "Dorchester, SC",
    value: "dorchester:south carolina",
  },
  {
    text: "Dougherty, GA",
    value: "dougherty:georgia",
  },
  {
    text: "Douglas, IL",
    value: "douglas:illinois",
  },
  {
    text: "Douglas, KS",
    value: "douglas:kansas",
  },
  {
    text: "Douglas, MO",
    value: "douglas:missouri",
  },
  {
    text: "Douglas, GA",
    value: "douglas:georgia",
  },
  {
    text: "Douglas, MN",
    value: "douglas:minnesota",
  },
  {
    text: "Douglas, NE",
    value: "douglas:nebraska",
  },
  {
    text: "Douglas, SD",
    value: "douglas:south dakota",
  },
  {
    text: "Douglas, WI",
    value: "douglas:wisconsin",
  },
  {
    text: "Douglas, CO",
    value: "douglas:colorado",
  },
  {
    text: "Douglas, NV",
    value: "douglas:nevada",
  },
  {
    text: "Douglas, OR",
    value: "douglas:oregon",
  },
  {
    text: "Douglas, WA",
    value: "douglas:washington",
  },
  {
    text: "Drew, AR",
    value: "drew:arkansas",
  },
  {
    text: "DuPage, IL",
    value: "du page:illinois",
  },
  {
    text: "DuPage, IL",
    value: "dupage:illinois",
  },
  {
    text: "Dubois, IN",
    value: "dubois:indiana",
  },
  {
    text: "Dubuque, IA",
    value: "dubuque:iowa",
  },
  {
    text: "Duchesne, UT",
    value: "duchesne:utah",
  },
  {
    text: "Dukes, MA",
    value: "dukes:massachusetts",
  },
  {
    text: "Dundy, NE",
    value: "dundy:nebraska",
  },
  {
    text: "Dunklin, MO",
    value: "dunklin:missouri",
  },
  {
    text: "Dunn, WI",
    value: "dunn:wisconsin",
  },
  {
    text: "Dunn, ND",
    value: "dunn:north dakota",
  },
  {
    text: "Duplin, NC",
    value: "duplin:north carolina",
  },
  {
    text: "Durham, NC",
    value: "durham:north carolina",
  },
  {
    text: "Dutchess, NY",
    value: "dutchess:new york",
  },
  {
    text: "Duval, TX",
    value: "duval:texas",
  },
  {
    text: "Duval, FL",
    value: "duval:florida",
  },
  {
    text: "Dyer, TN",
    value: "dyer:tennessee",
  },
  {
    text: "Eagle, CO",
    value: "eagle:colorado",
  },
  {
    text: "Early, GA",
    value: "early:georgia",
  },
  {
    text: "East Baton Rouge, LA",
    value: "east baton rouge:louisiana",
  },
  {
    text: "East Carroll, LA",
    value: "east carroll:louisiana",
  },
  {
    text: "East Feliciana, LA",
    value: "east feliciana:louisiana",
  },
  {
    text: "Eastland, TX",
    value: "eastland:texas",
  },
  {
    text: "Eaton, MI",
    value: "eaton:michigan",
  },
  {
    text: "Eau Claire, WI",
    value: "eau claire:wisconsin",
  },
  {
    text: "Echols, GA",
    value: "echols:georgia",
  },
  {
    text: "Ector, TX",
    value: "ector:texas",
  },
  {
    text: "Eddy, ND",
    value: "eddy:north dakota",
  },
  {
    text: "Eddy, NM",
    value: "eddy:new mexico",
  },
  {
    text: "Edgar, IL",
    value: "edgar:illinois",
  },
  {
    text: "Edgecombe, NC",
    value: "edgecombe:north carolina",
  },
  {
    text: "Edgefield, SC",
    value: "edgefield:south carolina",
  },
  {
    text: "Edmonson, KY",
    value: "edmonson:kentucky",
  },
  {
    text: "Edmunds, SD",
    value: "edmunds:south dakota",
  },
  {
    text: "Edwards, TX",
    value: "edwards:texas",
  },
  {
    text: "Edwards, IL",
    value: "edwards:illinois",
  },
  {
    text: "Edwards, KS",
    value: "edwards:kansas",
  },
  {
    text: "Effingham, IL",
    value: "effingham:illinois",
  },
  {
    text: "Effingham, GA",
    value: "effingham:georgia",
  },
  {
    text: "El Dorado, CA",
    value: "el dorado:california",
  },
  {
    text: "El Paso, TX",
    value: "el paso:texas",
  },
  {
    text: "El Paso, CO",
    value: "el paso:colorado",
  },
  {
    text: "Elbert, GA",
    value: "elbert:georgia",
  },
  {
    text: "Elbert, CO",
    value: "elbert:colorado",
  },
  {
    text: "Elk, KS",
    value: "elk:kansas",
  },
  {
    text: "Elk, PA",
    value: "elk:pennsylvania",
  },
  {
    text: "Elkhart, IN",
    value: "elkhart:indiana",
  },
  {
    text: "Elko, NV",
    value: "elko:nevada",
  },
  {
    text: "Elliott, KY",
    value: "elliott:kentucky",
  },
  {
    text: "Ellis, TX",
    value: "ellis:texas",
  },
  {
    text: "Ellis, KS",
    value: "ellis:kansas",
  },
  {
    text: "Ellis, OK",
    value: "ellis:oklahoma",
  },
  {
    text: "Ellsworth, KS",
    value: "ellsworth:kansas",
  },
  {
    text: "Elmore, AL",
    value: "elmore:alabama",
  },
  {
    text: "Elmore, ID",
    value: "elmore:idaho",
  },
  {
    text: "Emanuel, GA",
    value: "emanuel:georgia",
  },
  {
    text: "Emery, UT",
    value: "emery:utah",
  },
  {
    text: "Emmet, IA",
    value: "emmet:iowa",
  },
  {
    text: "Emmet, MI",
    value: "emmet:michigan",
  },
  {
    text: "Emmons, ND",
    value: "emmons:north dakota",
  },
  {
    text: "Emporia, VA",
    value: "emporia city:virginia",
  },
  {
    text: "Erath, TX",
    value: "erath:texas",
  },
  {
    text: "Erie, OH",
    value: "erie:ohio",
  },
  {
    text: "Erie, PA",
    value: "erie:pennsylvania",
  },
  {
    text: "Erie, NY",
    value: "erie:new york",
  },
  {
    text: "Escambia, AL",
    value: "escambia:alabama",
  },
  {
    text: "Escambia, FL",
    value: "escambia:florida",
  },
  {
    text: "Esmeralda, NV",
    value: "esmeralda:nevada",
  },
  {
    text: "Essex, VA",
    value: "essex:virginia",
  },
  {
    text: "Essex, NJ",
    value: "essex:new jersey",
  },
  {
    text: "Essex, MA",
    value: "essex:massachusetts",
  },
  {
    text: "Essex, NY",
    value: "essex:new york",
  },
  {
    text: "Essex, VT",
    value: "essex:vermont",
  },
  {
    text: "Estill, KY",
    value: "estill:kentucky",
  },
  {
    text: "Etowah, AL",
    value: "etowah:alabama",
  },
  {
    text: "Eureka, NV",
    value: "eureka:nevada",
  },
  {
    text: "Evangeline, LA",
    value: "evangeline:louisiana",
  },
  {
    text: "Evangeline, LA",
    value: "evangeline parish:louisiana",
  },
  {
    text: "Evans, GA",
    value: "evans:georgia",
  },
  {
    text: "Fairbanks North Star, AK",
    value: "fairbanks north star:alaska",
  },
  {
    text: "Fairfax, VA",
    value: "fairfax:virginia",
  },
  {
    text: "Fairfax, VA",
    value: "fairfax city:virginia",
  },
  {
    text: "Fairfax, VA",
    value: "fairfax county:virginia",
  },
  {
    text: "Fairfield, OH",
    value: "fairfield:ohio",
  },
  {
    text: "Fairfield, SC",
    value: "fairfield:south carolina",
  },
  {
    text: "Fairfield, CT",
    value: "fairfield:connecticut",
  },
  {
    text: "Fall River, SD",
    value: "fall river:south dakota",
  },
  {
    text: "Fallon, MT",
    value: "fallon:montana",
  },
  {
    text: "Falls, TX",
    value: "falls:texas",
  },
  {
    text: "Falls Church, VA",
    value: "falls church city:virginia",
  },
  {
    text: "Fannin, TX",
    value: "fannin:texas",
  },
  {
    text: "Fannin, GA",
    value: "fannin:georgia",
  },
  {
    text: "Faribault, MN",
    value: "faribault:minnesota",
  },
  {
    text: "Faulk, SD",
    value: "faulk:south dakota",
  },
  {
    text: "Faulkner, AR",
    value: "faulkner:arkansas",
  },
  {
    text: "Fauquier, VA",
    value: "fauquier:virginia",
  },
  {
    text: "Fayette, TX",
    value: "fayette:texas",
  },
  {
    text: "Fayette, AL",
    value: "fayette:alabama",
  },
  {
    text: "Fayette, WV",
    value: "fayette:west virginia",
  },
  {
    text: "Fayette, IL",
    value: "fayette:illinois",
  },
  {
    text: "Fayette, IN",
    value: "fayette:indiana",
  },
  {
    text: "Fayette, KY",
    value: "fayette:kentucky",
  },
  {
    text: "Fayette, TN",
    value: "fayette:tennessee",
  },
  {
    text: "Fayette, GA",
    value: "fayette:georgia",
  },
  {
    text: "Fayette, OH",
    value: "fayette:ohio",
  },
  {
    text: "Fayette, PA",
    value: "fayette:pennsylvania",
  },
  {
    text: "Fayette, IA",
    value: "fayette:iowa",
  },
  {
    text: "Fentress, TN",
    value: "fentress:tennessee",
  },
  {
    text: "Fergus, MT",
    value: "fergus:montana",
  },
  {
    text: "Ferry, WA",
    value: "ferry:washington",
  },
  {
    text: "Fillmore, MN",
    value: "fillmore:minnesota",
  },
  {
    text: "Fillmore, NE",
    value: "fillmore:nebraska",
  },
  {
    text: "Finney, KS",
    value: "finney:kansas",
  },
  {
    text: "Fisher, TX",
    value: "fisher:texas",
  },
  {
    text: "Flagler, FL",
    value: "flagler:florida",
  },
  {
    text: "Flathead, MT",
    value: "flathead:montana",
  },
  {
    text: "Fleming, KY",
    value: "fleming:kentucky",
  },
  {
    text: "Florence, SC",
    value: "florence:south carolina",
  },
  {
    text: "Florence, WI",
    value: "florence:wisconsin",
  },
  {
    text: "Floyd, TX",
    value: "floyd:texas",
  },
  {
    text: "Floyd, VA",
    value: "floyd:virginia",
  },
  {
    text: "Floyd, IN",
    value: "floyd:indiana",
  },
  {
    text: "Floyd, KY",
    value: "floyd:kentucky",
  },
  {
    text: "Floyd, GA",
    value: "floyd:georgia",
  },
  {
    text: "Floyd, IA",
    value: "floyd:iowa",
  },
  {
    text: "Fluvanna, VA",
    value: "fluvanna:virginia",
  },
  {
    text: "Foard, TX",
    value: "foard:texas",
  },
  {
    text: "Fond Du Lac, WI",
    value: "fond du lac:wisconsin",
  },
  {
    text: "Fond Du Lac, WI",
    value: "fond du lac:wisconsin",
  },
  {
    text: "Ford, IL",
    value: "ford:illinois",
  },
  {
    text: "Ford, KS",
    value: "ford:kansas",
  },
  {
    text: "Forest, PA",
    value: "forest:pennsylvania",
  },
  {
    text: "Forest, WI",
    value: "forest:wisconsin",
  },
  {
    text: "Forrest, MS",
    value: "forrest:mississippi",
  },
  {
    text: "Forsyth, NC",
    value: "forsyth:north carolina",
  },
  {
    text: "Forsyth, GA",
    value: "forsyth:georgia",
  },
  {
    text: "Fort Bend, TX",
    value: "fort bend:texas",
  },
  {
    text: "Foster, ND",
    value: "foster:north dakota",
  },
  {
    text: "Fountain, IN",
    value: "fountain:indiana",
  },
  {
    text: "Franklin, TX",
    value: "franklin:texas",
  },
  {
    text: "Franklin, AL",
    value: "franklin:alabama",
  },
  {
    text: "Franklin, VA",
    value: "franklin:virginia",
  },
  {
    text: "Franklin, AR",
    value: "franklin:arkansas",
  },
  {
    text: "Franklin, FL",
    value: "franklin:florida",
  },
  {
    text: "Franklin, IL",
    value: "franklin:illinois",
  },
  {
    text: "Franklin, IN",
    value: "franklin:indiana",
  },
  {
    text: "Franklin, KS",
    value: "franklin:kansas",
  },
  {
    text: "Franklin, KY",
    value: "franklin:kentucky",
  },
  {
    text: "Franklin, LA",
    value: "franklin:louisiana",
  },
  {
    text: "Franklin, MO",
    value: "franklin:missouri",
  },
  {
    text: "Franklin, MS",
    value: "franklin:mississippi",
  },
  {
    text: "Franklin, NC",
    value: "franklin:north carolina",
  },
  {
    text: "Franklin, TN",
    value: "franklin:tennessee",
  },
  {
    text: "Franklin, GA",
    value: "franklin:georgia",
  },
  {
    text: "Franklin, OH",
    value: "franklin:ohio",
  },
  {
    text: "Franklin, PA",
    value: "franklin:pennsylvania",
  },
  {
    text: "Franklin, IA",
    value: "franklin:iowa",
  },
  {
    text: "Franklin, MA",
    value: "franklin:massachusetts",
  },
  {
    text: "Franklin, NE",
    value: "franklin:nebraska",
  },
  {
    text: "Franklin, NY",
    value: "franklin:new york",
  },
  {
    text: "Franklin, ME",
    value: "franklin:maine",
  },
  {
    text: "Franklin, VT",
    value: "franklin:vermont",
  },
  {
    text: "Franklin, WA",
    value: "franklin:washington",
  },
  {
    text: "Franklin, ID",
    value: "franklin:idaho",
  },
  {
    text: "Franklin, TX",
    value: "franklin city:texas",
  },
  {
    text: "Franklin, AL",
    value: "franklin city:alabama",
  },
  {
    text: "Franklin, VA",
    value: "franklin city:virginia",
  },
  {
    text: "Franklin, AR",
    value: "franklin city:arkansas",
  },
  {
    text: "Franklin, FL",
    value: "franklin city:florida",
  },
  {
    text: "Franklin, IL",
    value: "franklin city:illinois",
  },
  {
    text: "Franklin, IN",
    value: "franklin city:indiana",
  },
  {
    text: "Franklin, KS",
    value: "franklin city:kansas",
  },
  {
    text: "Franklin, KY",
    value: "franklin city:kentucky",
  },
  {
    text: "Franklin, LA",
    value: "franklin city:louisiana",
  },
  {
    text: "Franklin, MO",
    value: "franklin city:missouri",
  },
  {
    text: "Franklin, MS",
    value: "franklin city:mississippi",
  },
  {
    text: "Franklin, NC",
    value: "franklin city:north carolina",
  },
  {
    text: "Franklin, TN",
    value: "franklin city:tennessee",
  },
  {
    text: "Franklin, GA",
    value: "franklin city:georgia",
  },
  {
    text: "Franklin, OH",
    value: "franklin city:ohio",
  },
  {
    text: "Franklin, PA",
    value: "franklin city:pennsylvania",
  },
  {
    text: "Franklin, IA",
    value: "franklin city:iowa",
  },
  {
    text: "Franklin, MA",
    value: "franklin city:massachusetts",
  },
  {
    text: "Franklin, NE",
    value: "franklin city:nebraska",
  },
  {
    text: "Franklin, NY",
    value: "franklin city:new york",
  },
  {
    text: "Franklin, ME",
    value: "franklin city:maine",
  },
  {
    text: "Franklin, VT",
    value: "franklin city:vermont",
  },
  {
    text: "Franklin, WA",
    value: "franklin city:washington",
  },
  {
    text: "Franklin, ID",
    value: "franklin city:idaho",
  },
  {
    text: "Frederick, VA",
    value: "frederick:virginia",
  },
  {
    text: "Frederick, MD",
    value: "frederick:maryland",
  },
  {
    text: "Fredericksburg, VA",
    value: "fredericksburg city:virginia",
  },
  {
    text: "Freeborn, MN",
    value: "freeborn:minnesota",
  },
  {
    text: "Freestone, TX",
    value: "freestone:texas",
  },
  {
    text: "Fremont, IA",
    value: "fremont:iowa",
  },
  {
    text: "Fremont, CO",
    value: "fremont:colorado",
  },
  {
    text: "Fremont, ID",
    value: "fremont:idaho",
  },
  {
    text: "Fremont, WY",
    value: "fremont:wyoming",
  },
  {
    text: "Fresno, CA",
    value: "fresno:california",
  },
  {
    text: "Frio, TX",
    value: "frio:texas",
  },
  {
    text: "Frontier, NE",
    value: "frontier:nebraska",
  },
  {
    text: "Fulton, AR",
    value: "fulton:arkansas",
  },
  {
    text: "Fulton, IL",
    value: "fulton:illinois",
  },
  {
    text: "Fulton, IN",
    value: "fulton:indiana",
  },
  {
    text: "Fulton, KY",
    value: "fulton:kentucky",
  },
  {
    text: "Fulton, GA",
    value: "fulton:georgia",
  },
  {
    text: "Fulton, OH",
    value: "fulton:ohio",
  },
  {
    text: "Fulton, PA",
    value: "fulton:pennsylvania",
  },
  {
    text: "Fulton, NY",
    value: "fulton:new york",
  },
  {
    text: "Furnas, NE",
    value: "furnas:nebraska",
  },
  {
    text: "Gadsden, FL",
    value: "gadsden:florida",
  },
  {
    text: "Gage, NE",
    value: "gage:nebraska",
  },
  {
    text: "Gaines, TX",
    value: "gaines:texas",
  },
  {
    text: "Galax, VA",
    value: "galax city:virginia",
  },
  {
    text: "Gallatin, IL",
    value: "gallatin:illinois",
  },
  {
    text: "Gallatin, KY",
    value: "gallatin:kentucky",
  },
  {
    text: "Gallatin, MT",
    value: "gallatin:montana",
  },
  {
    text: "Gallia, OH",
    value: "gallia:ohio",
  },
  {
    text: "Galveston, TX",
    value: "galveston:texas",
  },
  {
    text: "Garden, NE",
    value: "garden:nebraska",
  },
  {
    text: "Garfield, OK",
    value: "garfield:oklahoma",
  },
  {
    text: "Garfield, NE",
    value: "garfield:nebraska",
  },
  {
    text: "Garfield, CO",
    value: "garfield:colorado",
  },
  {
    text: "Garfield, UT",
    value: "garfield:utah",
  },
  {
    text: "Garfield, WA",
    value: "garfield:washington",
  },
  {
    text: "Garfield, MT",
    value: "garfield:montana",
  },
  {
    text: "Garland, AR",
    value: "garland:arkansas",
  },
  {
    text: "Garrard, KY",
    value: "garrard:kentucky",
  },
  {
    text: "Garrett, MD",
    value: "garrett:maryland",
  },
  {
    text: "Garvin, OK",
    value: "garvin:oklahoma",
  },
  {
    text: "Garza, TX",
    value: "garza:texas",
  },
  {
    text: "Gasconade, MO",
    value: "gasconade:missouri",
  },
  {
    text: "Gaston, NC",
    value: "gaston:north carolina",
  },
  {
    text: "Gates, NC",
    value: "gates:north carolina",
  },
  {
    text: "Geary, KS",
    value: "geary:kansas",
  },
  {
    text: "Geauga, OH",
    value: "geauga:ohio",
  },
  {
    text: "Gem, ID",
    value: "gem:idaho",
  },
  {
    text: "Genesee, NY",
    value: "genesee:new york",
  },
  {
    text: "Genesee, MI",
    value: "genesee:michigan",
  },
  {
    text: "Geneva, AL",
    value: "geneva:alabama",
  },
  {
    text: "Gentry, MO",
    value: "gentry:missouri",
  },
  {
    text: "George, MS",
    value: "george:mississippi",
  },
  {
    text: "Georgetown, SC",
    value: "georgetown:south carolina",
  },
  {
    text: "Gibson, IN",
    value: "gibson:indiana",
  },
  {
    text: "Gibson, TN",
    value: "gibson:tennessee",
  },
  {
    text: "Gila, AZ",
    value: "gila:arizona",
  },
  {
    text: "Gilchrist, FL",
    value: "gilchrist:florida",
  },
  {
    text: "Giles, VA",
    value: "giles:virginia",
  },
  {
    text: "Giles, TN",
    value: "giles:tennessee",
  },
  {
    text: "Gillespie, TX",
    value: "gillespie:texas",
  },
  {
    text: "Gilliam, OR",
    value: "gilliam:oregon",
  },
  {
    text: "Gilmer, WV",
    value: "gilmer:west virginia",
  },
  {
    text: "Gilmer, GA",
    value: "gilmer:georgia",
  },
  {
    text: "Gilpin, CO",
    value: "gilpin:colorado",
  },
  {
    text: "Glacier, MT",
    value: "glacier:montana",
  },
  {
    text: "Glades, FL",
    value: "glades:florida",
  },
  {
    text: "Gladwin, MI",
    value: "gladwin:michigan",
  },
  {
    text: "Glascock, GA",
    value: "glascock:georgia",
  },
  {
    text: "Glasscock, TX",
    value: "glasscock:texas",
  },
  {
    text: "Glenn, CA",
    value: "glenn:california",
  },
  {
    text: "Gloucester, VA",
    value: "gloucester:virginia",
  },
  {
    text: "Gloucester, NJ",
    value: "gloucester:new jersey",
  },
  {
    text: "Glynn, GA",
    value: "glynn:georgia",
  },
  {
    text: "Gogebic, MI",
    value: "gogebic:michigan",
  },
  {
    text: "Golden Valley, ND",
    value: "golden valley:north dakota",
  },
  {
    text: "Golden Valley, MT",
    value: "golden valley:montana",
  },
  {
    text: "Goliad, TX",
    value: "goliad:texas",
  },
  {
    text: "Gonzales, TX",
    value: "gonzales:texas",
  },
  {
    text: "Goochland, VA",
    value: "goochland:virginia",
  },
  {
    text: "Goodhue, MN",
    value: "goodhue:minnesota",
  },
  {
    text: "Gooding, ID",
    value: "gooding:idaho",
  },
  {
    text: "Gordon, GA",
    value: "gordon:georgia",
  },
  {
    text: "Goshen, WY",
    value: "goshen:wyoming",
  },
  {
    text: "Gosper, NE",
    value: "gosper:nebraska",
  },
  {
    text: "Gove, KS",
    value: "gove:kansas",
  },
  {
    text: "Grady, GA",
    value: "grady:georgia",
  },
  {
    text: "Grady, OK",
    value: "grady:oklahoma",
  },
  {
    text: "Grafton, NH",
    value: "grafton:new hampshire",
  },
  {
    text: "Graham, KS",
    value: "graham:kansas",
  },
  {
    text: "Graham, NC",
    value: "graham:north carolina",
  },
  {
    text: "Graham, AZ",
    value: "graham:arizona",
  },
  {
    text: "Grainger, TN",
    value: "grainger:tennessee",
  },
  {
    text: "Grand, CO",
    value: "grand:colorado",
  },
  {
    text: "Grand, UT",
    value: "grand:utah",
  },
  {
    text: "Grand Forks, ND",
    value: "grand forks:north dakota",
  },
  {
    text: "Grand Isle, VT",
    value: "grand isle:vermont",
  },
  {
    text: "Grand Traverse, MI",
    value: "grand traverse:michigan",
  },
  {
    text: "Granite, MT",
    value: "granite:montana",
  },
  {
    text: "Grant, WV",
    value: "grant:west virginia",
  },
  {
    text: "Grant, AR",
    value: "grant:arkansas",
  },
  {
    text: "Grant, FL",
    value: "grant:florida",
  },
  {
    text: "Grant, IN",
    value: "grant:indiana",
  },
  {
    text: "Grant, KS",
    value: "grant:kansas",
  },
  {
    text: "Grant, KY",
    value: "grant:kentucky",
  },
  {
    text: "Grant, LA",
    value: "grant:louisiana",
  },
  {
    text: "Grant, OK",
    value: "grant:oklahoma",
  },
  {
    text: "Grant, MN",
    value: "grant:minnesota",
  },
  {
    text: "Grant, NE",
    value: "grant:nebraska",
  },
  {
    text: "Grant, SD",
    value: "grant:south dakota",
  },
  {
    text: "Grant, WI",
    value: "grant:wisconsin",
  },
  {
    text: "Grant, ND",
    value: "grant:north dakota",
  },
  {
    text: "Grant, NM",
    value: "grant:new mexico",
  },
  {
    text: "Grant, OR",
    value: "grant:oregon",
  },
  {
    text: "Grant, WA",
    value: "grant:washington",
  },
  {
    text: "Granville, NC",
    value: "granville:north carolina",
  },
  {
    text: "Gratiot, MI",
    value: "gratiot:michigan",
  },
  {
    text: "Graves, KY",
    value: "graves:kentucky",
  },
  {
    text: "Gray, TX",
    value: "gray:texas",
  },
  {
    text: "Gray, KS",
    value: "gray:kansas",
  },
  {
    text: "Grays Harbor, WA",
    value: "grays harbor:washington",
  },
  {
    text: "Grayson, TX",
    value: "grayson:texas",
  },
  {
    text: "Grayson, VA",
    value: "grayson:virginia",
  },
  {
    text: "Grayson, KY",
    value: "grayson:kentucky",
  },
  {
    text: "Greeley, KS",
    value: "greeley:kansas",
  },
  {
    text: "Greeley, NE",
    value: "greeley:nebraska",
  },
  {
    text: "Green, KY",
    value: "green:kentucky",
  },
  {
    text: "Green, WI",
    value: "green:wisconsin",
  },
  {
    text: "Green Lake, WI",
    value: "green lake:wisconsin",
  },
  {
    text: "Greenbrier, WV",
    value: "greenbrier:west virginia",
  },
  {
    text: "Greene, AL",
    value: "greene:alabama",
  },
  {
    text: "Greene, VA",
    value: "greene:virginia",
  },
  {
    text: "Greene, AR",
    value: "greene:arkansas",
  },
  {
    text: "Greene, IL",
    value: "greene:illinois",
  },
  {
    text: "Greene, IN",
    value: "greene:indiana",
  },
  {
    text: "Greene, MO",
    value: "greene:missouri",
  },
  {
    text: "Greene, MS",
    value: "greene:mississippi",
  },
  {
    text: "Greene, NC",
    value: "greene:north carolina",
  },
  {
    text: "Greene, TN",
    value: "greene:tennessee",
  },
  {
    text: "Greene, GA",
    value: "greene:georgia",
  },
  {
    text: "Greene, OH",
    value: "greene:ohio",
  },
  {
    text: "Greene, PA",
    value: "greene:pennsylvania",
  },
  {
    text: "Greene, IA",
    value: "greene:iowa",
  },
  {
    text: "Greene, NY",
    value: "greene:new york",
  },
  {
    text: "Greenlee, AZ",
    value: "greenlee:arizona",
  },
  {
    text: "Greensville, VA",
    value: "greensville:virginia",
  },
  {
    text: "Greenup, KY",
    value: "greenup:kentucky",
  },
  {
    text: "Greenville, SC",
    value: "greenville:south carolina",
  },
  {
    text: "Greenwood, KS",
    value: "greenwood:kansas",
  },
  {
    text: "Greenwood, SC",
    value: "greenwood:south carolina",
  },
  {
    text: "Greer, OK",
    value: "greer:oklahoma",
  },
  {
    text: "Gregg, TX",
    value: "gregg:texas",
  },
  {
    text: "Gregory, SD",
    value: "gregory:south dakota",
  },
  {
    text: "Grenada, MS",
    value: "grenada:mississippi",
  },
  {
    text: "Griggs, ND",
    value: "griggs:north dakota",
  },
  {
    text: "Grimes, TX",
    value: "grimes:texas",
  },
  {
    text: "Grundy, IL",
    value: "grundy:illinois",
  },
  {
    text: "Grundy, MO",
    value: "grundy:missouri",
  },
  {
    text: "Grundy, TN",
    value: "grundy:tennessee",
  },
  {
    text: "Grundy, IA",
    value: "grundy:iowa",
  },
  {
    text: "Guadalupe, TX",
    value: "guadalupe:texas",
  },
  {
    text: "Guadalupe, NM",
    value: "guadalupe:new mexico",
  },
  {
    text: "Guernsey, OH",
    value: "guernsey:ohio",
  },
  {
    text: "Guilford, NC",
    value: "guilford:north carolina",
  },
  {
    text: "Gulf, FL",
    value: "gulf:florida",
  },
  {
    text: "Gunnison, CO",
    value: "gunnison:colorado",
  },
  {
    text: "Guthrie, IA",
    value: "guthrie:iowa",
  },
  {
    text: "Gwinnett, GA",
    value: "gwinnett:georgia",
  },
  {
    text: "Haakon, SD",
    value: "haakon:south dakota",
  },
  {
    text: "Habersham, GA",
    value: "habersham:georgia",
  },
  {
    text: "Haines, AK",
    value: "haines:alaska",
  },
  {
    text: "Hale, TX",
    value: "hale:texas",
  },
  {
    text: "Hale, AL",
    value: "hale:alabama",
  },
  {
    text: "Halifax, VA",
    value: "halifax:virginia",
  },
  {
    text: "Halifax, NC",
    value: "halifax:north carolina",
  },
  {
    text: "Hall, TX",
    value: "hall:texas",
  },
  {
    text: "Hall, GA",
    value: "hall:georgia",
  },
  {
    text: "Hall, NE",
    value: "hall:nebraska",
  },
  {
    text: "Hamblen, TN",
    value: "hamblen:tennessee",
  },
  {
    text: "Hamilton, TX",
    value: "hamilton:texas",
  },
  {
    text: "Hamilton, FL",
    value: "hamilton:florida",
  },
  {
    text: "Hamilton, IL",
    value: "hamilton:illinois",
  },
  {
    text: "Hamilton, IN",
    value: "hamilton:indiana",
  },
  {
    text: "Hamilton, KS",
    value: "hamilton:kansas",
  },
  {
    text: "Hamilton, TN",
    value: "hamilton:tennessee",
  },
  {
    text: "Hamilton, OH",
    value: "hamilton:ohio",
  },
  {
    text: "Hamilton, IA",
    value: "hamilton:iowa",
  },
  {
    text: "Hamilton, NE",
    value: "hamilton:nebraska",
  },
  {
    text: "Hamilton, NY",
    value: "hamilton:new york",
  },
  {
    text: "Hamlin, SD",
    value: "hamlin:south dakota",
  },
  {
    text: "Hampden, MA",
    value: "hampden:massachusetts",
  },
  {
    text: "Hampshire, WV",
    value: "hampshire:west virginia",
  },
  {
    text: "Hampshire, MA",
    value: "hampshire:massachusetts",
  },
  {
    text: "Hampton, VA",
    value: "hampton:virginia",
  },
  {
    text: "Hampton, SC",
    value: "hampton:south carolina",
  },
  {
    text: "Hampton, VA",
    value: "hampton city:virginia",
  },
  {
    text: "Hampton, SC",
    value: "hampton city:south carolina",
  },
  {
    text: "Hampton, VA",
    value: "hampton city:virginia",
  },
  {
    text: "Hampton, SC",
    value: "hampton city:south carolina",
  },
  {
    text: "Hancock, WV",
    value: "hancock:west virginia",
  },
  {
    text: "Hancock, IL",
    value: "hancock:illinois",
  },
  {
    text: "Hancock, IN",
    value: "hancock:indiana",
  },
  {
    text: "Hancock, KY",
    value: "hancock:kentucky",
  },
  {
    text: "Hancock, MS",
    value: "hancock:mississippi",
  },
  {
    text: "Hancock, TN",
    value: "hancock:tennessee",
  },
  {
    text: "Hancock, GA",
    value: "hancock:georgia",
  },
  {
    text: "Hancock, OH",
    value: "hancock:ohio",
  },
  {
    text: "Hancock, IA",
    value: "hancock:iowa",
  },
  {
    text: "Hancock, ME",
    value: "hancock:maine",
  },
  {
    text: "Hand, SD",
    value: "hand:south dakota",
  },
  {
    text: "Hanover, VA",
    value: "hanover:virginia",
  },
  {
    text: "Hansford, TX",
    value: "hansford:texas",
  },
  {
    text: "Hanson, SD",
    value: "hanson:south dakota",
  },
  {
    text: "Haralson, GA",
    value: "haralson:georgia",
  },
  {
    text: "Hardee, FL",
    value: "hardee:florida",
  },
  {
    text: "Hardeman, TX",
    value: "hardeman:texas",
  },
  {
    text: "Hardeman, TN",
    value: "hardeman:tennessee",
  },
  {
    text: "Hardin, TX",
    value: "hardin:texas",
  },
  {
    text: "Hardin, IL",
    value: "hardin:illinois",
  },
  {
    text: "Hardin, KY",
    value: "hardin:kentucky",
  },
  {
    text: "Hardin, TN",
    value: "hardin:tennessee",
  },
  {
    text: "Hardin, OH",
    value: "hardin:ohio",
  },
  {
    text: "Hardin, IA",
    value: "hardin:iowa",
  },
  {
    text: "Harding, SD",
    value: "harding:south dakota",
  },
  {
    text: "Harding, NM",
    value: "harding:new mexico",
  },
  {
    text: "Hardy, WV",
    value: "hardy:west virginia",
  },
  {
    text: "Harford, MD",
    value: "harford:maryland",
  },
  {
    text: "Harlan, KY",
    value: "harlan:kentucky",
  },
  {
    text: "Harlan, NE",
    value: "harlan:nebraska",
  },
  {
    text: "Harmon, OK",
    value: "harmon:oklahoma",
  },
  {
    text: "Harnett, NC",
    value: "harnett:north carolina",
  },
  {
    text: "Harney, OR",
    value: "harney:oregon",
  },
  {
    text: "Harper, KS",
    value: "harper:kansas",
  },
  {
    text: "Harper, OK",
    value: "harper:oklahoma",
  },
  {
    text: "Harris, TX",
    value: "harris:texas",
  },
  {
    text: "Harris, GA",
    value: "harris:georgia",
  },
  {
    text: "Harrison, TX",
    value: "harrison:texas",
  },
  {
    text: "Harrison, WV",
    value: "harrison:west virginia",
  },
  {
    text: "Harrison, IN",
    value: "harrison:indiana",
  },
  {
    text: "Harrison, KY",
    value: "harrison:kentucky",
  },
  {
    text: "Harrison, MO",
    value: "harrison:missouri",
  },
  {
    text: "Harrison, MS",
    value: "harrison:mississippi",
  },
  {
    text: "Harrison, OH",
    value: "harrison:ohio",
  },
  {
    text: "Harrison, IA",
    value: "harrison:iowa",
  },
  {
    text: "Harrisonburg, VA",
    value: "harrisonburg city:virginia",
  },
  {
    text: "Harrisonburg, VA",
    value: "harrisonburg city:virginia",
  },
  {
    text: "Hart, KY",
    value: "hart:kentucky",
  },
  {
    text: "Hart, GA",
    value: "hart:georgia",
  },
  {
    text: "Hartford, CT",
    value: "hartford:connecticut",
  },
  {
    text: "Hartley, TX",
    value: "hartley:texas",
  },
  {
    text: "Harvey, KS",
    value: "harvey:kansas",
  },
  {
    text: "Haskell, TX",
    value: "haskell:texas",
  },
  {
    text: "Haskell, KS",
    value: "haskell:kansas",
  },
  {
    text: "Haskell, OK",
    value: "haskell:oklahoma",
  },
  {
    text: "Hawaii, HI",
    value: "hawaii:hawaii",
  },
  {
    text: "Hawkins, TN",
    value: "hawkins:tennessee",
  },
  {
    text: "Hayes, NE",
    value: "hayes:nebraska",
  },
  {
    text: "Hays, TX",
    value: "hays:texas",
  },
  {
    text: "Haywood, NC",
    value: "haywood:north carolina",
  },
  {
    text: "Haywood, TN",
    value: "haywood:tennessee",
  },
  {
    text: "Heard, GA",
    value: "heard:georgia",
  },
  {
    text: "Hemphill, TX",
    value: "hemphill:texas",
  },
  {
    text: "Hempstead, AR",
    value: "hempstead:arkansas",
  },
  {
    text: "Henderson, TX",
    value: "henderson:texas",
  },
  {
    text: "Henderson, IL",
    value: "henderson:illinois",
  },
  {
    text: "Henderson, KY",
    value: "henderson:kentucky",
  },
  {
    text: "Henderson, NC",
    value: "henderson:north carolina",
  },
  {
    text: "Henderson, TN",
    value: "henderson:tennessee",
  },
  {
    text: "Hendricks, IN",
    value: "hendricks:indiana",
  },
  {
    text: "Hendry, FL",
    value: "hendry:florida",
  },
  {
    text: "Hennepin, MN",
    value: "hennepin:minnesota",
  },
  {
    text: "Henrico, VA",
    value: "henrico:virginia",
  },
  {
    text: "Henry, AL",
    value: "henry:alabama",
  },
  {
    text: "Henry, VA",
    value: "henry:virginia",
  },
  {
    text: "Henry, IL",
    value: "henry:illinois",
  },
  {
    text: "Henry, IN",
    value: "henry:indiana",
  },
  {
    text: "Henry, KY",
    value: "henry:kentucky",
  },
  {
    text: "Henry, MO",
    value: "henry:missouri",
  },
  {
    text: "Henry, TN",
    value: "henry:tennessee",
  },
  {
    text: "Henry, GA",
    value: "henry:georgia",
  },
  {
    text: "Henry, OH",
    value: "henry:ohio",
  },
  {
    text: "Henry, IA",
    value: "henry:iowa",
  },
  {
    text: "Herkimer, NY",
    value: "herkimer:new york",
  },
  {
    text: "Hernando, FL",
    value: "hernando:florida",
  },
  {
    text: "Hertford, NC",
    value: "hertford:north carolina",
  },
  {
    text: "Hettinger, ND",
    value: "hettinger:north dakota",
  },
  {
    text: "Hickman, KY",
    value: "hickman:kentucky",
  },
  {
    text: "Hickman, TN",
    value: "hickman:tennessee",
  },
  {
    text: "Hickory, MO",
    value: "hickory:missouri",
  },
  {
    text: "Hidalgo, TX",
    value: "hidalgo:texas",
  },
  {
    text: "Hidalgo, NM",
    value: "hidalgo:new mexico",
  },
  {
    text: "Highland, VA",
    value: "highland:virginia",
  },
  {
    text: "Highland, OH",
    value: "highland:ohio",
  },
  {
    text: "Highlands, FL",
    value: "highlands:florida",
  },
  {
    text: "Hill, TX",
    value: "hill:texas",
  },
  {
    text: "Hill, MT",
    value: "hill:montana",
  },
  {
    text: "Hillsborough, FL",
    value: "hillsborough:florida",
  },
  {
    text: "Hillsborough, NH",
    value: "hillsborough:new hampshire",
  },
  {
    text: "Hillsdale, MI",
    value: "hillsdale:michigan",
  },
  {
    text: "Hinds, MS",
    value: "hinds:mississippi",
  },
  {
    text: "Hinsdale, CO",
    value: "hinsdale:colorado",
  },
  {
    text: "Hitchcock, NE",
    value: "hitchcock:nebraska",
  },
  {
    text: "Hocking, OH",
    value: "hocking:ohio",
  },
  {
    text: "Hockley, TX",
    value: "hockley:texas",
  },
  {
    text: "Hodgeman, KS",
    value: "hodgeman:kansas",
  },
  {
    text: "Hoke, NC",
    value: "hoke:north carolina",
  },
  {
    text: "Holmes, FL",
    value: "holmes:florida",
  },
  {
    text: "Holmes, MS",
    value: "holmes:mississippi",
  },
  {
    text: "Holmes, OH",
    value: "holmes:ohio",
  },
  {
    text: "Holt, MO",
    value: "holt:missouri",
  },
  {
    text: "Holt, NE",
    value: "holt:nebraska",
  },
  {
    text: "Honolulu, HI",
    value: "honolulu:hawaii",
  },
  {
    text: "Hood, TX",
    value: "hood:texas",
  },
  {
    text: "Hood River, OR",
    value: "hood river:oregon",
  },
  {
    text: "Hooker, NE",
    value: "hooker:nebraska",
  },
  {
    text: "Hoonah-Angoon, AK",
    value: "hoonah-angoon:alaska",
  },
  {
    text: "Hopewell, VA",
    value: "hopewell city:virginia",
  },
  {
    text: "Hopkins, TX",
    value: "hopkins:texas",
  },
  {
    text: "Hopkins, KY",
    value: "hopkins:kentucky",
  },
  {
    text: "Horry, SC",
    value: "horry:south carolina",
  },
  {
    text: "Hot Spring, AR",
    value: "hot spring:arkansas",
  },
  {
    text: "Hot Springs, WY",
    value: "hot springs:wyoming",
  },
  {
    text: "Houghton, MI",
    value: "houghton:michigan",
  },
  {
    text: "Houston, TX",
    value: "houston:texas",
  },
  {
    text: "Houston, AL",
    value: "houston:alabama",
  },
  {
    text: "Houston, TN",
    value: "houston:tennessee",
  },
  {
    text: "Houston, GA",
    value: "houston:georgia",
  },
  {
    text: "Houston, MN",
    value: "houston:minnesota",
  },
  {
    text: "Howard, TX",
    value: "howard:texas",
  },
  {
    text: "Howard, AR",
    value: "howard:arkansas",
  },
  {
    text: "Howard, IN",
    value: "howard:indiana",
  },
  {
    text: "Howard, MD",
    value: "howard:maryland",
  },
  {
    text: "Howard, MO",
    value: "howard:missouri",
  },
  {
    text: "Howard, IA",
    value: "howard:iowa",
  },
  {
    text: "Howard, NE",
    value: "howard:nebraska",
  },
  {
    text: "Howell, MO",
    value: "howell:missouri",
  },
  {
    text: "Hubbard, MN",
    value: "hubbard:minnesota",
  },
  {
    text: "Hudson, NJ",
    value: "hudson:new jersey",
  },
  {
    text: "Hudspeth, TX",
    value: "hudspeth:texas",
  },
  {
    text: "Huerfano, CO",
    value: "huerfano:colorado",
  },
  {
    text: "Hughes, OK",
    value: "hughes:oklahoma",
  },
  {
    text: "Hughes, SD",
    value: "hughes:south dakota",
  },
  {
    text: "Humboldt, IA",
    value: "humboldt:iowa",
  },
  {
    text: "Humboldt, CA",
    value: "humboldt:california",
  },
  {
    text: "Humboldt, NV",
    value: "humboldt:nevada",
  },
  {
    text: "Humphreys, MS",
    value: "humphreys:mississippi",
  },
  {
    text: "Humphreys, TN",
    value: "humphreys:tennessee",
  },
  {
    text: "Hunt, TX",
    value: "hunt:texas",
  },
  {
    text: "Hunterdon, NJ",
    value: "hunterdon:new jersey",
  },
  {
    text: "Huntingdon, PA",
    value: "huntingdon:pennsylvania",
  },
  {
    text: "Huntington, IN",
    value: "huntington:indiana",
  },
  {
    text: "Huron, OH",
    value: "huron:ohio",
  },
  {
    text: "Huron, MI",
    value: "huron:michigan",
  },
  {
    text: "Hutchinson, TX",
    value: "hutchinson:texas",
  },
  {
    text: "Hutchinson, SD",
    value: "hutchinson:south dakota",
  },
  {
    text: "Hyde, NC",
    value: "hyde:north carolina",
  },
  {
    text: "Hyde, SD",
    value: "hyde:south dakota",
  },
  {
    text: "Iberia, LA",
    value: "iberia:louisiana",
  },
  {
    text: "Iberville, LA",
    value: "iberville:louisiana",
  },
  {
    text: "Ida, IA",
    value: "ida:iowa",
  },
  {
    text: "Idaho, ID",
    value: "idaho:idaho",
  },
  {
    text: "Imperial, CA",
    value: "imperial:california",
  },
  {
    text: "Independence, AR",
    value: "independence:arkansas",
  },
  {
    text: "Independence, AR",
    value: "independence county:arkansas",
  },
  {
    text: "Indian River, FL",
    value: "indian river:florida",
  },
  {
    text: "Indiana, PA",
    value: "indiana:pennsylvania",
  },
  {
    text: "Ingham, MI",
    value: "ingham:michigan",
  },
  {
    text: "Inyo, CA",
    value: "inyo:california",
  },
  {
    text: "Ionia, MI",
    value: "ionia:michigan",
  },
  {
    text: "Iosco, MI",
    value: "iosco:michigan",
  },
  {
    text: "Iowa, IA",
    value: "iowa:iowa",
  },
  {
    text: "Iowa, WI",
    value: "iowa:wisconsin",
  },
  {
    text: "Iredell, NC",
    value: "iredell:north carolina",
  },
  {
    text: "Irion, TX",
    value: "irion:texas",
  },
  {
    text: "Iron, MO",
    value: "iron:missouri",
  },
  {
    text: "Iron, WI",
    value: "iron:wisconsin",
  },
  {
    text: "Iron, MI",
    value: "iron:michigan",
  },
  {
    text: "Iron, UT",
    value: "iron:utah",
  },
  {
    text: "Iroquois, IL",
    value: "iroquois:illinois",
  },
  {
    text: "Irwin, GA",
    value: "irwin:georgia",
  },
  {
    text: "Isabella, MI",
    value: "isabella:michigan",
  },
  {
    text: "Isanti, MN",
    value: "isanti:minnesota",
  },
  {
    text: "Island, WA",
    value: "island:washington",
  },
  {
    text: "Isle of Wight, VA",
    value: "isle of wight:virginia",
  },
  {
    text: "Issaquena, MS",
    value: "issaquena:mississippi",
  },
  {
    text: "Itasca, MN",
    value: "itasca:minnesota",
  },
  {
    text: "Itawamba, MS",
    value: "itawamba:mississippi",
  },
  {
    text: "Izard, AR",
    value: "izard:arkansas",
  },
  {
    text: "Jack, TX",
    value: "jack:texas",
  },
  {
    text: "Jackson, TX",
    value: "jackson:texas",
  },
  {
    text: "Jackson, AL",
    value: "jackson:alabama",
  },
  {
    text: "Jackson, WV",
    value: "jackson:west virginia",
  },
  {
    text: "Jackson, AR",
    value: "jackson:arkansas",
  },
  {
    text: "Jackson, FL",
    value: "jackson:florida",
  },
  {
    text: "Jackson, IL",
    value: "jackson:illinois",
  },
  {
    text: "Jackson, IN",
    value: "jackson:indiana",
  },
  {
    text: "Jackson, KS",
    value: "jackson:kansas",
  },
  {
    text: "Jackson, KY",
    value: "jackson:kentucky",
  },
  {
    text: "Jackson, LA",
    value: "jackson:louisiana",
  },
  {
    text: "Jackson, MO",
    value: "jackson:missouri",
  },
  {
    text: "Jackson, MS",
    value: "jackson:mississippi",
  },
  {
    text: "Jackson, NC",
    value: "jackson:north carolina",
  },
  {
    text: "Jackson, TN",
    value: "jackson:tennessee",
  },
  {
    text: "Jackson, GA",
    value: "jackson:georgia",
  },
  {
    text: "Jackson, OH",
    value: "jackson:ohio",
  },
  {
    text: "Jackson, OK",
    value: "jackson:oklahoma",
  },
  {
    text: "Jackson, IA",
    value: "jackson:iowa",
  },
  {
    text: "Jackson, MN",
    value: "jackson:minnesota",
  },
  {
    text: "Jackson, SD",
    value: "jackson:south dakota",
  },
  {
    text: "Jackson, WI",
    value: "jackson:wisconsin",
  },
  {
    text: "Jackson, MI",
    value: "jackson:michigan",
  },
  {
    text: "Jackson, CO",
    value: "jackson:colorado",
  },
  {
    text: "Jackson, OR",
    value: "jackson:oregon",
  },
  {
    text: "Jackson, TX",
    value: "jackson county:texas",
  },
  {
    text: "Jackson, AL",
    value: "jackson county:alabama",
  },
  {
    text: "Jackson, WV",
    value: "jackson county:west virginia",
  },
  {
    text: "Jackson, AR",
    value: "jackson county:arkansas",
  },
  {
    text: "Jackson, FL",
    value: "jackson county:florida",
  },
  {
    text: "Jackson, IL",
    value: "jackson county:illinois",
  },
  {
    text: "Jackson, IN",
    value: "jackson county:indiana",
  },
  {
    text: "Jackson, KS",
    value: "jackson county:kansas",
  },
  {
    text: "Jackson, KY",
    value: "jackson county:kentucky",
  },
  {
    text: "Jackson, LA",
    value: "jackson county:louisiana",
  },
  {
    text: "Jackson, MO",
    value: "jackson county:missouri",
  },
  {
    text: "Jackson, MS",
    value: "jackson county:mississippi",
  },
  {
    text: "Jackson, NC",
    value: "jackson county:north carolina",
  },
  {
    text: "Jackson, TN",
    value: "jackson county:tennessee",
  },
  {
    text: "Jackson, GA",
    value: "jackson county:georgia",
  },
  {
    text: "Jackson, OH",
    value: "jackson county:ohio",
  },
  {
    text: "Jackson, OK",
    value: "jackson county:oklahoma",
  },
  {
    text: "Jackson, IA",
    value: "jackson county:iowa",
  },
  {
    text: "Jackson, MN",
    value: "jackson county:minnesota",
  },
  {
    text: "Jackson, SD",
    value: "jackson county:south dakota",
  },
  {
    text: "Jackson, WI",
    value: "jackson county:wisconsin",
  },
  {
    text: "Jackson, MI",
    value: "jackson county:michigan",
  },
  {
    text: "Jackson, CO",
    value: "jackson county:colorado",
  },
  {
    text: "Jackson, OR",
    value: "jackson county:oregon",
  },
  {
    text: "James, VA",
    value: "james city:virginia",
  },
  {
    text: "Jasper, TX",
    value: "jasper:texas",
  },
  {
    text: "Jasper, IL",
    value: "jasper:illinois",
  },
  {
    text: "Jasper, IN",
    value: "jasper:indiana",
  },
  {
    text: "Jasper, MO",
    value: "jasper:missouri",
  },
  {
    text: "Jasper, MS",
    value: "jasper:mississippi",
  },
  {
    text: "Jasper, GA",
    value: "jasper:georgia",
  },
  {
    text: "Jasper, SC",
    value: "jasper:south carolina",
  },
  {
    text: "Jasper, IA",
    value: "jasper:iowa",
  },
  {
    text: "Jay, IN",
    value: "jay:indiana",
  },
  {
    text: "Jeff Davis, TX",
    value: "jeff davis:texas",
  },
  {
    text: "Jeff Davis, GA",
    value: "jeff davis:georgia",
  },
  {
    text: "Jefferson, TX",
    value: "jefferson:texas",
  },
  {
    text: "Jefferson, AL",
    value: "jefferson:alabama",
  },
  {
    text: "Jefferson, WV",
    value: "jefferson:west virginia",
  },
  {
    text: "Jefferson, AR",
    value: "jefferson:arkansas",
  },
  {
    text: "Jefferson, FL",
    value: "jefferson:florida",
  },
  {
    text: "Jefferson, IL",
    value: "jefferson:illinois",
  },
  {
    text: "Jefferson, IN",
    value: "jefferson:indiana",
  },
  {
    text: "Jefferson, KS",
    value: "jefferson:kansas",
  },
  {
    text: "Jefferson, KY",
    value: "jefferson:kentucky",
  },
  {
    text: "Jefferson, LA",
    value: "jefferson:louisiana",
  },
  {
    text: "Jefferson, MO",
    value: "jefferson:missouri",
  },
  {
    text: "Jefferson, MS",
    value: "jefferson:mississippi",
  },
  {
    text: "Jefferson, TN",
    value: "jefferson:tennessee",
  },
  {
    text: "Jefferson, GA",
    value: "jefferson:georgia",
  },
  {
    text: "Jefferson, OH",
    value: "jefferson:ohio",
  },
  {
    text: "Jefferson, OK",
    value: "jefferson:oklahoma",
  },
  {
    text: "Jefferson, PA",
    value: "jefferson:pennsylvania",
  },
  {
    text: "Jefferson, IA",
    value: "jefferson:iowa",
  },
  {
    text: "Jefferson, NE",
    value: "jefferson:nebraska",
  },
  {
    text: "Jefferson, NY",
    value: "jefferson:new york",
  },
  {
    text: "Jefferson, WI",
    value: "jefferson:wisconsin",
  },
  {
    text: "Jefferson, CO",
    value: "jefferson:colorado",
  },
  {
    text: "Jefferson, OR",
    value: "jefferson:oregon",
  },
  {
    text: "Jefferson, WA",
    value: "jefferson:washington",
  },
  {
    text: "Jefferson, ID",
    value: "jefferson:idaho",
  },
  {
    text: "Jefferson, MT",
    value: "jefferson:montana",
  },
  {
    text: "Jefferson Davis, LA",
    value: "jefferson davis:louisiana",
  },
  {
    text: "Jefferson Davis, MS",
    value: "jefferson davis:mississippi",
  },
  {
    text: "Jefferson, TX",
    value: "jefferson parish:texas",
  },
  {
    text: "Jefferson, AL",
    value: "jefferson parish:alabama",
  },
  {
    text: "Jefferson, WV",
    value: "jefferson parish:west virginia",
  },
  {
    text: "Jefferson, AR",
    value: "jefferson parish:arkansas",
  },
  {
    text: "Jefferson, FL",
    value: "jefferson parish:florida",
  },
  {
    text: "Jefferson, IL",
    value: "jefferson parish:illinois",
  },
  {
    text: "Jefferson, IN",
    value: "jefferson parish:indiana",
  },
  {
    text: "Jefferson, KS",
    value: "jefferson parish:kansas",
  },
  {
    text: "Jefferson, KY",
    value: "jefferson parish:kentucky",
  },
  {
    text: "Jefferson, LA",
    value: "jefferson parish:louisiana",
  },
  {
    text: "Jefferson, MO",
    value: "jefferson parish:missouri",
  },
  {
    text: "Jefferson, MS",
    value: "jefferson parish:mississippi",
  },
  {
    text: "Jefferson, TN",
    value: "jefferson parish:tennessee",
  },
  {
    text: "Jefferson, GA",
    value: "jefferson parish:georgia",
  },
  {
    text: "Jefferson, OH",
    value: "jefferson parish:ohio",
  },
  {
    text: "Jefferson, OK",
    value: "jefferson parish:oklahoma",
  },
  {
    text: "Jefferson, PA",
    value: "jefferson parish:pennsylvania",
  },
  {
    text: "Jefferson, IA",
    value: "jefferson parish:iowa",
  },
  {
    text: "Jefferson, NE",
    value: "jefferson parish:nebraska",
  },
  {
    text: "Jefferson, NY",
    value: "jefferson parish:new york",
  },
  {
    text: "Jefferson, WI",
    value: "jefferson parish:wisconsin",
  },
  {
    text: "Jefferson, CO",
    value: "jefferson parish:colorado",
  },
  {
    text: "Jefferson, OR",
    value: "jefferson parish:oregon",
  },
  {
    text: "Jefferson, WA",
    value: "jefferson parish:washington",
  },
  {
    text: "Jefferson, ID",
    value: "jefferson parish:idaho",
  },
  {
    text: "Jefferson, MT",
    value: "jefferson parish:montana",
  },
  {
    text: "Jenkins, GA",
    value: "jenkins:georgia",
  },
  {
    text: "Jennings, IN",
    value: "jennings:indiana",
  },
  {
    text: "Jerauld, SD",
    value: "jerauld:south dakota",
  },
  {
    text: "Jerome, ID",
    value: "jerome:idaho",
  },
  {
    text: "Jersey, IL",
    value: "jersey:illinois",
  },
  {
    text: "Jessamine, KY",
    value: "jessamine:kentucky",
  },
  {
    text: "Jewell, KS",
    value: "jewell:kansas",
  },
  {
    text: "Jim Hogg, TX",
    value: "jim hogg:texas",
  },
  {
    text: "Jim Wells, TX",
    value: "jim wells:texas",
  },
  {
    text: "Jo Daviess, IL",
    value: "jo daviess:illinois",
  },
  {
    text: "Johnson, TX",
    value: "johnson:texas",
  },
  {
    text: "Johnson, AR",
    value: "johnson:arkansas",
  },
  {
    text: "Johnson, IL",
    value: "johnson:illinois",
  },
  {
    text: "Johnson, IN",
    value: "johnson:indiana",
  },
  {
    text: "Johnson, KS",
    value: "johnson:kansas",
  },
  {
    text: "Johnson, KY",
    value: "johnson:kentucky",
  },
  {
    text: "Johnson, MO",
    value: "johnson:missouri",
  },
  {
    text: "Johnson, TN",
    value: "johnson:tennessee",
  },
  {
    text: "Johnson, GA",
    value: "johnson:georgia",
  },
  {
    text: "Johnson, IA",
    value: "johnson:iowa",
  },
  {
    text: "Johnson, NE",
    value: "johnson:nebraska",
  },
  {
    text: "Johnson, WY",
    value: "johnson:wyoming",
  },
  {
    text: "Johnson, TX",
    value: "johnson county:texas",
  },
  {
    text: "Johnson, AR",
    value: "johnson county:arkansas",
  },
  {
    text: "Johnson, IL",
    value: "johnson county:illinois",
  },
  {
    text: "Johnson, IN",
    value: "johnson county:indiana",
  },
  {
    text: "Johnson, KS",
    value: "johnson county:kansas",
  },
  {
    text: "Johnson, KY",
    value: "johnson county:kentucky",
  },
  {
    text: "Johnson, MO",
    value: "johnson county:missouri",
  },
  {
    text: "Johnson, TN",
    value: "johnson county:tennessee",
  },
  {
    text: "Johnson, GA",
    value: "johnson county:georgia",
  },
  {
    text: "Johnson, IA",
    value: "johnson county:iowa",
  },
  {
    text: "Johnson, NE",
    value: "johnson county:nebraska",
  },
  {
    text: "Johnson, WY",
    value: "johnson county:wyoming",
  },
  {
    text: "Johnston, NC",
    value: "johnston:north carolina",
  },
  {
    text: "Johnston, OK",
    value: "johnston:oklahoma",
  },
  {
    text: "Jones, TX",
    value: "jones:texas",
  },
  {
    text: "Jones, MS",
    value: "jones:mississippi",
  },
  {
    text: "Jones, NC",
    value: "jones:north carolina",
  },
  {
    text: "Jones, GA",
    value: "jones:georgia",
  },
  {
    text: "Jones, IA",
    value: "jones:iowa",
  },
  {
    text: "Jones, SD",
    value: "jones:south dakota",
  },
  {
    text: "Josephine, OR",
    value: "josephine:oregon",
  },
  {
    text: "Juab, UT",
    value: "juab:utah",
  },
  {
    text: "Judith Basin, MT",
    value: "judith basin:montana",
  },
  {
    text: "Juneau, WI",
    value: "juneau:wisconsin",
  },
  {
    text: "Juneau, AK",
    value: "juneau:alaska",
  },
  {
    text: "Juniata, PA",
    value: "juniata:pennsylvania",
  },
  {
    text: "Kalamazoo, MI",
    value: "kalamazoo:michigan",
  },
  {
    text: "Kalkaska, MI",
    value: "kalkaska:michigan",
  },
  {
    text: "Kanabec, MN",
    value: "kanabec:minnesota",
  },
  {
    text: "Kanawha, WV",
    value: "kanawha:west virginia",
  },
  {
    text: "Kandiyohi, MN",
    value: "kandiyohi:minnesota",
  },
  {
    text: "Kane, IL",
    value: "kane:illinois",
  },
  {
    text: "Kane, UT",
    value: "kane:utah",
  },
  {
    text: "Kankakee, IL",
    value: "kankakee:illinois",
  },
  {
    text: "Karnes, TX",
    value: "karnes:texas",
  },
  {
    text: "Kauai, HI",
    value: "kauai:hawaii",
  },
  {
    text: "Kaufman, TX",
    value: "kaufman:texas",
  },
  {
    text: "Kay, OK",
    value: "kay:oklahoma",
  },
  {
    text: "Kearney, NE",
    value: "kearney:nebraska",
  },
  {
    text: "Kearny, KS",
    value: "kearny:kansas",
  },
  {
    text: "Keith, NE",
    value: "keith:nebraska",
  },
  {
    text: "Kemper, MS",
    value: "kemper:mississippi",
  },
  {
    text: "Kenai Peninsula, AK",
    value: "kenai peninsula:alaska",
  },
  {
    text: "Kendall, TX",
    value: "kendall:texas",
  },
  {
    text: "Kendall, IL",
    value: "kendall:illinois",
  },
  {
    text: "Kenedy, TX",
    value: "kenedy:texas",
  },
  {
    text: "Kennebec, ME",
    value: "kennebec:maine",
  },
  {
    text: "Kenosha, WI",
    value: "kenosha:wisconsin",
  },
  {
    text: "Kent, TX",
    value: "kent:texas",
  },
  {
    text: "Kent, MD",
    value: "kent:maryland",
  },
  {
    text: "Kent, DE",
    value: "kent:delaware",
  },
  {
    text: "Kent, MI",
    value: "kent:michigan",
  },
  {
    text: "Kent, RI",
    value: "kent:rhode island",
  },
  {
    text: "Kent, TX",
    value: "kent county:texas",
  },
  {
    text: "Kent, MD",
    value: "kent county:maryland",
  },
  {
    text: "Kent, DE",
    value: "kent county:delaware",
  },
  {
    text: "Kent, MI",
    value: "kent county:michigan",
  },
  {
    text: "Kent, RI",
    value: "kent county:rhode island",
  },
  {
    text: "Kenton, KY",
    value: "kenton:kentucky",
  },
  {
    text: "Keokuk, IA",
    value: "keokuk:iowa",
  },
  {
    text: "Kern, CA",
    value: "kern:california",
  },
  {
    text: "Kerr, TX",
    value: "kerr:texas",
  },
  {
    text: "Kershaw, SC",
    value: "kershaw:south carolina",
  },
  {
    text: "Ketchikan Gateway, AK",
    value: "ketchikan gateway:alaska",
  },
  {
    text: "Kewaunee, WI",
    value: "kewaunee:wisconsin",
  },
  {
    text: "Keweenaw, MI",
    value: "keweenaw:michigan",
  },
  {
    text: "Keya Paha, NE",
    value: "keya paha:nebraska",
  },
  {
    text: "Kidder, ND",
    value: "kidder:north dakota",
  },
  {
    text: "Kimball, NE",
    value: "kimball:nebraska",
  },
  {
    text: "Kimble, TX",
    value: "kimble:texas",
  },
  {
    text: "King, WA",
    value: "king:washington",
  },
  {
    text: "King George, VA",
    value: "king george:virginia",
  },
  {
    text: "King William, VA",
    value: "king william:virginia",
  },
  {
    text: "King And Queen, VA",
    value: "king and queen:virginia",
  },
  {
    text: "Kingfisher, OK",
    value: "kingfisher:oklahoma",
  },
  {
    text: "Kingman, KS",
    value: "kingman:kansas",
  },
  {
    text: "Kings, NY",
    value: "kings:new york",
  },
  {
    text: "Kings, CA",
    value: "kings:california",
  },
  {
    text: "Kingsbury, SD",
    value: "kingsbury:south dakota",
  },
  {
    text: "Kinney, TX",
    value: "kinney:texas",
  },
  {
    text: "Kiowa, KS",
    value: "kiowa:kansas",
  },
  {
    text: "Kiowa, OK",
    value: "kiowa:oklahoma",
  },
  {
    text: "Kiowa, CO",
    value: "kiowa:colorado",
  },
  {
    text: "Kit Carson, CO",
    value: "kit carson:colorado",
  },
  {
    text: "Kitsap, WA",
    value: "kitsap:washington",
  },
  {
    text: "Kittitas, WA",
    value: "kittitas:washington",
  },
  {
    text: "Kittson, MN",
    value: "kittson:minnesota",
  },
  {
    text: "Klamath, OR",
    value: "klamath:oregon",
  },
  {
    text: "Kleberg, TX",
    value: "kleberg:texas",
  },
  {
    text: "Klickitat, WA",
    value: "klickitat:washington",
  },
  {
    text: "Knott, KY",
    value: "knott:kentucky",
  },
  {
    text: "Knott, KY",
    value: "knott county:kentucky",
  },
  {
    text: "Knox, TX",
    value: "knox:texas",
  },
  {
    text: "Knox, IL",
    value: "knox:illinois",
  },
  {
    text: "Knox, IN",
    value: "knox:indiana",
  },
  {
    text: "Knox, KY",
    value: "knox:kentucky",
  },
  {
    text: "Knox, MO",
    value: "knox:missouri",
  },
  {
    text: "Knox, TN",
    value: "knox:tennessee",
  },
  {
    text: "Knox, OH",
    value: "knox:ohio",
  },
  {
    text: "Knox, NE",
    value: "knox:nebraska",
  },
  {
    text: "Knox, ME",
    value: "knox:maine",
  },
  {
    text: "Kodiak Island, AK",
    value: "kodiak island:alaska",
  },
  {
    text: "Koochiching, MN",
    value: "koochiching:minnesota",
  },
  {
    text: "Kootenai, ID",
    value: "kootenai:idaho",
  },
  {
    text: "Kosciusko, IN",
    value: "kosciusko:indiana",
  },
  {
    text: "Kossuth, IA",
    value: "kossuth:iowa",
  },
  {
    text: "Kusilvak, AK",
    value: "kusilvak:alaska",
  },
  {
    text: "La Crosse, WI",
    value: "la crosse:wisconsin",
  },
  {
    text: "La Paz, AZ",
    value: "la paz:arizona",
  },
  {
    text: "La Plata, CO",
    value: "la plata:colorado",
  },
  {
    text: "LaPorte, IN",
    value: "la porte:indiana",
  },
  {
    text: "LaSalle, TX",
    value: "la salle:texas",
  },
  {
    text: "LaSalle, IL",
    value: "la salle:illinois",
  },
  {
    text: "LaSalle, LA",
    value: "la salle:louisiana",
  },
  {
    text: "LaPorte, IN",
    value: "laporte:indiana",
  },
  {
    text: "Larue, KY",
    value: "larue:kentucky",
  },
  {
    text: "LaSalle, TX",
    value: "lasalle:texas",
  },
  {
    text: "LaSalle, IL",
    value: "lasalle:illinois",
  },
  {
    text: "LaSalle, LA",
    value: "lasalle:louisiana",
  },
  {
    text: "Labette, KS",
    value: "labette:kansas",
  },
  {
    text: "Lac Qui Parle, MN",
    value: "lac qui parle:minnesota",
  },
  {
    text: "Lackawanna, PA",
    value: "lackawanna:pennsylvania",
  },
  {
    text: "Laclede, MO",
    value: "laclede:missouri",
  },
  {
    text: "Lafayette, AR",
    value: "lafayette:arkansas",
  },
  {
    text: "Lafayette, FL",
    value: "lafayette:florida",
  },
  {
    text: "Lafayette, LA",
    value: "lafayette:louisiana",
  },
  {
    text: "Lafayette, MO",
    value: "lafayette:missouri",
  },
  {
    text: "Lafayette, MS",
    value: "lafayette:mississippi",
  },
  {
    text: "Lafayette, WI",
    value: "lafayette:wisconsin",
  },
  {
    text: "Lafourche, LA",
    value: "lafourche:louisiana",
  },
  {
    text: "Lagrange, IN",
    value: "lagrange:indiana",
  },
  {
    text: "Lake, FL",
    value: "lake:florida",
  },
  {
    text: "Lake, IL",
    value: "lake:illinois",
  },
  {
    text: "Lake, IN",
    value: "lake:indiana",
  },
  {
    text: "Lake, TN",
    value: "lake:tennessee",
  },
  {
    text: "Lake, OH",
    value: "lake:ohio",
  },
  {
    text: "Lake, MN",
    value: "lake:minnesota",
  },
  {
    text: "Lake, SD",
    value: "lake:south dakota",
  },
  {
    text: "Lake, MI",
    value: "lake:michigan",
  },
  {
    text: "Lake, CA",
    value: "lake:california",
  },
  {
    text: "Lake, CO",
    value: "lake:colorado",
  },
  {
    text: "Lake, OR",
    value: "lake:oregon",
  },
  {
    text: "Lake, MT",
    value: "lake:montana",
  },
  {
    text: "Lake And Peninsula, AK",
    value: "lake and peninsula:alaska",
  },
  {
    text: "Lake of the Woods, MN",
    value: "lake of the woods:minnesota",
  },
  {
    text: "Lamar, TX",
    value: "lamar:texas",
  },
  {
    text: "Lamar, AL",
    value: "lamar:alabama",
  },
  {
    text: "Lamar, MS",
    value: "lamar:mississippi",
  },
  {
    text: "Lamar, GA",
    value: "lamar:georgia",
  },
  {
    text: "Lamb, TX",
    value: "lamb:texas",
  },
  {
    text: "Lamoille, VT",
    value: "lamoille:vermont",
  },
  {
    text: "Lamoure, ND",
    value: "lamoure:north dakota",
  },
  {
    text: "Lampasas, TX",
    value: "lampasas:texas",
  },
  {
    text: "Lancaster, VA",
    value: "lancaster:virginia",
  },
  {
    text: "Lancaster, PA",
    value: "lancaster:pennsylvania",
  },
  {
    text: "Lancaster, SC",
    value: "lancaster:south carolina",
  },
  {
    text: "Lancaster, NE",
    value: "lancaster:nebraska",
  },
  {
    text: "Lander, NV",
    value: "lander:nevada",
  },
  {
    text: "Lane, KS",
    value: "lane:kansas",
  },
  {
    text: "Lane, OR",
    value: "lane:oregon",
  },
  {
    text: "Langlade, WI",
    value: "langlade:wisconsin",
  },
  {
    text: "Lanier, GA",
    value: "lanier:georgia",
  },
  {
    text: "Lapeer, MI",
    value: "lapeer:michigan",
  },
  {
    text: "Laramie, WY",
    value: "laramie:wyoming",
  },
  {
    text: "Larimer, CO",
    value: "larimer:colorado",
  },
  {
    text: "Larue, KY",
    value: "larue:kentucky",
  },
  {
    text: "Las Animas, CO",
    value: "las animas:colorado",
  },
  {
    text: "Lassen, CA",
    value: "lassen:california",
  },
  {
    text: "Latah, ID",
    value: "latah:idaho",
  },
  {
    text: "Latimer, OK",
    value: "latimer:oklahoma",
  },
  {
    text: "Lauderdale, AL",
    value: "lauderdale:alabama",
  },
  {
    text: "Lauderdale, MS",
    value: "lauderdale:mississippi",
  },
  {
    text: "Lauderdale, TN",
    value: "lauderdale:tennessee",
  },
  {
    text: "Laurel, KY",
    value: "laurel:kentucky",
  },
  {
    text: "Laurens, GA",
    value: "laurens:georgia",
  },
  {
    text: "Laurens, SC",
    value: "laurens:south carolina",
  },
  {
    text: "Lavaca, TX",
    value: "lavaca:texas",
  },
  {
    text: "Lawrence, AL",
    value: "lawrence:alabama",
  },
  {
    text: "Lawrence, AR",
    value: "lawrence:arkansas",
  },
  {
    text: "Lawrence, IL",
    value: "lawrence:illinois",
  },
  {
    text: "Lawrence, IN",
    value: "lawrence:indiana",
  },
  {
    text: "Lawrence, KY",
    value: "lawrence:kentucky",
  },
  {
    text: "Lawrence, MO",
    value: "lawrence:missouri",
  },
  {
    text: "Lawrence, MS",
    value: "lawrence:mississippi",
  },
  {
    text: "Lawrence, TN",
    value: "lawrence:tennessee",
  },
  {
    text: "Lawrence, OH",
    value: "lawrence:ohio",
  },
  {
    text: "Lawrence, PA",
    value: "lawrence:pennsylvania",
  },
  {
    text: "Lawrence, SD",
    value: "lawrence:south dakota",
  },
  {
    text: "Leflore, MS",
    value: "le flore:mississippi",
  },
  {
    text: "Leflore, OK",
    value: "le flore:oklahoma",
  },
  {
    text: "Le Sueur, MN",
    value: "le sueur:minnesota",
  },
  {
    text: "Lea, NM",
    value: "lea:new mexico",
  },
  {
    text: "Leake, MS",
    value: "leake:mississippi",
  },
  {
    text: "Leavenworth, KS",
    value: "leavenworth:kansas",
  },
  {
    text: "Lebanon, PA",
    value: "lebanon:pennsylvania",
  },
  {
    text: "Lee, TX",
    value: "lee:texas",
  },
  {
    text: "Lee, AL",
    value: "lee:alabama",
  },
  {
    text: "Lee, VA",
    value: "lee:virginia",
  },
  {
    text: "Lee, AR",
    value: "lee:arkansas",
  },
  {
    text: "Lee, FL",
    value: "lee:florida",
  },
  {
    text: "Lee, IL",
    value: "lee:illinois",
  },
  {
    text: "Lee, KY",
    value: "lee:kentucky",
  },
  {
    text: "Lee, MS",
    value: "lee:mississippi",
  },
  {
    text: "Lee, NC",
    value: "lee:north carolina",
  },
  {
    text: "Lee, GA",
    value: "lee:georgia",
  },
  {
    text: "Lee, SC",
    value: "lee:south carolina",
  },
  {
    text: "Lee, IA",
    value: "lee:iowa",
  },
  {
    text: "Leelanau, MI",
    value: "leelanau:michigan",
  },
  {
    text: "Leflore, MS",
    value: "leflore:mississippi",
  },
  {
    text: "Leflore, OK",
    value: "leflore:oklahoma",
  },
  {
    text: "Lehigh, PA",
    value: "lehigh:pennsylvania",
  },
  {
    text: "Lemhi, ID",
    value: "lemhi:idaho",
  },
  {
    text: "Lenawee, MI",
    value: "lenawee:michigan",
  },
  {
    text: "Lenoir, NC",
    value: "lenoir:north carolina",
  },
  {
    text: "Leon, TX",
    value: "leon:texas",
  },
  {
    text: "Leon, FL",
    value: "leon:florida",
  },
  {
    text: "Leslie, KY",
    value: "leslie:kentucky",
  },
  {
    text: "Letcher, KY",
    value: "letcher:kentucky",
  },
  {
    text: "Levy, FL",
    value: "levy:florida",
  },
  {
    text: "Lewis, WV",
    value: "lewis:west virginia",
  },
  {
    text: "Lewis, KY",
    value: "lewis:kentucky",
  },
  {
    text: "Lewis, MO",
    value: "lewis:missouri",
  },
  {
    text: "Lewis, TN",
    value: "lewis:tennessee",
  },
  {
    text: "Lewis, NY",
    value: "lewis:new york",
  },
  {
    text: "Lewis, WA",
    value: "lewis:washington",
  },
  {
    text: "Lewis, ID",
    value: "lewis:idaho",
  },
  {
    text: "Lewis And Clark, MT",
    value: "lewis and clark:montana",
  },
  {
    text: "Lexington, VA",
    value: "lexington:virginia",
  },
  {
    text: "Lexington, SC",
    value: "lexington:south carolina",
  },
  {
    text: "Lexington, VA",
    value: "lexington city:virginia",
  },
  {
    text: "Lexington, SC",
    value: "lexington city:south carolina",
  },
  {
    text: "Liberty, TX",
    value: "liberty:texas",
  },
  {
    text: "Liberty, FL",
    value: "liberty:florida",
  },
  {
    text: "Liberty, GA",
    value: "liberty:georgia",
  },
  {
    text: "Liberty, MT",
    value: "liberty:montana",
  },
  {
    text: "Licking, OH",
    value: "licking:ohio",
  },
  {
    text: "Limestone, TX",
    value: "limestone:texas",
  },
  {
    text: "Limestone, AL",
    value: "limestone:alabama",
  },
  {
    text: "Lincoln, WV",
    value: "lincoln:west virginia",
  },
  {
    text: "Lincoln, AR",
    value: "lincoln:arkansas",
  },
  {
    text: "Lincoln, KS",
    value: "lincoln:kansas",
  },
  {
    text: "Lincoln, KY",
    value: "lincoln:kentucky",
  },
  {
    text: "Lincoln, LA",
    value: "lincoln:louisiana",
  },
  {
    text: "Lincoln, MO",
    value: "lincoln:missouri",
  },
  {
    text: "Lincoln, MS",
    value: "lincoln:mississippi",
  },
  {
    text: "Lincoln, NC",
    value: "lincoln:north carolina",
  },
  {
    text: "Lincoln, TN",
    value: "lincoln:tennessee",
  },
  {
    text: "Lincoln, GA",
    value: "lincoln:georgia",
  },
  {
    text: "Lincoln, OK",
    value: "lincoln:oklahoma",
  },
  {
    text: "Lincoln, MN",
    value: "lincoln:minnesota",
  },
  {
    text: "Lincoln, NE",
    value: "lincoln:nebraska",
  },
  {
    text: "Lincoln, SD",
    value: "lincoln:south dakota",
  },
  {
    text: "Lincoln, WI",
    value: "lincoln:wisconsin",
  },
  {
    text: "Lincoln, ME",
    value: "lincoln:maine",
  },
  {
    text: "Lincoln, NM",
    value: "lincoln:new mexico",
  },
  {
    text: "Lincoln, CO",
    value: "lincoln:colorado",
  },
  {
    text: "Lincoln, NV",
    value: "lincoln:nevada",
  },
  {
    text: "Lincoln, OR",
    value: "lincoln:oregon",
  },
  {
    text: "Lincoln, WA",
    value: "lincoln:washington",
  },
  {
    text: "Lincoln, ID",
    value: "lincoln:idaho",
  },
  {
    text: "Lincoln, MT",
    value: "lincoln:montana",
  },
  {
    text: "Lincoln, WY",
    value: "lincoln:wyoming",
  },
  {
    text: "Lincoln, WV",
    value: "lincoln parish:west virginia",
  },
  {
    text: "Lincoln, AR",
    value: "lincoln parish:arkansas",
  },
  {
    text: "Lincoln, KS",
    value: "lincoln parish:kansas",
  },
  {
    text: "Lincoln, KY",
    value: "lincoln parish:kentucky",
  },
  {
    text: "Lincoln, LA",
    value: "lincoln parish:louisiana",
  },
  {
    text: "Lincoln, MO",
    value: "lincoln parish:missouri",
  },
  {
    text: "Lincoln, MS",
    value: "lincoln parish:mississippi",
  },
  {
    text: "Lincoln, NC",
    value: "lincoln parish:north carolina",
  },
  {
    text: "Lincoln, TN",
    value: "lincoln parish:tennessee",
  },
  {
    text: "Lincoln, GA",
    value: "lincoln parish:georgia",
  },
  {
    text: "Lincoln, OK",
    value: "lincoln parish:oklahoma",
  },
  {
    text: "Lincoln, MN",
    value: "lincoln parish:minnesota",
  },
  {
    text: "Lincoln, NE",
    value: "lincoln parish:nebraska",
  },
  {
    text: "Lincoln, SD",
    value: "lincoln parish:south dakota",
  },
  {
    text: "Lincoln, WI",
    value: "lincoln parish:wisconsin",
  },
  {
    text: "Lincoln, ME",
    value: "lincoln parish:maine",
  },
  {
    text: "Lincoln, NM",
    value: "lincoln parish:new mexico",
  },
  {
    text: "Lincoln, CO",
    value: "lincoln parish:colorado",
  },
  {
    text: "Lincoln, NV",
    value: "lincoln parish:nevada",
  },
  {
    text: "Lincoln, OR",
    value: "lincoln parish:oregon",
  },
  {
    text: "Lincoln, WA",
    value: "lincoln parish:washington",
  },
  {
    text: "Lincoln, ID",
    value: "lincoln parish:idaho",
  },
  {
    text: "Lincoln, MT",
    value: "lincoln parish:montana",
  },
  {
    text: "Lincoln, WY",
    value: "lincoln parish:wyoming",
  },
  {
    text: "Linn, KS",
    value: "linn:kansas",
  },
  {
    text: "Linn, MO",
    value: "linn:missouri",
  },
  {
    text: "Linn, IA",
    value: "linn:iowa",
  },
  {
    text: "Linn, OR",
    value: "linn:oregon",
  },
  {
    text: "Lipscomb, TX",
    value: "lipscomb:texas",
  },
  {
    text: "Litchfield, CT",
    value: "litchfield:connecticut",
  },
  {
    text: "Little River, AR",
    value: "little river:arkansas",
  },
  {
    text: "Live Oak, TX",
    value: "live oak:texas",
  },
  {
    text: "Livingston, IL",
    value: "livingston:illinois",
  },
  {
    text: "Livingston, KY",
    value: "livingston:kentucky",
  },
  {
    text: "Livingston, LA",
    value: "livingston:louisiana",
  },
  {
    text: "Livingston, MO",
    value: "livingston:missouri",
  },
  {
    text: "Livingston, NY",
    value: "livingston:new york",
  },
  {
    text: "Livingston, MI",
    value: "livingston:michigan",
  },
  {
    text: "Livingston, IL",
    value: "livingston parish:illinois",
  },
  {
    text: "Livingston, KY",
    value: "livingston parish:kentucky",
  },
  {
    text: "Livingston, LA",
    value: "livingston parish:louisiana",
  },
  {
    text: "Livingston, MO",
    value: "livingston parish:missouri",
  },
  {
    text: "Livingston, NY",
    value: "livingston parish:new york",
  },
  {
    text: "Livingston, MI",
    value: "livingston parish:michigan",
  },
  {
    text: "Llano, TX",
    value: "llano:texas",
  },
  {
    text: "Logan, WV",
    value: "logan:west virginia",
  },
  {
    text: "Logan, AR",
    value: "logan:arkansas",
  },
  {
    text: "Logan, IL",
    value: "logan:illinois",
  },
  {
    text: "Logan, KS",
    value: "logan:kansas",
  },
  {
    text: "Logan, KY",
    value: "logan:kentucky",
  },
  {
    text: "Logan, OH",
    value: "logan:ohio",
  },
  {
    text: "Logan, OK",
    value: "logan:oklahoma",
  },
  {
    text: "Logan, NE",
    value: "logan:nebraska",
  },
  {
    text: "Logan, ND",
    value: "logan:north dakota",
  },
  {
    text: "Logan, CO",
    value: "logan:colorado",
  },
  {
    text: "Long, GA",
    value: "long:georgia",
  },
  {
    text: "Lonoke, AR",
    value: "lonoke:arkansas",
  },
  {
    text: "Lorain, OH",
    value: "lorain:ohio",
  },
  {
    text: "Los Alamos, NM",
    value: "los alamos:new mexico",
  },
  {
    text: "Los Angeles, CA",
    value: "los angeles:california",
  },
  {
    text: "Loudon, TN",
    value: "loudon:tennessee",
  },
  {
    text: "Loudoun, VA",
    value: "loudoun:virginia",
  },
  {
    text: "Louisa, VA",
    value: "louisa:virginia",
  },
  {
    text: "Louisa, IA",
    value: "louisa:iowa",
  },
  {
    text: "Loup, NE",
    value: "loup:nebraska",
  },
  {
    text: "Love, OK",
    value: "love:oklahoma",
  },
  {
    text: "Loving, TX",
    value: "loving:texas",
  },
  {
    text: "Lowndes, AL",
    value: "lowndes:alabama",
  },
  {
    text: "Lowndes, MS",
    value: "lowndes:mississippi",
  },
  {
    text: "Lowndes, GA",
    value: "lowndes:georgia",
  },
  {
    text: "Lowndes, AL",
    value: "lowndes county:alabama",
  },
  {
    text: "Lowndes, MS",
    value: "lowndes county:mississippi",
  },
  {
    text: "Lowndes, GA",
    value: "lowndes county:georgia",
  },
  {
    text: "Lubbock, TX",
    value: "lubbock:texas",
  },
  {
    text: "Lucas, OH",
    value: "lucas:ohio",
  },
  {
    text: "Lucas, IA",
    value: "lucas:iowa",
  },
  {
    text: "Luce, MI",
    value: "luce:michigan",
  },
  {
    text: "Lumpkin, GA",
    value: "lumpkin:georgia",
  },
  {
    text: "Luna, NM",
    value: "luna:new mexico",
  },
  {
    text: "Lunenburg, VA",
    value: "lunenburg:virginia",
  },
  {
    text: "Luzerne, PA",
    value: "luzerne:pennsylvania",
  },
  {
    text: "Lycoming, PA",
    value: "lycoming:pennsylvania",
  },
  {
    text: "Lyman, SD",
    value: "lyman:south dakota",
  },
  {
    text: "Lynchburg, VA",
    value: "lynchburg city:virginia",
  },
  {
    text: "Lynn, TX",
    value: "lynn:texas",
  },
  {
    text: "Lyon, KS",
    value: "lyon:kansas",
  },
  {
    text: "Lyon, KY",
    value: "lyon:kentucky",
  },
  {
    text: "Lyon, IA",
    value: "lyon:iowa",
  },
  {
    text: "Lyon, MN",
    value: "lyon:minnesota",
  },
  {
    text: "Lyon, NV",
    value: "lyon:nevada",
  },
  {
    text: "Mackinac, MI",
    value: "mackinac:michigan",
  },
  {
    text: "Macomb, MI",
    value: "macomb:michigan",
  },
  {
    text: "Macon, AL",
    value: "macon:alabama",
  },
  {
    text: "Macon, IL",
    value: "macon:illinois",
  },
  {
    text: "Macon, MO",
    value: "macon:missouri",
  },
  {
    text: "Macon, NC",
    value: "macon:north carolina",
  },
  {
    text: "Macon, TN",
    value: "macon:tennessee",
  },
  {
    text: "Macon, GA",
    value: "macon:georgia",
  },
  {
    text: "Macoupin, IL",
    value: "macoupin:illinois",
  },
  {
    text: "Madera, CA",
    value: "madera:california",
  },
  {
    text: "Madison, TX",
    value: "madison:texas",
  },
  {
    text: "Madison, AL",
    value: "madison:alabama",
  },
  {
    text: "Madison, VA",
    value: "madison:virginia",
  },
  {
    text: "Madison, AR",
    value: "madison:arkansas",
  },
  {
    text: "Madison, FL",
    value: "madison:florida",
  },
  {
    text: "Madison, IL",
    value: "madison:illinois",
  },
  {
    text: "Madison, IN",
    value: "madison:indiana",
  },
  {
    text: "Madison, KY",
    value: "madison:kentucky",
  },
  {
    text: "Madison, LA",
    value: "madison:louisiana",
  },
  {
    text: "Madison, MO",
    value: "madison:missouri",
  },
  {
    text: "Madison, MS",
    value: "madison:mississippi",
  },
  {
    text: "Madison, NC",
    value: "madison:north carolina",
  },
  {
    text: "Madison, TN",
    value: "madison:tennessee",
  },
  {
    text: "Madison, GA",
    value: "madison:georgia",
  },
  {
    text: "Madison, OH",
    value: "madison:ohio",
  },
  {
    text: "Madison, IA",
    value: "madison:iowa",
  },
  {
    text: "Madison, NE",
    value: "madison:nebraska",
  },
  {
    text: "Madison, NY",
    value: "madison:new york",
  },
  {
    text: "Madison, ID",
    value: "madison:idaho",
  },
  {
    text: "Madison, MT",
    value: "madison:montana",
  },
  {
    text: "Magoffin, KY",
    value: "magoffin:kentucky",
  },
  {
    text: "Mahaska, IA",
    value: "mahaska:iowa",
  },
  {
    text: "Mahnomen, MN",
    value: "mahnomen:minnesota",
  },
  {
    text: "Mahoning, OH",
    value: "mahoning:ohio",
  },
  {
    text: "Major, OK",
    value: "major:oklahoma",
  },
  {
    text: "Malheur, OR",
    value: "malheur:oregon",
  },
  {
    text: "Manassas, VA",
    value: "manassas city:virginia",
  },
  {
    text: "Manassas Park, VA",
    value: "manassas park city:virginia",
  },
  {
    text: "Manatee, FL",
    value: "manatee:florida",
  },
  {
    text: "Manatee, FL",
    value: "manatee county:florida",
  },
  {
    text: "Manistee, MI",
    value: "manistee:michigan",
  },
  {
    text: "Manitowoc, WI",
    value: "manitowoc:wisconsin",
  },
  {
    text: "Marathon, WI",
    value: "marathon:wisconsin",
  },
  {
    text: "Marengo, AL",
    value: "marengo:alabama",
  },
  {
    text: "Maricopa, AZ",
    value: "maricopa:arizona",
  },
  {
    text: "Maries, MO",
    value: "maries:missouri",
  },
  {
    text: "Marin, CA",
    value: "marin:california",
  },
  {
    text: "Marinette, WI",
    value: "marinette:wisconsin",
  },
  {
    text: "Marion, TX",
    value: "marion:texas",
  },
  {
    text: "Marion, AL",
    value: "marion:alabama",
  },
  {
    text: "Marion, WV",
    value: "marion:west virginia",
  },
  {
    text: "Marion, AR",
    value: "marion:arkansas",
  },
  {
    text: "Marion, FL",
    value: "marion:florida",
  },
  {
    text: "Marion, IL",
    value: "marion:illinois",
  },
  {
    text: "Marion, IN",
    value: "marion:indiana",
  },
  {
    text: "Marion, KS",
    value: "marion:kansas",
  },
  {
    text: "Marion, KY",
    value: "marion:kentucky",
  },
  {
    text: "Marion, MO",
    value: "marion:missouri",
  },
  {
    text: "Marion, MS",
    value: "marion:mississippi",
  },
  {
    text: "Marion, TN",
    value: "marion:tennessee",
  },
  {
    text: "Marion, GA",
    value: "marion:georgia",
  },
  {
    text: "Marion, OH",
    value: "marion:ohio",
  },
  {
    text: "Marion, SC",
    value: "marion:south carolina",
  },
  {
    text: "Marion, IA",
    value: "marion:iowa",
  },
  {
    text: "Marion, OR",
    value: "marion:oregon",
  },
  {
    text: "Mariposa, CA",
    value: "mariposa:california",
  },
  {
    text: "Marlboro, SC",
    value: "marlboro:south carolina",
  },
  {
    text: "Marquette, WI",
    value: "marquette:wisconsin",
  },
  {
    text: "Marquette, MI",
    value: "marquette:michigan",
  },
  {
    text: "Marshall, AL",
    value: "marshall:alabama",
  },
  {
    text: "Marshall, WV",
    value: "marshall:west virginia",
  },
  {
    text: "Marshall, IL",
    value: "marshall:illinois",
  },
  {
    text: "Marshall, IN",
    value: "marshall:indiana",
  },
  {
    text: "Marshall, KS",
    value: "marshall:kansas",
  },
  {
    text: "Marshall, KY",
    value: "marshall:kentucky",
  },
  {
    text: "Marshall, MS",
    value: "marshall:mississippi",
  },
  {
    text: "Marshall, TN",
    value: "marshall:tennessee",
  },
  {
    text: "Marshall, OK",
    value: "marshall:oklahoma",
  },
  {
    text: "Marshall, IA",
    value: "marshall:iowa",
  },
  {
    text: "Marshall, MN",
    value: "marshall:minnesota",
  },
  {
    text: "Marshall, SD",
    value: "marshall:south dakota",
  },
  {
    text: "Marshall, AL",
    value: "marshall county:alabama",
  },
  {
    text: "Marshall, WV",
    value: "marshall county:west virginia",
  },
  {
    text: "Marshall, IL",
    value: "marshall county:illinois",
  },
  {
    text: "Marshall, IN",
    value: "marshall county:indiana",
  },
  {
    text: "Marshall, KS",
    value: "marshall county:kansas",
  },
  {
    text: "Marshall, KY",
    value: "marshall county:kentucky",
  },
  {
    text: "Marshall, MS",
    value: "marshall county:mississippi",
  },
  {
    text: "Marshall, TN",
    value: "marshall county:tennessee",
  },
  {
    text: "Marshall, OK",
    value: "marshall county:oklahoma",
  },
  {
    text: "Marshall, IA",
    value: "marshall county:iowa",
  },
  {
    text: "Marshall, MN",
    value: "marshall county:minnesota",
  },
  {
    text: "Marshall, SD",
    value: "marshall county:south dakota",
  },
  {
    text: "Martin, TX",
    value: "martin:texas",
  },
  {
    text: "Martin, FL",
    value: "martin:florida",
  },
  {
    text: "Martin, IN",
    value: "martin:indiana",
  },
  {
    text: "Martin, KY",
    value: "martin:kentucky",
  },
  {
    text: "Martin, NC",
    value: "martin:north carolina",
  },
  {
    text: "Martin, MN",
    value: "martin:minnesota",
  },
  {
    text: "Martinsville, VA",
    value: "martinsville city:virginia",
  },
  {
    text: "Mason, TX",
    value: "mason:texas",
  },
  {
    text: "Mason, WV",
    value: "mason:west virginia",
  },
  {
    text: "Mason, IL",
    value: "mason:illinois",
  },
  {
    text: "Mason, KY",
    value: "mason:kentucky",
  },
  {
    text: "Mason, MI",
    value: "mason:michigan",
  },
  {
    text: "Mason, WA",
    value: "mason:washington",
  },
  {
    text: "Massac, IL",
    value: "massac:illinois",
  },
  {
    text: "Matagorda, TX",
    value: "matagorda:texas",
  },
  {
    text: "Matanuska-Susitna, AK",
    value: "matanuska susitna:alaska",
  },
  {
    text: "Matanuska-Susitna, AK",
    value: "matanuska-susitna:alaska",
  },
  {
    text: "Mathews, VA",
    value: "mathews:virginia",
  },
  {
    text: "Maui, HI",
    value: "maui:hawaii",
  },
  {
    text: "Maury, TN",
    value: "maury:tennessee",
  },
  {
    text: "Maverick, TX",
    value: "maverick:texas",
  },
  {
    text: "Mayes, OK",
    value: "mayes:oklahoma",
  },
  {
    text: "McCone, MT",
    value: "mccone:montana",
  },
  {
    text: "McCook, SD",
    value: "mccook:south dakota",
  },
  {
    text: "McCormick, SC",
    value: "mccormick:south carolina",
  },
  {
    text: "McCracken, KY",
    value: "mccracken:kentucky",
  },
  {
    text: "McCreary, KY",
    value: "mccreary:kentucky",
  },
  {
    text: "McCulloch, TX",
    value: "mcculloch:texas",
  },
  {
    text: "McCurtain, OK",
    value: "mccurtain:oklahoma",
  },
  {
    text: "McDonald, MO",
    value: "mcdonald:missouri",
  },
  {
    text: "McDonough, IL",
    value: "mcdonough:illinois",
  },
  {
    text: "McDowell, WV",
    value: "mcdowell:west virginia",
  },
  {
    text: "McDowell, NC",
    value: "mcdowell:north carolina",
  },
  {
    text: "McDuffie, GA",
    value: "mcduffie:georgia",
  },
  {
    text: "McHenry, IL",
    value: "mchenry:illinois",
  },
  {
    text: "McHenry, ND",
    value: "mchenry:north dakota",
  },
  {
    text: "McIntosh, GA",
    value: "mcintosh:georgia",
  },
  {
    text: "McIntosh, OK",
    value: "mcintosh:oklahoma",
  },
  {
    text: "McIntosh, ND",
    value: "mcintosh:north dakota",
  },
  {
    text: "McKean, PA",
    value: "mckean:pennsylvania",
  },
  {
    text: "McKenzie, ND",
    value: "mckenzie:north dakota",
  },
  {
    text: "McKinley, NM",
    value: "mckinley:new mexico",
  },
  {
    text: "McLean, IL",
    value: "mclean:illinois",
  },
  {
    text: "McLean, KY",
    value: "mclean:kentucky",
  },
  {
    text: "McLean, ND",
    value: "mclean:north dakota",
  },
  {
    text: "McLennan, TX",
    value: "mclennan:texas",
  },
  {
    text: "McLeod, MN",
    value: "mcleod:minnesota",
  },
  {
    text: "McMinn, TN",
    value: "mcminn:tennessee",
  },
  {
    text: "McMullen, TX",
    value: "mcmullen:texas",
  },
  {
    text: "McNairy, TN",
    value: "mcnairy:tennessee",
  },
  {
    text: "McPherson, KS",
    value: "mcpherson:kansas",
  },
  {
    text: "McPherson, NE",
    value: "mcpherson:nebraska",
  },
  {
    text: "McPherson, SD",
    value: "mcpherson:south dakota",
  },
  {
    text: "McClain, OK",
    value: "mcclain:oklahoma",
  },
  {
    text: "McCone, MT",
    value: "mccone:montana",
  },
  {
    text: "McDonald, MO",
    value: "mcdonald:missouri",
  },
  {
    text: "McKenzie, ND",
    value: "mckenzie:north dakota",
  },
  {
    text: "McKinley, NM",
    value: "mckinley:new mexico",
  },
  {
    text: "McLean, IL",
    value: "mclean:illinois",
  },
  {
    text: "McLean, KY",
    value: "mclean:kentucky",
  },
  {
    text: "McLean, ND",
    value: "mclean:north dakota",
  },
  {
    text: "McNairy, TN",
    value: "mcnairy:tennessee",
  },
  {
    text: "Meade, KS",
    value: "meade:kansas",
  },
  {
    text: "Meade, KY",
    value: "meade:kentucky",
  },
  {
    text: "Meade, SD",
    value: "meade:south dakota",
  },
  {
    text: "Meagher, MT",
    value: "meagher:montana",
  },
  {
    text: "Mecklenburg, VA",
    value: "mecklenburg:virginia",
  },
  {
    text: "Mecklenburg, NC",
    value: "mecklenburg:north carolina",
  },
  {
    text: "Mecosta, MI",
    value: "mecosta:michigan",
  },
  {
    text: "Medina, TX",
    value: "medina:texas",
  },
  {
    text: "Medina, OH",
    value: "medina:ohio",
  },
  {
    text: "Meeker, MN",
    value: "meeker:minnesota",
  },
  {
    text: "Meigs, TN",
    value: "meigs:tennessee",
  },
  {
    text: "Meigs, OH",
    value: "meigs:ohio",
  },
  {
    text: "Mellette, SD",
    value: "mellette:south dakota",
  },
  {
    text: "Menard, TX",
    value: "menard:texas",
  },
  {
    text: "Menard, IL",
    value: "menard:illinois",
  },
  {
    text: "Mendocino, CA",
    value: "mendocino:california",
  },
  {
    text: "Menifee, KY",
    value: "menifee:kentucky",
  },
  {
    text: "Menominee, WI",
    value: "menominee:wisconsin",
  },
  {
    text: "Menominee, MI",
    value: "menominee:michigan",
  },
  {
    text: "Merced, CA",
    value: "merced:california",
  },
  {
    text: "Mercer, WV",
    value: "mercer:west virginia",
  },
  {
    text: "Mercer, IL",
    value: "mercer:illinois",
  },
  {
    text: "Mercer, KY",
    value: "mercer:kentucky",
  },
  {
    text: "Mercer, MO",
    value: "mercer:missouri",
  },
  {
    text: "Mercer, NJ",
    value: "mercer:new jersey",
  },
  {
    text: "Mercer, OH",
    value: "mercer:ohio",
  },
  {
    text: "Mercer, PA",
    value: "mercer:pennsylvania",
  },
  {
    text: "Mercer, ND",
    value: "mercer:north dakota",
  },
  {
    text: "Meriwether, GA",
    value: "meriwether:georgia",
  },
  {
    text: "Merrick, NE",
    value: "merrick:nebraska",
  },
  {
    text: "Merrimack, NH",
    value: "merrimack:new hampshire",
  },
  {
    text: "Mesa, CO",
    value: "mesa:colorado",
  },
  {
    text: "Metcalfe, KY",
    value: "metcalfe:kentucky",
  },
  {
    text: "Miami, IN",
    value: "miami:indiana",
  },
  {
    text: "Miami, KS",
    value: "miami:kansas",
  },
  {
    text: "Miami, OH",
    value: "miami:ohio",
  },
  {
    text: "Miami-Dade, FL",
    value: "miami-dade:florida",
  },
  {
    text: "Middlesex, VA",
    value: "middlesex:virginia",
  },
  {
    text: "Middlesex, NJ",
    value: "middlesex:new jersey",
  },
  {
    text: "Middlesex, CT",
    value: "middlesex:connecticut",
  },
  {
    text: "Middlesex, MA",
    value: "middlesex:massachusetts",
  },
  {
    text: "Midland, TX",
    value: "midland:texas",
  },
  {
    text: "Midland, MI",
    value: "midland:michigan",
  },
  {
    text: "Mifflin, PA",
    value: "mifflin:pennsylvania",
  },
  {
    text: "Milam, TX",
    value: "milam:texas",
  },
  {
    text: "Millard, UT",
    value: "millard:utah",
  },
  {
    text: "Mille Lacs, MN",
    value: "mille lacs:minnesota",
  },
  {
    text: "Miller, AR",
    value: "miller:arkansas",
  },
  {
    text: "Miller, MO",
    value: "miller:missouri",
  },
  {
    text: "Miller, GA",
    value: "miller:georgia",
  },
  {
    text: "Mills, TX",
    value: "mills:texas",
  },
  {
    text: "Mills, IA",
    value: "mills:iowa",
  },
  {
    text: "Milwaukee, WI",
    value: "milwaukee:wisconsin",
  },
  {
    text: "Miner, SD",
    value: "miner:south dakota",
  },
  {
    text: "Mineral, WV",
    value: "mineral:west virginia",
  },
  {
    text: "Mineral, CO",
    value: "mineral:colorado",
  },
  {
    text: "Mineral, NV",
    value: "mineral:nevada",
  },
  {
    text: "Mineral, MT",
    value: "mineral:montana",
  },
  {
    text: "Mingo, WV",
    value: "mingo:west virginia",
  },
  {
    text: "Minidoka, ID",
    value: "minidoka:idaho",
  },
  {
    text: "Minnehaha, SD",
    value: "minnehaha:south dakota",
  },
  {
    text: "Missaukee, MI",
    value: "missaukee:michigan",
  },
  {
    text: "Mississippi, AR",
    value: "mississippi:arkansas",
  },
  {
    text: "Mississippi, MO",
    value: "mississippi:missouri",
  },
  {
    text: "Missoula, MT",
    value: "missoula:montana",
  },
  {
    text: "Mitchell, TX",
    value: "mitchell:texas",
  },
  {
    text: "Mitchell, KS",
    value: "mitchell:kansas",
  },
  {
    text: "Mitchell, NC",
    value: "mitchell:north carolina",
  },
  {
    text: "Mitchell, GA",
    value: "mitchell:georgia",
  },
  {
    text: "Mitchell, IA",
    value: "mitchell:iowa",
  },
  {
    text: "Mobile, AL",
    value: "mobile:alabama",
  },
  {
    text: "Modoc, CA",
    value: "modoc:california",
  },
  {
    text: "Moffat, CO",
    value: "moffat:colorado",
  },
  {
    text: "Mohave, AZ",
    value: "mohave:arizona",
  },
  {
    text: "Moniteau, MO",
    value: "moniteau:missouri",
  },
  {
    text: "Monmouth, NJ",
    value: "monmouth:new jersey",
  },
  {
    text: "Mono, CA",
    value: "mono:california",
  },
  {
    text: "Monona, IA",
    value: "monona:iowa",
  },
  {
    text: "Monongalia, WV",
    value: "monongalia:west virginia",
  },
  {
    text: "Monroe, AL",
    value: "monroe:alabama",
  },
  {
    text: "Monroe, WV",
    value: "monroe:west virginia",
  },
  {
    text: "Monroe, AR",
    value: "monroe:arkansas",
  },
  {
    text: "Monroe, FL",
    value: "monroe:florida",
  },
  {
    text: "Monroe, IL",
    value: "monroe:illinois",
  },
  {
    text: "Monroe, IN",
    value: "monroe:indiana",
  },
  {
    text: "Monroe, KY",
    value: "monroe:kentucky",
  },
  {
    text: "Monroe, MO",
    value: "monroe:missouri",
  },
  {
    text: "Monroe, MS",
    value: "monroe:mississippi",
  },
  {
    text: "Monroe, TN",
    value: "monroe:tennessee",
  },
  {
    text: "Monroe, GA",
    value: "monroe:georgia",
  },
  {
    text: "Monroe, OH",
    value: "monroe:ohio",
  },
  {
    text: "Monroe, PA",
    value: "monroe:pennsylvania",
  },
  {
    text: "Monroe, IA",
    value: "monroe:iowa",
  },
  {
    text: "Monroe, NY",
    value: "monroe:new york",
  },
  {
    text: "Monroe, WI",
    value: "monroe:wisconsin",
  },
  {
    text: "Monroe, MI",
    value: "monroe:michigan",
  },
  {
    text: "Montague, TX",
    value: "montague:texas",
  },
  {
    text: "Montcalm, MI",
    value: "montcalm:michigan",
  },
  {
    text: "Monterey, CA",
    value: "monterey:california",
  },
  {
    text: "Montezuma, CO",
    value: "montezuma:colorado",
  },
  {
    text: "Montgomery, TX",
    value: "montgomery:texas",
  },
  {
    text: "Montgomery, AL",
    value: "montgomery:alabama",
  },
  {
    text: "Montgomery, VA",
    value: "montgomery:virginia",
  },
  {
    text: "Montgomery, AR",
    value: "montgomery:arkansas",
  },
  {
    text: "Montgomery, IL",
    value: "montgomery:illinois",
  },
  {
    text: "Montgomery, IN",
    value: "montgomery:indiana",
  },
  {
    text: "Montgomery, KS",
    value: "montgomery:kansas",
  },
  {
    text: "Montgomery, KY",
    value: "montgomery:kentucky",
  },
  {
    text: "Montgomery, MD",
    value: "montgomery:maryland",
  },
  {
    text: "Montgomery, MO",
    value: "montgomery:missouri",
  },
  {
    text: "Montgomery, MS",
    value: "montgomery:mississippi",
  },
  {
    text: "Montgomery, NC",
    value: "montgomery:north carolina",
  },
  {
    text: "Montgomery, TN",
    value: "montgomery:tennessee",
  },
  {
    text: "Montgomery, GA",
    value: "montgomery:georgia",
  },
  {
    text: "Montgomery, OH",
    value: "montgomery:ohio",
  },
  {
    text: "Montgomery, PA",
    value: "montgomery:pennsylvania",
  },
  {
    text: "Montgomery, IA",
    value: "montgomery:iowa",
  },
  {
    text: "Montgomery, NY",
    value: "montgomery:new york",
  },
  {
    text: "Montmorency, MI",
    value: "montmorency:michigan",
  },
  {
    text: "Montour, PA",
    value: "montour:pennsylvania",
  },
  {
    text: "Montrose, CO",
    value: "montrose:colorado",
  },
  {
    text: "Moody, SD",
    value: "moody:south dakota",
  },
  {
    text: "Moore, TX",
    value: "moore:texas",
  },
  {
    text: "Moore, NC",
    value: "moore:north carolina",
  },
  {
    text: "Moore, TN",
    value: "moore:tennessee",
  },
  {
    text: "Mora, NM",
    value: "mora:new mexico",
  },
  {
    text: "Morehouse, LA",
    value: "morehouse:louisiana",
  },
  {
    text: "Morgan, AL",
    value: "morgan:alabama",
  },
  {
    text: "Morgan, WV",
    value: "morgan:west virginia",
  },
  {
    text: "Morgan, IL",
    value: "morgan:illinois",
  },
  {
    text: "Morgan, IN",
    value: "morgan:indiana",
  },
  {
    text: "Morgan, KY",
    value: "morgan:kentucky",
  },
  {
    text: "Morgan, MO",
    value: "morgan:missouri",
  },
  {
    text: "Morgan, TN",
    value: "morgan:tennessee",
  },
  {
    text: "Morgan, GA",
    value: "morgan:georgia",
  },
  {
    text: "Morgan, OH",
    value: "morgan:ohio",
  },
  {
    text: "Morgan, CO",
    value: "morgan:colorado",
  },
  {
    text: "Morgan, UT",
    value: "morgan:utah",
  },
  {
    text: "Morrill, NE",
    value: "morrill:nebraska",
  },
  {
    text: "Morris, TX",
    value: "morris:texas",
  },
  {
    text: "Morris, KS",
    value: "morris:kansas",
  },
  {
    text: "Morris, NJ",
    value: "morris:new jersey",
  },
  {
    text: "Morris, TX",
    value: "morris county:texas",
  },
  {
    text: "Morris, KS",
    value: "morris county:kansas",
  },
  {
    text: "Morris, NJ",
    value: "morris county:new jersey",
  },
  {
    text: "Morrison, MN",
    value: "morrison:minnesota",
  },
  {
    text: "Morrow, OH",
    value: "morrow:ohio",
  },
  {
    text: "Morrow, OR",
    value: "morrow:oregon",
  },
  {
    text: "Morton, KS",
    value: "morton:kansas",
  },
  {
    text: "Morton, ND",
    value: "morton:north dakota",
  },
  {
    text: "Motley, TX",
    value: "motley:texas",
  },
  {
    text: "Moultrie, IL",
    value: "moultrie:illinois",
  },
  {
    text: "Mountrail, ND",
    value: "mountrail:north dakota",
  },
  {
    text: "Mower, MN",
    value: "mower:minnesota",
  },
  {
    text: "Muhlenberg, KY",
    value: "muhlenberg:kentucky",
  },
  {
    text: "Multnomah, OR",
    value: "multnomah:oregon",
  },
  {
    text: "Murray, GA",
    value: "murray:georgia",
  },
  {
    text: "Murray, OK",
    value: "murray:oklahoma",
  },
  {
    text: "Murray, MN",
    value: "murray:minnesota",
  },
  {
    text: "Muscatine, IA",
    value: "muscatine:iowa",
  },
  {
    text: "Muscogee, GA",
    value: "muscogee:georgia",
  },
  {
    text: "Muskegon, MI",
    value: "muskegon:michigan",
  },
  {
    text: "Muskingum, OH",
    value: "muskingum:ohio",
  },
  {
    text: "Muskogee, OK",
    value: "muskogee:oklahoma",
  },
  {
    text: "Musselshell, MT",
    value: "musselshell:montana",
  },
  {
    text: "Nacogdoches, TX",
    value: "nacogdoches:texas",
  },
  {
    text: "Nance, NE",
    value: "nance:nebraska",
  },
  {
    text: "Nantucket, MA",
    value: "nantucket:massachusetts",
  },
  {
    text: "Napa, CA",
    value: "napa:california",
  },
  {
    text: "Nash, NC",
    value: "nash:north carolina",
  },
  {
    text: "Nassau, FL",
    value: "nassau:florida",
  },
  {
    text: "Nassau, NY",
    value: "nassau:new york",
  },
  {
    text: "Natchitoches, LA",
    value: "natchitoches:louisiana",
  },
  {
    text: "Natchitoches, LA",
    value: "natchitoches parish:louisiana",
  },
  {
    text: "Natrona, WY",
    value: "natrona:wyoming",
  },
  {
    text: "Navajo, AZ",
    value: "navajo:arizona",
  },
  {
    text: "Navarro, TX",
    value: "navarro:texas",
  },
  {
    text: "Nelson, VA",
    value: "nelson:virginia",
  },
  {
    text: "Nelson, KY",
    value: "nelson:kentucky",
  },
  {
    text: "Nelson, ND",
    value: "nelson:north dakota",
  },
  {
    text: "Nemaha, KS",
    value: "nemaha:kansas",
  },
  {
    text: "Nemaha, NE",
    value: "nemaha:nebraska",
  },
  {
    text: "Neosho, KS",
    value: "neosho:kansas",
  },
  {
    text: "Neshoba, MS",
    value: "neshoba:mississippi",
  },
  {
    text: "Ness, KS",
    value: "ness:kansas",
  },
  {
    text: "Nevada, AR",
    value: "nevada:arkansas",
  },
  {
    text: "Nevada, CA",
    value: "nevada:california",
  },
  {
    text: "New Castle, DE",
    value: "new castle:delaware",
  },
  {
    text: "New Hanover, NC",
    value: "new hanover:north carolina",
  },
  {
    text: "New Haven, CT",
    value: "new haven:connecticut",
  },
  {
    text: "New Kent, VA",
    value: "new kent:virginia",
  },
  {
    text: "New London, CT",
    value: "new london:connecticut",
  },
  {
    text: "New Madrid, MO",
    value: "new madrid:missouri",
  },
  {
    text: "New York, NY",
    value: "new york:new york",
  },
  {
    text: "Newaygo, MI",
    value: "newaygo:michigan",
  },
  {
    text: "Newberry, SC",
    value: "newberry:south carolina",
  },
  {
    text: "Newport, RI",
    value: "newport:rhode island",
  },
  {
    text: "Newport News, VA",
    value: "newport news city:virginia",
  },
  {
    text: "Newport News, VA",
    value: "newport news city:virginia",
  },
  {
    text: "Newton, TX",
    value: "newton:texas",
  },
  {
    text: "Newton, AR",
    value: "newton:arkansas",
  },
  {
    text: "Newton, IN",
    value: "newton:indiana",
  },
  {
    text: "Newton, MO",
    value: "newton:missouri",
  },
  {
    text: "Newton, MS",
    value: "newton:mississippi",
  },
  {
    text: "Newton, GA",
    value: "newton:georgia",
  },
  {
    text: "Nez Perce, ID",
    value: "nez perce:idaho",
  },
  {
    text: "Niagara, NY",
    value: "niagara:new york",
  },
  {
    text: "Nicholas, WV",
    value: "nicholas:west virginia",
  },
  {
    text: "Nicholas, KY",
    value: "nicholas:kentucky",
  },
  {
    text: "Nicollet, MN",
    value: "nicollet:minnesota",
  },
  {
    text: "Niobrara, WY",
    value: "niobrara:wyoming",
  },
  {
    text: "Noble, IN",
    value: "noble:indiana",
  },
  {
    text: "Noble, OH",
    value: "noble:ohio",
  },
  {
    text: "Noble, OK",
    value: "noble:oklahoma",
  },
  {
    text: "Nobles, MN",
    value: "nobles:minnesota",
  },
  {
    text: "Nodaway, MO",
    value: "nodaway:missouri",
  },
  {
    text: "Nolan, TX",
    value: "nolan:texas",
  },
  {
    text: "Nome, AK",
    value: "nome:alaska",
  },
  {
    text: "Norfolk, VA",
    value: "norfolk:virginia",
  },
  {
    text: "Norfolk, MA",
    value: "norfolk:massachusetts",
  },
  {
    text: "Norfolk, VA",
    value: "norfolk city:virginia",
  },
  {
    text: "Norfolk, MA",
    value: "norfolk city:massachusetts",
  },
  {
    text: "Norman, MN",
    value: "norman:minnesota",
  },
  {
    text: "North Slope, AK",
    value: "north slope:alaska",
  },
  {
    text: "Northampton, VA",
    value: "northampton:virginia",
  },
  {
    text: "Northampton, NC",
    value: "northampton:north carolina",
  },
  {
    text: "Northampton, PA",
    value: "northampton:pennsylvania",
  },
  {
    text: "Northumberland, VA",
    value: "northumberland:virginia",
  },
  {
    text: "Northumberland, PA",
    value: "northumberland:pennsylvania",
  },
  {
    text: "Northwest Arctic, AK",
    value: "northwest arctic:alaska",
  },
  {
    text: "Norton, VA",
    value: "norton:virginia",
  },
  {
    text: "Norton, KS",
    value: "norton:kansas",
  },
  {
    text: "Norton, VA",
    value: "norton city:virginia",
  },
  {
    text: "Norton, KS",
    value: "norton city:kansas",
  },
  {
    text: "Nottoway, VA",
    value: "nottoway:virginia",
  },
  {
    text: "Nowata, OK",
    value: "nowata:oklahoma",
  },
  {
    text: "Noxubee, MS",
    value: "noxubee:mississippi",
  },
  {
    text: "Nuckolls, NE",
    value: "nuckolls:nebraska",
  },
  {
    text: "Nueces, TX",
    value: "nueces:texas",
  },
  {
    text: "Nye, NV",
    value: "nye:nevada",
  },
  {
    text: "Oakland, MI",
    value: "oakland:michigan",
  },
  {
    text: "Obion, TN",
    value: "obion:tennessee",
  },
  {
    text: "Obrien, IA",
    value: "obrien:iowa",
  },
  {
    text: "Ocean, NJ",
    value: "ocean:new jersey",
  },
  {
    text: "Oceana, MI",
    value: "oceana:michigan",
  },
  {
    text: "Ochiltree, TX",
    value: "ochiltree:texas",
  },
  {
    text: "Oconee, GA",
    value: "oconee:georgia",
  },
  {
    text: "Oconee, SC",
    value: "oconee:south carolina",
  },
  {
    text: "Oconto, WI",
    value: "oconto:wisconsin",
  },
  {
    text: "Ogemaw, MI",
    value: "ogemaw:michigan",
  },
  {
    text: "Oglala Lakota, SD",
    value: "oglala lakota:south dakota",
  },
  {
    text: "Ogle, IL",
    value: "ogle:illinois",
  },
  {
    text: "Oglethorpe, GA",
    value: "oglethorpe:georgia",
  },
  {
    text: "Ohio, WV",
    value: "ohio:west virginia",
  },
  {
    text: "Ohio, IN",
    value: "ohio:indiana",
  },
  {
    text: "Ohio, KY",
    value: "ohio:kentucky",
  },
  {
    text: "Okaloosa, FL",
    value: "okaloosa:florida",
  },
  {
    text: "Okanogan, WA",
    value: "okanogan:washington",
  },
  {
    text: "Okeechobee, FL",
    value: "okeechobee:florida",
  },
  {
    text: "Okfuskee, OK",
    value: "okfuskee:oklahoma",
  },
  {
    text: "Oklahoma, OK",
    value: "oklahoma:oklahoma",
  },
  {
    text: "Okmulgee, OK",
    value: "okmulgee:oklahoma",
  },
  {
    text: "Oktibbeha, MS",
    value: "oktibbeha:mississippi",
  },
  {
    text: "Oldham, TX",
    value: "oldham:texas",
  },
  {
    text: "Oldham, KY",
    value: "oldham:kentucky",
  },
  {
    text: "Oliver, ND",
    value: "oliver:north dakota",
  },
  {
    text: "Olmsted, MN",
    value: "olmsted:minnesota",
  },
  {
    text: "Oneida, NY",
    value: "oneida:new york",
  },
  {
    text: "Oneida, WI",
    value: "oneida:wisconsin",
  },
  {
    text: "Oneida, ID",
    value: "oneida:idaho",
  },
  {
    text: "Onondaga, NY",
    value: "onondaga:new york",
  },
  {
    text: "Onslow, NC",
    value: "onslow:north carolina",
  },
  {
    text: "Ontario, NY",
    value: "ontario:new york",
  },
  {
    text: "Ontonagon, MI",
    value: "ontonagon:michigan",
  },
  {
    text: "Orange, TX",
    value: "orange:texas",
  },
  {
    text: "Orange, VA",
    value: "orange:virginia",
  },
  {
    text: "Orange, FL",
    value: "orange:florida",
  },
  {
    text: "Orange, IN",
    value: "orange:indiana",
  },
  {
    text: "Orange, NC",
    value: "orange:north carolina",
  },
  {
    text: "Orange, NY",
    value: "orange:new york",
  },
  {
    text: "Orange, VT",
    value: "orange:vermont",
  },
  {
    text: "Orange, CA",
    value: "orange:california",
  },
  {
    text: "Orangeburg, SC",
    value: "orangeburg:south carolina",
  },
  {
    text: "Oregon, MO",
    value: "oregon:missouri",
  },
  {
    text: "Orleans, LA",
    value: "orleans:louisiana",
  },
  {
    text: "Orleans, NY",
    value: "orleans:new york",
  },
  {
    text: "Orleans, VT",
    value: "orleans:vermont",
  },
  {
    text: "Osage, KS",
    value: "osage:kansas",
  },
  {
    text: "Osage, MO",
    value: "osage:missouri",
  },
  {
    text: "Osage, OK",
    value: "osage:oklahoma",
  },
  {
    text: "Osborne, KS",
    value: "osborne:kansas",
  },
  {
    text: "Osceola, FL",
    value: "osceola:florida",
  },
  {
    text: "Osceola, IA",
    value: "osceola:iowa",
  },
  {
    text: "Osceola, MI",
    value: "osceola:michigan",
  },
  {
    text: "Oscoda, MI",
    value: "oscoda:michigan",
  },
  {
    text: "Oswego, NY",
    value: "oswego:new york",
  },
  {
    text: "Otero, NM",
    value: "otero:new mexico",
  },
  {
    text: "Otero, CO",
    value: "otero:colorado",
  },
  {
    text: "Otoe, NE",
    value: "otoe:nebraska",
  },
  {
    text: "Otsego, NY",
    value: "otsego:new york",
  },
  {
    text: "Otsego, MI",
    value: "otsego:michigan",
  },
  {
    text: "Ottawa, KS",
    value: "ottawa:kansas",
  },
  {
    text: "Ottawa, OH",
    value: "ottawa:ohio",
  },
  {
    text: "Ottawa, OK",
    value: "ottawa:oklahoma",
  },
  {
    text: "Ottawa, MI",
    value: "ottawa:michigan",
  },
  {
    text: "Otter Tail, MN",
    value: "otter tail:minnesota",
  },
  {
    text: "Ouachita, AR",
    value: "ouachita:arkansas",
  },
  {
    text: "Ouachita, LA",
    value: "ouachita:louisiana",
  },
  {
    text: "Ouachita, AR",
    value: "ouachita parish:arkansas",
  },
  {
    text: "Ouachita, LA",
    value: "ouachita parish:louisiana",
  },
  {
    text: "Ouray, CO",
    value: "ouray:colorado",
  },
  {
    text: "Outagamie, WI",
    value: "outagamie:wisconsin",
  },
  {
    text: "Overton, TN",
    value: "overton:tennessee",
  },
  {
    text: "Owen, IN",
    value: "owen:indiana",
  },
  {
    text: "Owen, KY",
    value: "owen:kentucky",
  },
  {
    text: "Owsley, KY",
    value: "owsley:kentucky",
  },
  {
    text: "Owyhee, ID",
    value: "owyhee:idaho",
  },
  {
    text: "Oxford, ME",
    value: "oxford:maine",
  },
  {
    text: "Ozark, MO",
    value: "ozark:missouri",
  },
  {
    text: "Ozaukee, WI",
    value: "ozaukee:wisconsin",
  },
  {
    text: "Pacific, WA",
    value: "pacific:washington",
  },
  {
    text: "Page, VA",
    value: "page:virginia",
  },
  {
    text: "Page, IA",
    value: "page:iowa",
  },
  {
    text: "Palm Beach, FL",
    value: "palm beach:florida",
  },
  {
    text: "Palo Alto, IA",
    value: "palo alto:iowa",
  },
  {
    text: "Palo Pinto, TX",
    value: "palo pinto:texas",
  },
  {
    text: "Pamlico, NC",
    value: "pamlico:north carolina",
  },
  {
    text: "Panola, TX",
    value: "panola:texas",
  },
  {
    text: "Panola, MS",
    value: "panola:mississippi",
  },
  {
    text: "Park, CO",
    value: "park:colorado",
  },
  {
    text: "Park, MT",
    value: "park:montana",
  },
  {
    text: "Park, WY",
    value: "park:wyoming",
  },
  {
    text: "Parke, IN",
    value: "parke:indiana",
  },
  {
    text: "Parker, TX",
    value: "parker:texas",
  },
  {
    text: "Parmer, TX",
    value: "parmer:texas",
  },
  {
    text: "Pasco, FL",
    value: "pasco:florida",
  },
  {
    text: "Pasquotank, NC",
    value: "pasquotank:north carolina",
  },
  {
    text: "Passaic, NJ",
    value: "passaic:new jersey",
  },
  {
    text: "Patrick, VA",
    value: "patrick:virginia",
  },
  {
    text: "Paulding, GA",
    value: "paulding:georgia",
  },
  {
    text: "Paulding, OH",
    value: "paulding:ohio",
  },
  {
    text: "Pawnee, KS",
    value: "pawnee:kansas",
  },
  {
    text: "Pawnee, OK",
    value: "pawnee:oklahoma",
  },
  {
    text: "Pawnee, NE",
    value: "pawnee:nebraska",
  },
  {
    text: "Payette, ID",
    value: "payette:idaho",
  },
  {
    text: "Payne, OK",
    value: "payne:oklahoma",
  },
  {
    text: "Peach, GA",
    value: "peach:georgia",
  },
  {
    text: "Pearl River, MS",
    value: "pearl river:mississippi",
  },
  {
    text: "Pecos, TX",
    value: "pecos:texas",
  },
  {
    text: "Pembina, ND",
    value: "pembina:north dakota",
  },
  {
    text: "Pemiscot, MO",
    value: "pemiscot:missouri",
  },
  {
    text: "Pend Oreille, WA",
    value: "pend oreille:washington",
  },
  {
    text: "Pender, NC",
    value: "pender:north carolina",
  },
  {
    text: "Pendleton, WV",
    value: "pendleton:west virginia",
  },
  {
    text: "Pendleton, KY",
    value: "pendleton:kentucky",
  },
  {
    text: "Pennington, MN",
    value: "pennington:minnesota",
  },
  {
    text: "Pennington, SD",
    value: "pennington:south dakota",
  },
  {
    text: "Penobscot, ME",
    value: "penobscot:maine",
  },
  {
    text: "Peoria, IL",
    value: "peoria:illinois",
  },
  {
    text: "Pepin, WI",
    value: "pepin:wisconsin",
  },
  {
    text: "Perkins, NE",
    value: "perkins:nebraska",
  },
  {
    text: "Perkins, SD",
    value: "perkins:south dakota",
  },
  {
    text: "Perquimans, NC",
    value: "perquimans:north carolina",
  },
  {
    text: "Perry, AL",
    value: "perry:alabama",
  },
  {
    text: "Perry, AR",
    value: "perry:arkansas",
  },
  {
    text: "Perry, IL",
    value: "perry:illinois",
  },
  {
    text: "Perry, IN",
    value: "perry:indiana",
  },
  {
    text: "Perry, KY",
    value: "perry:kentucky",
  },
  {
    text: "Perry, MO",
    value: "perry:missouri",
  },
  {
    text: "Perry, MS",
    value: "perry:mississippi",
  },
  {
    text: "Perry, TN",
    value: "perry:tennessee",
  },
  {
    text: "Perry, OH",
    value: "perry:ohio",
  },
  {
    text: "Perry, PA",
    value: "perry:pennsylvania",
  },
  {
    text: "Pershing, NV",
    value: "pershing:nevada",
  },
  {
    text: "Person, NC",
    value: "person:north carolina",
  },
  {
    text: "Petersburg, VA",
    value: "petersburg borough:virginia",
  },
  {
    text: "Petersburg, AK",
    value: "petersburg borough:alaska",
  },
  {
    text: "Petersburg, VA",
    value: "petersburg city:virginia",
  },
  {
    text: "Petersburg, AK",
    value: "petersburg city:alaska",
  },
  {
    text: "Petroleum, MT",
    value: "petroleum:montana",
  },
  {
    text: "Pettis, MO",
    value: "pettis:missouri",
  },
  {
    text: "Phelps, MO",
    value: "phelps:missouri",
  },
  {
    text: "Phelps, NE",
    value: "phelps:nebraska",
  },
  {
    text: "Philadelphia, PA",
    value: "philadelphia:pennsylvania",
  },
  {
    text: "Phillips, AR",
    value: "phillips:arkansas",
  },
  {
    text: "Phillips, KS",
    value: "phillips:kansas",
  },
  {
    text: "Phillips, CO",
    value: "phillips:colorado",
  },
  {
    text: "Phillips, MT",
    value: "phillips:montana",
  },
  {
    text: "Piatt, IL",
    value: "piatt:illinois",
  },
  {
    text: "Piatt, IL",
    value: "piatt county:illinois",
  },
  {
    text: "Pickaway, OH",
    value: "pickaway:ohio",
  },
  {
    text: "Pickens, AL",
    value: "pickens:alabama",
  },
  {
    text: "Pickens, GA",
    value: "pickens:georgia",
  },
  {
    text: "Pickens, SC",
    value: "pickens:south carolina",
  },
  {
    text: "Pickett, TN",
    value: "pickett:tennessee",
  },
  {
    text: "Pierce, GA",
    value: "pierce:georgia",
  },
  {
    text: "Pierce, NE",
    value: "pierce:nebraska",
  },
  {
    text: "Pierce, WI",
    value: "pierce:wisconsin",
  },
  {
    text: "Pierce, ND",
    value: "pierce:north dakota",
  },
  {
    text: "Pierce, WA",
    value: "pierce:washington",
  },
  {
    text: "Pike, AL",
    value: "pike:alabama",
  },
  {
    text: "Pike, AR",
    value: "pike:arkansas",
  },
  {
    text: "Pike, IL",
    value: "pike:illinois",
  },
  {
    text: "Pike, IN",
    value: "pike:indiana",
  },
  {
    text: "Pike, KY",
    value: "pike:kentucky",
  },
  {
    text: "Pike, MO",
    value: "pike:missouri",
  },
  {
    text: "Pike, MS",
    value: "pike:mississippi",
  },
  {
    text: "Pike, GA",
    value: "pike:georgia",
  },
  {
    text: "Pike, OH",
    value: "pike:ohio",
  },
  {
    text: "Pike, PA",
    value: "pike:pennsylvania",
  },
  {
    text: "Pima, AZ",
    value: "pima:arizona",
  },
  {
    text: "Pinal, AZ",
    value: "pinal:arizona",
  },
  {
    text: "Pine, MN",
    value: "pine:minnesota",
  },
  {
    text: "Pinellas, FL",
    value: "pinellas:florida",
  },
  {
    text: "Pipestone, MN",
    value: "pipestone:minnesota",
  },
  {
    text: "Piscataquis, ME",
    value: "piscataquis:maine",
  },
  {
    text: "Pitkin, CO",
    value: "pitkin:colorado",
  },
  {
    text: "Pitt, NC",
    value: "pitt:north carolina",
  },
  {
    text: "Pittsburg, OK",
    value: "pittsburg:oklahoma",
  },
  {
    text: "Pittsylvania, VA",
    value: "pittsylvania:virginia",
  },
  {
    text: "Piute, UT",
    value: "piute:utah",
  },
  {
    text: "Placer, CA",
    value: "placer:california",
  },
  {
    text: "Plaquemines, LA",
    value: "plaquemines:louisiana",
  },
  {
    text: "Platte, MO",
    value: "platte:missouri",
  },
  {
    text: "Platte, NE",
    value: "platte:nebraska",
  },
  {
    text: "Platte, WY",
    value: "platte:wyoming",
  },
  {
    text: "Pleasants, WV",
    value: "pleasants:west virginia",
  },
  {
    text: "Plumas, CA",
    value: "plumas:california",
  },
  {
    text: "Plymouth, IA",
    value: "plymouth:iowa",
  },
  {
    text: "Plymouth, MA",
    value: "plymouth:massachusetts",
  },
  {
    text: "Pocahontas, WV",
    value: "pocahontas:west virginia",
  },
  {
    text: "Pocahontas, IA",
    value: "pocahontas:iowa",
  },
  {
    text: "Poinsett, AR",
    value: "poinsett:arkansas",
  },
  {
    text: "Pointe Coupee, LA",
    value: "pointe coupee:louisiana",
  },
  {
    text: "Pointe Coupee, LA",
    value: "pointe coupee parish:louisiana",
  },
  {
    text: "Polk, TX",
    value: "polk:texas",
  },
  {
    text: "Polk, AR",
    value: "polk:arkansas",
  },
  {
    text: "Polk, FL",
    value: "polk:florida",
  },
  {
    text: "Polk, MO",
    value: "polk:missouri",
  },
  {
    text: "Polk, NC",
    value: "polk:north carolina",
  },
  {
    text: "Polk, TN",
    value: "polk:tennessee",
  },
  {
    text: "Polk, GA",
    value: "polk:georgia",
  },
  {
    text: "Polk, IA",
    value: "polk:iowa",
  },
  {
    text: "Polk, MN",
    value: "polk:minnesota",
  },
  {
    text: "Polk, NE",
    value: "polk:nebraska",
  },
  {
    text: "Polk, WI",
    value: "polk:wisconsin",
  },
  {
    text: "Polk, OR",
    value: "polk:oregon",
  },
  {
    text: "Pondera, MT",
    value: "pondera:montana",
  },
  {
    text: "Pontotoc, MS",
    value: "pontotoc:mississippi",
  },
  {
    text: "Pontotoc, OK",
    value: "pontotoc:oklahoma",
  },
  {
    text: "Pope, AR",
    value: "pope:arkansas",
  },
  {
    text: "Pope, IL",
    value: "pope:illinois",
  },
  {
    text: "Pope, MN",
    value: "pope:minnesota",
  },
  {
    text: "Poquoson, VA",
    value: "poquoson city:virginia",
  },
  {
    text: "Portage, OH",
    value: "portage:ohio",
  },
  {
    text: "Portage, WI",
    value: "portage:wisconsin",
  },
  {
    text: "Porter, IN",
    value: "porter:indiana",
  },
  {
    text: "Portsmouth, VA",
    value: "portsmouth city:virginia",
  },
  {
    text: "Posey, IN",
    value: "posey:indiana",
  },
  {
    text: "Pottawatomie, KS",
    value: "pottawatomie:kansas",
  },
  {
    text: "Pottawatomie, OK",
    value: "pottawatomie:oklahoma",
  },
  {
    text: "Pottawattamie, IA",
    value: "pottawattamie:iowa",
  },
  {
    text: "Potter, TX",
    value: "potter:texas",
  },
  {
    text: "Potter, PA",
    value: "potter:pennsylvania",
  },
  {
    text: "Potter, SD",
    value: "potter:south dakota",
  },
  {
    text: "Powder River, MT",
    value: "powder river:montana",
  },
  {
    text: "Powell, KY",
    value: "powell:kentucky",
  },
  {
    text: "Powell, MT",
    value: "powell:montana",
  },
  {
    text: "Power, ID",
    value: "power:idaho",
  },
  {
    text: "Poweshiek, IA",
    value: "poweshiek:iowa",
  },
  {
    text: "Powhatan, VA",
    value: "powhatan:virginia",
  },
  {
    text: "Prairie, AR",
    value: "prairie:arkansas",
  },
  {
    text: "Prairie, MT",
    value: "prairie:montana",
  },
  {
    text: "Pratt, KS",
    value: "pratt:kansas",
  },
  {
    text: "Preble, OH",
    value: "preble:ohio",
  },
  {
    text: "Prentiss, MS",
    value: "prentiss:mississippi",
  },
  {
    text: "Presidio, TX",
    value: "presidio:texas",
  },
  {
    text: "Presque Isle, MI",
    value: "presque isle:michigan",
  },
  {
    text: "Preston, WV",
    value: "preston:west virginia",
  },
  {
    text: "Price, WI",
    value: "price:wisconsin",
  },
  {
    text: "Prince Edward, VA",
    value: "prince edward:virginia",
  },
  {
    text: "Prince George, VA",
    value: "prince george:virginia",
  },
  {
    text: "Prince George'S, MD",
    value: "prince george's:maryland",
  },
  {
    text: "Prince George'S, MD",
    value: "prince george's county:maryland",
  },
  {
    text: "Prince George'S, MD",
    value: "prince georges:maryland",
  },
  {
    text: "Prince William, VA",
    value: "prince william:virginia",
  },
  {
    text: "Prince of Wales-Hyder, AK",
    value: "prince of wales-hyder:alaska",
  },
  {
    text: "Prince of Wales-Outer Ketchikan, AK",
    value: "prince of wales-outer ketchikan:alaska",
  },
  {
    text: "Providence, RI",
    value: "providence:rhode island",
  },
  {
    text: "Prowers, CO",
    value: "prowers:colorado",
  },
  {
    text: "Pueblo, CO",
    value: "pueblo:colorado",
  },
  {
    text: "Pulaski, VA",
    value: "pulaski:virginia",
  },
  {
    text: "Pulaski, AR",
    value: "pulaski:arkansas",
  },
  {
    text: "Pulaski, IL",
    value: "pulaski:illinois",
  },
  {
    text: "Pulaski, IN",
    value: "pulaski:indiana",
  },
  {
    text: "Pulaski, KY",
    value: "pulaski:kentucky",
  },
  {
    text: "Pulaski, MO",
    value: "pulaski:missouri",
  },
  {
    text: "Pulaski, GA",
    value: "pulaski:georgia",
  },
  {
    text: "Pushmataha, OK",
    value: "pushmataha:oklahoma",
  },
  {
    text: "Putnam, WV",
    value: "putnam:west virginia",
  },
  {
    text: "Putnam, FL",
    value: "putnam:florida",
  },
  {
    text: "Putnam, IL",
    value: "putnam:illinois",
  },
  {
    text: "Putnam, IN",
    value: "putnam:indiana",
  },
  {
    text: "Putnam, MO",
    value: "putnam:missouri",
  },
  {
    text: "Putnam, TN",
    value: "putnam:tennessee",
  },
  {
    text: "Putnam, GA",
    value: "putnam:georgia",
  },
  {
    text: "Putnam, OH",
    value: "putnam:ohio",
  },
  {
    text: "Putnam, NY",
    value: "putnam:new york",
  },
  {
    text: "Quay, NM",
    value: "quay:new mexico",
  },
  {
    text: "Queen Anne'S, MD",
    value: "queen anne's:maryland",
  },
  {
    text: "Queen Anne'S, MD",
    value: "queen annes:maryland",
  },
  {
    text: "Queens, NY",
    value: "queens:new york",
  },
  {
    text: "Quitman, MS",
    value: "quitman:mississippi",
  },
  {
    text: "Quitman, GA",
    value: "quitman:georgia",
  },
  {
    text: "Rabun, GA",
    value: "rabun:georgia",
  },
  {
    text: "Racine, WI",
    value: "racine:wisconsin",
  },
  {
    text: "Radford, VA",
    value: "radford:virginia",
  },
  {
    text: "Rains, TX",
    value: "rains:texas",
  },
  {
    text: "Raleigh, WV",
    value: "raleigh:west virginia",
  },
  {
    text: "Ralls, MO",
    value: "ralls:missouri",
  },
  {
    text: "Ramsey, MN",
    value: "ramsey:minnesota",
  },
  {
    text: "Ramsey, ND",
    value: "ramsey:north dakota",
  },
  {
    text: "Randall, TX",
    value: "randall:texas",
  },
  {
    text: "Randolph, AL",
    value: "randolph:alabama",
  },
  {
    text: "Randolph, WV",
    value: "randolph:west virginia",
  },
  {
    text: "Randolph, AR",
    value: "randolph:arkansas",
  },
  {
    text: "Randolph, IL",
    value: "randolph:illinois",
  },
  {
    text: "Randolph, IN",
    value: "randolph:indiana",
  },
  {
    text: "Randolph, MO",
    value: "randolph:missouri",
  },
  {
    text: "Randolph, NC",
    value: "randolph:north carolina",
  },
  {
    text: "Randolph, GA",
    value: "randolph:georgia",
  },
  {
    text: "Rankin, MS",
    value: "rankin:mississippi",
  },
  {
    text: "Ransom, ND",
    value: "ransom:north dakota",
  },
  {
    text: "Rapides, LA",
    value: "rapides:louisiana",
  },
  {
    text: "Rapides, LA",
    value: "rapides parish:louisiana",
  },
  {
    text: "Rappahannock, VA",
    value: "rappahannock:virginia",
  },
  {
    text: "Ravalli, MT",
    value: "ravalli:montana",
  },
  {
    text: "Rawlins, KS",
    value: "rawlins:kansas",
  },
  {
    text: "Ray, MO",
    value: "ray:missouri",
  },
  {
    text: "Reagan, TX",
    value: "reagan:texas",
  },
  {
    text: "Real, TX",
    value: "real:texas",
  },
  {
    text: "Red Lake, MN",
    value: "red lake:minnesota",
  },
  {
    text: "Red River, TX",
    value: "red river:texas",
  },
  {
    text: "Red River, LA",
    value: "red river:louisiana",
  },
  {
    text: "Red Willow, NE",
    value: "red willow:nebraska",
  },
  {
    text: "Redwood, MN",
    value: "redwood:minnesota",
  },
  {
    text: "Reeves, TX",
    value: "reeves:texas",
  },
  {
    text: "Refugio, TX",
    value: "refugio:texas",
  },
  {
    text: "Reno, KS",
    value: "reno:kansas",
  },
  {
    text: "Rensselaer, NY",
    value: "rensselaer:new york",
  },
  {
    text: "Renville, MN",
    value: "renville:minnesota",
  },
  {
    text: "Renville, ND",
    value: "renville:north dakota",
  },
  {
    text: "Republic, KS",
    value: "republic:kansas",
  },
  {
    text: "Reynolds, MO",
    value: "reynolds:missouri",
  },
  {
    text: "Rhea, TN",
    value: "rhea:tennessee",
  },
  {
    text: "Rice, KS",
    value: "rice:kansas",
  },
  {
    text: "Rice, MN",
    value: "rice:minnesota",
  },
  {
    text: "Rich, UT",
    value: "rich:utah",
  },
  {
    text: "Richardson, NE",
    value: "richardson:nebraska",
  },
  {
    text: "Richland, IL",
    value: "richland:illinois",
  },
  {
    text: "Richland, LA",
    value: "richland:louisiana",
  },
  {
    text: "Richland, OH",
    value: "richland:ohio",
  },
  {
    text: "Richland, SC",
    value: "richland:south carolina",
  },
  {
    text: "Richland, WI",
    value: "richland:wisconsin",
  },
  {
    text: "Richland, ND",
    value: "richland:north dakota",
  },
  {
    text: "Richland, MT",
    value: "richland:montana",
  },
  {
    text: "Richmond, VA",
    value: "richmond:virginia",
  },
  {
    text: "Richmond, NC",
    value: "richmond:north carolina",
  },
  {
    text: "Richmond, GA",
    value: "richmond:georgia",
  },
  {
    text: "Richmond, NY",
    value: "richmond:new york",
  },
  {
    text: "Richmond, VA",
    value: "richmond city:virginia",
  },
  {
    text: "Richmond, NC",
    value: "richmond city:north carolina",
  },
  {
    text: "Richmond, GA",
    value: "richmond city:georgia",
  },
  {
    text: "Richmond, NY",
    value: "richmond city:new york",
  },
  {
    text: "Riley, KS",
    value: "riley:kansas",
  },
  {
    text: "Ringgold, IA",
    value: "ringgold:iowa",
  },
  {
    text: "Rio Arriba, NM",
    value: "rio arriba:new mexico",
  },
  {
    text: "Rio Blanco, CO",
    value: "rio blanco:colorado",
  },
  {
    text: "Rio Grande, CO",
    value: "rio grande:colorado",
  },
  {
    text: "Ripley, IN",
    value: "ripley:indiana",
  },
  {
    text: "Ripley, MO",
    value: "ripley:missouri",
  },
  {
    text: "Ritchie, WV",
    value: "ritchie:west virginia",
  },
  {
    text: "Riverside, CA",
    value: "riverside:california",
  },
  {
    text: "Roane, WV",
    value: "roane:west virginia",
  },
  {
    text: "Roane, TN",
    value: "roane:tennessee",
  },
  {
    text: "Roanoke, VA",
    value: "roanoke:virginia",
  },
  {
    text: "Roanoke, VA",
    value: "roanoke city:virginia",
  },
  {
    text: "Roberts, TX",
    value: "roberts:texas",
  },
  {
    text: "Roberts, SD",
    value: "roberts:south dakota",
  },
  {
    text: "Robertson, TX",
    value: "robertson:texas",
  },
  {
    text: "Robertson, KY",
    value: "robertson:kentucky",
  },
  {
    text: "Robertson, TN",
    value: "robertson:tennessee",
  },
  {
    text: "Robeson, NC",
    value: "robeson:north carolina",
  },
  {
    text: "Rock, MN",
    value: "rock:minnesota",
  },
  {
    text: "Rock, NE",
    value: "rock:nebraska",
  },
  {
    text: "Rock, WI",
    value: "rock:wisconsin",
  },
  {
    text: "Rock Island, IL",
    value: "rock island:illinois",
  },
  {
    text: "Rockbridge, VA",
    value: "rockbridge:virginia",
  },
  {
    text: "Rockcastle, KY",
    value: "rockcastle:kentucky",
  },
  {
    text: "Rockdale, GA",
    value: "rockdale:georgia",
  },
  {
    text: "Rockingham, VA",
    value: "rockingham:virginia",
  },
  {
    text: "Rockingham, NC",
    value: "rockingham:north carolina",
  },
  {
    text: "Rockingham, NH",
    value: "rockingham:new hampshire",
  },
  {
    text: "Rockland, NY",
    value: "rockland:new york",
  },
  {
    text: "Rockwall, TX",
    value: "rockwall:texas",
  },
  {
    text: "Roger Mills, OK",
    value: "roger mills:oklahoma",
  },
  {
    text: "Rogers, OK",
    value: "rogers:oklahoma",
  },
  {
    text: "Rolette, ND",
    value: "rolette:north dakota",
  },
  {
    text: "Rooks, KS",
    value: "rooks:kansas",
  },
  {
    text: "Roosevelt, NM",
    value: "roosevelt:new mexico",
  },
  {
    text: "Roosevelt, MT",
    value: "roosevelt:montana",
  },
  {
    text: "Roscommon, MI",
    value: "roscommon:michigan",
  },
  {
    text: "Roseau, MN",
    value: "roseau:minnesota",
  },
  {
    text: "Rosebud, MT",
    value: "rosebud:montana",
  },
  {
    text: "Ross, OH",
    value: "ross:ohio",
  },
  {
    text: "Routt, CO",
    value: "routt:colorado",
  },
  {
    text: "Rowan, KY",
    value: "rowan:kentucky",
  },
  {
    text: "Rowan, NC",
    value: "rowan:north carolina",
  },
  {
    text: "Runnels, TX",
    value: "runnels:texas",
  },
  {
    text: "Rush, IN",
    value: "rush:indiana",
  },
  {
    text: "Rush, KS",
    value: "rush:kansas",
  },
  {
    text: "Rusk, TX",
    value: "rusk:texas",
  },
  {
    text: "Rusk, WI",
    value: "rusk:wisconsin",
  },
  {
    text: "Russell, AL",
    value: "russell:alabama",
  },
  {
    text: "Russell, VA",
    value: "russell:virginia",
  },
  {
    text: "Russell, KS",
    value: "russell:kansas",
  },
  {
    text: "Russell, KY",
    value: "russell:kentucky",
  },
  {
    text: "Rutherford, NC",
    value: "rutherford:north carolina",
  },
  {
    text: "Rutherford, TN",
    value: "rutherford:tennessee",
  },
  {
    text: "Rutland, VT",
    value: "rutland:vermont",
  },
  {
    text: "Sabine, TX",
    value: "sabine:texas",
  },
  {
    text: "Sabine, LA",
    value: "sabine:louisiana",
  },
  {
    text: "Sabine, TX",
    value: "sabine parish:texas",
  },
  {
    text: "Sabine, LA",
    value: "sabine parish:louisiana",
  },
  {
    text: "Sac, IA",
    value: "sac:iowa",
  },
  {
    text: "Sacramento, CA",
    value: "sacramento:california",
  },
  {
    text: "Sagadahoc, ME",
    value: "sagadahoc:maine",
  },
  {
    text: "Saginaw, MI",
    value: "saginaw:michigan",
  },
  {
    text: "Saginaw And Bay, MI",
    value: "saginaw and bay:michigan",
  },
  {
    text: "Saguache, CO",
    value: "saguache:colorado",
  },
  {
    text: "St Bernard, LA",
    value: "saint bernard:louisiana",
  },
  {
    text: "St Charles, LA",
    value: "saint charles:louisiana",
  },
  {
    text: "St Charles, MO",
    value: "saint charles:missouri",
  },
  {
    text: "St Clair, AL",
    value: "saint clair:alabama",
  },
  {
    text: "St Clair, IL",
    value: "saint clair:illinois",
  },
  {
    text: "St Clair, MO",
    value: "saint clair:missouri",
  },
  {
    text: "St Clair, MI",
    value: "saint clair:michigan",
  },
  {
    text: "St Croix, WI",
    value: "saint croix:wisconsin",
  },
  {
    text: "St Francis, AR",
    value: "saint francis:arkansas",
  },
  {
    text: "St Francois, MO",
    value: "saint francois:missouri",
  },
  {
    text: "St Helena, LA",
    value: "saint helena:louisiana",
  },
  {
    text: "St James, LA",
    value: "saint james:louisiana",
  },
  {
    text: "St John the Baptist, LA",
    value: "saint john the baptist:louisiana",
  },
  {
    text: "St Johns, FL",
    value: "saint johns:florida",
  },
  {
    text: "St Joseph, IN",
    value: "saint joseph:indiana",
  },
  {
    text: "St Joseph, MI",
    value: "saint joseph:michigan",
  },
  {
    text: "St Landry, LA",
    value: "saint landry:louisiana",
  },
  {
    text: "St Lawrence, NY",
    value: "saint lawrence:new york",
  },
  {
    text: "Saint Louis, MO",
    value: "saint louis:missouri",
  },
  {
    text: "Saint Louis, MN",
    value: "saint louis:minnesota",
  },
  {
    text: "Saint Louis, MO",
    value: "saint louis city:missouri",
  },
  {
    text: "Saint Louis, MN",
    value: "saint louis city:minnesota",
  },
  {
    text: "St Lucie, FL",
    value: "saint lucie:florida",
  },
  {
    text: "St Martin, LA",
    value: "saint martin:louisiana",
  },
  {
    text: "St Mary, LA",
    value: "saint mary:louisiana",
  },
  {
    text: "St Mary'S, MD",
    value: "saint marys:maryland",
  },
  {
    text: "St Tammany, LA",
    value: "saint tammany:louisiana",
  },
  {
    text: "Salem, VA",
    value: "salem:virginia",
  },
  {
    text: "Salem, NJ",
    value: "salem:new jersey",
  },
  {
    text: "Salem, VA",
    value: "salem city:virginia",
  },
  {
    text: "Salem, NJ",
    value: "salem city:new jersey",
  },
  {
    text: "Saline, AR",
    value: "saline:arkansas",
  },
  {
    text: "Saline, IL",
    value: "saline:illinois",
  },
  {
    text: "Saline, KS",
    value: "saline:kansas",
  },
  {
    text: "Saline, MO",
    value: "saline:missouri",
  },
  {
    text: "Saline, NE",
    value: "saline:nebraska",
  },
  {
    text: "Salt Lake, UT",
    value: "salt lake:utah",
  },
  {
    text: "Saluda, SC",
    value: "saluda:south carolina",
  },
  {
    text: "Sampson, NC",
    value: "sampson:north carolina",
  },
  {
    text: "San Augustine, TX",
    value: "san augustine:texas",
  },
  {
    text: "San Benito, CA",
    value: "san benito:california",
  },
  {
    text: "San Bernardino, CA",
    value: "san bernardino:california",
  },
  {
    text: "San Diego, CA",
    value: "san diego:california",
  },
  {
    text: "San Francisco, CA",
    value: "san francisco:california",
  },
  {
    text: "San Jacinto, TX",
    value: "san jacinto:texas",
  },
  {
    text: "San Joaquin, CA",
    value: "san joaquin:california",
  },
  {
    text: "San Juan, NM",
    value: "san juan:new mexico",
  },
  {
    text: "San Juan, CO",
    value: "san juan:colorado",
  },
  {
    text: "San Juan, UT",
    value: "san juan:utah",
  },
  {
    text: "San Juan, WA",
    value: "san juan:washington",
  },
  {
    text: "San Luis Obispo, CA",
    value: "san luis obispo:california",
  },
  {
    text: "San Mateo, CA",
    value: "san mateo:california",
  },
  {
    text: "San Miguel, NM",
    value: "san miguel:new mexico",
  },
  {
    text: "San Miguel, CO",
    value: "san miguel:colorado",
  },
  {
    text: "San Patricio, TX",
    value: "san patricio:texas",
  },
  {
    text: "San Saba, TX",
    value: "san saba:texas",
  },
  {
    text: "Sanborn, SD",
    value: "sanborn:south dakota",
  },
  {
    text: "Sanders, MT",
    value: "sanders:montana",
  },
  {
    text: "Sandoval, NM",
    value: "sandoval:new mexico",
  },
  {
    text: "Sandusky, OH",
    value: "sandusky:ohio",
  },
  {
    text: "Sangamon, IL",
    value: "sangamon:illinois",
  },
  {
    text: "Sanilac, MI",
    value: "sanilac:michigan",
  },
  {
    text: "Sanpete, UT",
    value: "sanpete:utah",
  },
  {
    text: "Santa Barbara, CA",
    value: "santa barbara:california",
  },
  {
    text: "Santa Clara, CA",
    value: "santa clara:california",
  },
  {
    text: "Santa Cruz, AZ",
    value: "santa cruz:arizona",
  },
  {
    text: "Santa Cruz, CA",
    value: "santa cruz:california",
  },
  {
    text: "Santa Fe, NM",
    value: "santa fe:new mexico",
  },
  {
    text: "Santa Rosa, FL",
    value: "santa rosa:florida",
  },
  {
    text: "Sarasota, FL",
    value: "sarasota:florida",
  },
  {
    text: "Saratoga, NY",
    value: "saratoga:new york",
  },
  {
    text: "Sargent, ND",
    value: "sargent:north dakota",
  },
  {
    text: "Sarpy, NE",
    value: "sarpy:nebraska",
  },
  {
    text: "Sauk, WI",
    value: "sauk:wisconsin",
  },
  {
    text: "Saunders, NE",
    value: "saunders:nebraska",
  },
  {
    text: "Sawyer, WI",
    value: "sawyer:wisconsin",
  },
  {
    text: "Schenectady, NY",
    value: "schenectady:new york",
  },
  {
    text: "Schleicher, TX",
    value: "schleicher:texas",
  },
  {
    text: "Schley, GA",
    value: "schley:georgia",
  },
  {
    text: "Schoharie, NY",
    value: "schoharie:new york",
  },
  {
    text: "Schoolcraft, MI",
    value: "schoolcraft:michigan",
  },
  {
    text: "Schuyler, IL",
    value: "schuyler:illinois",
  },
  {
    text: "Schuyler, MO",
    value: "schuyler:missouri",
  },
  {
    text: "Schuyler, NY",
    value: "schuyler:new york",
  },
  {
    text: "Schuylkill, PA",
    value: "schuylkill:pennsylvania",
  },
  {
    text: "Scioto, OH",
    value: "scioto:ohio",
  },
  {
    text: "Scotland, MO",
    value: "scotland:missouri",
  },
  {
    text: "Scotland, NC",
    value: "scotland:north carolina",
  },
  {
    text: "Scott, VA",
    value: "scott:virginia",
  },
  {
    text: "Scott, AR",
    value: "scott:arkansas",
  },
  {
    text: "Scott, IL",
    value: "scott:illinois",
  },
  {
    text: "Scott, IN",
    value: "scott:indiana",
  },
  {
    text: "Scott, KS",
    value: "scott:kansas",
  },
  {
    text: "Scott, KY",
    value: "scott:kentucky",
  },
  {
    text: "Scott, MO",
    value: "scott:missouri",
  },
  {
    text: "Scott, MS",
    value: "scott:mississippi",
  },
  {
    text: "Scott, TN",
    value: "scott:tennessee",
  },
  {
    text: "Scott, IA",
    value: "scott:iowa",
  },
  {
    text: "Scott, MN",
    value: "scott:minnesota",
  },
  {
    text: "Scotts Bluff, NE",
    value: "scotts bluff:nebraska",
  },
  {
    text: "Screven, GA",
    value: "screven:georgia",
  },
  {
    text: "Scurry, TX",
    value: "scurry:texas",
  },
  {
    text: "Searcy, AR",
    value: "searcy:arkansas",
  },
  {
    text: "Sebastian, AR",
    value: "sebastian:arkansas",
  },
  {
    text: "Sedgwick, KS",
    value: "sedgwick:kansas",
  },
  {
    text: "Sedgwick, CO",
    value: "sedgwick:colorado",
  },
  {
    text: "Seminole, FL",
    value: "seminole:florida",
  },
  {
    text: "Seminole, GA",
    value: "seminole:georgia",
  },
  {
    text: "Seminole, OK",
    value: "seminole:oklahoma",
  },
  {
    text: "Seneca, OH",
    value: "seneca:ohio",
  },
  {
    text: "Seneca, NY",
    value: "seneca:new york",
  },
  {
    text: "Sequatchie, TN",
    value: "sequatchie:tennessee",
  },
  {
    text: "Sequoyah, OK",
    value: "sequoyah:oklahoma",
  },
  {
    text: "Sevier, AR",
    value: "sevier:arkansas",
  },
  {
    text: "Sevier, TN",
    value: "sevier:tennessee",
  },
  {
    text: "Sevier, UT",
    value: "sevier:utah",
  },
  {
    text: "Seward, KS",
    value: "seward:kansas",
  },
  {
    text: "Seward, NE",
    value: "seward:nebraska",
  },
  {
    text: "Shackelford, TX",
    value: "shackelford:texas",
  },
  {
    text: "Shannon, MO",
    value: "shannon:missouri",
  },
  {
    text: "Shannon, SD",
    value: "shannon:south dakota",
  },
  {
    text: "Sharkey, MS",
    value: "sharkey:mississippi",
  },
  {
    text: "Sharp, AR",
    value: "sharp:arkansas",
  },
  {
    text: "Shasta, CA",
    value: "shasta:california",
  },
  {
    text: "Shawano, WI",
    value: "shawano:wisconsin",
  },
  {
    text: "Shawnee, KS",
    value: "shawnee:kansas",
  },
  {
    text: "Sheboygan, WI",
    value: "sheboygan:wisconsin",
  },
  {
    text: "Shelby, TX",
    value: "shelby:texas",
  },
  {
    text: "Shelby, AL",
    value: "shelby:alabama",
  },
  {
    text: "Shelby, IL",
    value: "shelby:illinois",
  },
  {
    text: "Shelby, IN",
    value: "shelby:indiana",
  },
  {
    text: "Shelby, KY",
    value: "shelby:kentucky",
  },
  {
    text: "Shelby, MO",
    value: "shelby:missouri",
  },
  {
    text: "Shelby, TN",
    value: "shelby:tennessee",
  },
  {
    text: "Shelby, OH",
    value: "shelby:ohio",
  },
  {
    text: "Shelby, IA",
    value: "shelby:iowa",
  },
  {
    text: "Shenandoah, VA",
    value: "shenandoah:virginia",
  },
  {
    text: "Sherburne, MN",
    value: "sherburne:minnesota",
  },
  {
    text: "Sheridan, KS",
    value: "sheridan:kansas",
  },
  {
    text: "Sheridan, NE",
    value: "sheridan:nebraska",
  },
  {
    text: "Sheridan, ND",
    value: "sheridan:north dakota",
  },
  {
    text: "Sheridan, MT",
    value: "sheridan:montana",
  },
  {
    text: "Sheridan, WY",
    value: "sheridan:wyoming",
  },
  {
    text: "Sherman, TX",
    value: "sherman:texas",
  },
  {
    text: "Sherman, KS",
    value: "sherman:kansas",
  },
  {
    text: "Sherman, NE",
    value: "sherman:nebraska",
  },
  {
    text: "Sherman, OR",
    value: "sherman:oregon",
  },
  {
    text: "Shiawassee, MI",
    value: "shiawassee:michigan",
  },
  {
    text: "Shoshone, ID",
    value: "shoshone:idaho",
  },
  {
    text: "Sibley, MN",
    value: "sibley:minnesota",
  },
  {
    text: "Sierra, NM",
    value: "sierra:new mexico",
  },
  {
    text: "Sierra, CA",
    value: "sierra:california",
  },
  {
    text: "Silver Bow, MT",
    value: "silver bow:montana",
  },
  {
    text: "Simpson, KY",
    value: "simpson:kentucky",
  },
  {
    text: "Simpson, MS",
    value: "simpson:mississippi",
  },
  {
    text: "Sioux, IA",
    value: "sioux:iowa",
  },
  {
    text: "Sioux, NE",
    value: "sioux:nebraska",
  },
  {
    text: "Sioux, ND",
    value: "sioux:north dakota",
  },
  {
    text: "Siskiyou, CA",
    value: "siskiyou:california",
  },
  {
    text: "Sitka, AK",
    value: "sitka:alaska",
  },
  {
    text: "Skagit, WA",
    value: "skagit:washington",
  },
  {
    text: "Skagway, AK",
    value: "skagway:alaska",
  },
  {
    text: "Skamania, WA",
    value: "skamania:washington",
  },
  {
    text: "Slope, ND",
    value: "slope:north dakota",
  },
  {
    text: "Smith, TX",
    value: "smith:texas",
  },
  {
    text: "Smith, KS",
    value: "smith:kansas",
  },
  {
    text: "Smith, MS",
    value: "smith:mississippi",
  },
  {
    text: "Smith, TN",
    value: "smith:tennessee",
  },
  {
    text: "Smyth, VA",
    value: "smyth:virginia",
  },
  {
    text: "Snohomish, WA",
    value: "snohomish:washington",
  },
  {
    text: "Snyder, PA",
    value: "snyder:pennsylvania",
  },
  {
    text: "Socorro, NM",
    value: "socorro:new mexico",
  },
  {
    text: "Solano, CA",
    value: "solano:california",
  },
  {
    text: "Somerset, MD",
    value: "somerset:maryland",
  },
  {
    text: "Somerset, NJ",
    value: "somerset:new jersey",
  },
  {
    text: "Somerset, PA",
    value: "somerset:pennsylvania",
  },
  {
    text: "Somerset, ME",
    value: "somerset:maine",
  },
  {
    text: "Somervell, TX",
    value: "somervell:texas",
  },
  {
    text: "Sonoma, CA",
    value: "sonoma:california",
  },
  {
    text: "Southampton, VA",
    value: "southampton:virginia",
  },
  {
    text: "Southeast Fairbanks, AK",
    value: "southeast fairbanks:alaska",
  },
  {
    text: "Spalding, GA",
    value: "spalding:georgia",
  },
  {
    text: "Spartanburg, SC",
    value: "spartanburg:south carolina",
  },
  {
    text: "Spencer, IN",
    value: "spencer:indiana",
  },
  {
    text: "Spencer, KY",
    value: "spencer:kentucky",
  },
  {
    text: "Spink, SD",
    value: "spink:south dakota",
  },
  {
    text: "Spokane, WA",
    value: "spokane:washington",
  },
  {
    text: "Spotsylvania, VA",
    value: "spotsylvania:virginia",
  },
  {
    text: "St Clair, AL",
    value: "st clair:alabama",
  },
  {
    text: "St Clair, IL",
    value: "st clair:illinois",
  },
  {
    text: "St Clair, MO",
    value: "st clair:missouri",
  },
  {
    text: "St Clair, MI",
    value: "st clair:michigan",
  },
  {
    text: "St Francis, AR",
    value: "st francis:arkansas",
  },
  {
    text: "St Lawrence, NY",
    value: "st lawrence:new york",
  },
  {
    text: "Saint Louis, MO",
    value: "st louis:missouri",
  },
  {
    text: "Saint Louis, MN",
    value: "st louis:minnesota",
  },
  {
    text: "St Bernard, LA",
    value: "st. bernard:louisiana",
  },
  {
    text: "St Charles, LA",
    value: "st. charles:louisiana",
  },
  {
    text: "St Charles, MO",
    value: "st. charles:missouri",
  },
  {
    text: "St Clair, AL",
    value: "st. clair:alabama",
  },
  {
    text: "St Clair, IL",
    value: "st. clair:illinois",
  },
  {
    text: "St Clair, MO",
    value: "st. clair:missouri",
  },
  {
    text: "St Clair, MI",
    value: "st. clair:michigan",
  },
  {
    text: "St Francis, AR",
    value: "st. francis:arkansas",
  },
  {
    text: "St Francois, MO",
    value: "st. francois:missouri",
  },
  {
    text: "St Helena, LA",
    value: "st. helena:louisiana",
  },
  {
    text: "St James, LA",
    value: "st. james:louisiana",
  },
  {
    text: "St John the Baptist, LA",
    value: "st. john the baptist:louisiana",
  },
  {
    text: "St John the Baptist, LA",
    value: "st. john the baptist parish:louisiana",
  },
  {
    text: "St Johns, FL",
    value: "st. johns:florida",
  },
  {
    text: "St Joseph, IN",
    value: "st. joseph:indiana",
  },
  {
    text: "St Joseph, MI",
    value: "st. joseph:michigan",
  },
  {
    text: "St Landry, LA",
    value: "st. landry parish:louisiana",
  },
  {
    text: "St Lawrence, NY",
    value: "st. lawrence:new york",
  },
  {
    text: "Saint Louis, MO",
    value: "st. louis:missouri",
  },
  {
    text: "Saint Louis, MN",
    value: "st. louis:minnesota",
  },
  {
    text: "Saint Louis, MO",
    value: "st. louis city:missouri",
  },
  {
    text: "Saint Louis, MN",
    value: "st. louis city:minnesota",
  },
  {
    text: "St Lucie, FL",
    value: "st. lucie:florida",
  },
  {
    text: "St Mary'S, MD",
    value: "st. mary's:maryland",
  },
  {
    text: "St Tammany, LA",
    value: "st. tammany:louisiana",
  },
  {
    text: "St Tammany, LA",
    value: "st. tammany parish:louisiana",
  },
  {
    text: "Stafford, VA",
    value: "stafford:virginia",
  },
  {
    text: "Stafford, KS",
    value: "stafford:kansas",
  },
  {
    text: "Stanislaus, CA",
    value: "stanislaus:california",
  },
  {
    text: "Stanley, SD",
    value: "stanley:south dakota",
  },
  {
    text: "Stanly, NC",
    value: "stanly:north carolina",
  },
  {
    text: "Stanton, KS",
    value: "stanton:kansas",
  },
  {
    text: "Stanton, NE",
    value: "stanton:nebraska",
  },
  {
    text: "Stark, IL",
    value: "stark:illinois",
  },
  {
    text: "Stark, OH",
    value: "stark:ohio",
  },
  {
    text: "Stark, ND",
    value: "stark:north dakota",
  },
  {
    text: "Starke, IN",
    value: "starke:indiana",
  },
  {
    text: "Starr, TX",
    value: "starr:texas",
  },
  {
    text: "Staunton, VA",
    value: "staunton city:virginia",
  },
  {
    text: "Ste Genevieve, MO",
    value: "ste genevieve:missouri",
  },
  {
    text: "Ste Genevieve, MO",
    value: "ste. genevieve:missouri",
  },
  {
    text: "Stearns, MN",
    value: "stearns:minnesota",
  },
  {
    text: "Steele, MN",
    value: "steele:minnesota",
  },
  {
    text: "Steele, ND",
    value: "steele:north dakota",
  },
  {
    text: "Stephens, TX",
    value: "stephens:texas",
  },
  {
    text: "Stephens, GA",
    value: "stephens:georgia",
  },
  {
    text: "Stephens, OK",
    value: "stephens:oklahoma",
  },
  {
    text: "Stephenson, IL",
    value: "stephenson:illinois",
  },
  {
    text: "Sterling, TX",
    value: "sterling:texas",
  },
  {
    text: "Steuben, IN",
    value: "steuben:indiana",
  },
  {
    text: "Steuben, NY",
    value: "steuben:new york",
  },
  {
    text: "Stevens, KS",
    value: "stevens:kansas",
  },
  {
    text: "Stevens, MN",
    value: "stevens:minnesota",
  },
  {
    text: "Stevens, WA",
    value: "stevens:washington",
  },
  {
    text: "Stewart, TN",
    value: "stewart:tennessee",
  },
  {
    text: "Stewart, GA",
    value: "stewart:georgia",
  },
  {
    text: "Stillwater, MT",
    value: "stillwater:montana",
  },
  {
    text: "Stoddard, MO",
    value: "stoddard:missouri",
  },
  {
    text: "Stokes, NC",
    value: "stokes:north carolina",
  },
  {
    text: "Stone, AR",
    value: "stone:arkansas",
  },
  {
    text: "Stone, MO",
    value: "stone:missouri",
  },
  {
    text: "Stone, MS",
    value: "stone:mississippi",
  },
  {
    text: "Stonewall, TX",
    value: "stonewall:texas",
  },
  {
    text: "Storey, NV",
    value: "storey:nevada",
  },
  {
    text: "Story, IA",
    value: "story:iowa",
  },
  {
    text: "Strafford, NH",
    value: "strafford:new hampshire",
  },
  {
    text: "Stutsman, ND",
    value: "stutsman:north dakota",
  },
  {
    text: "Sublette, WY",
    value: "sublette:wyoming",
  },
  {
    text: "Suffolk, VA",
    value: "suffolk:virginia",
  },
  {
    text: "Suffolk, MA",
    value: "suffolk:massachusetts",
  },
  {
    text: "Suffolk, NY",
    value: "suffolk:new york",
  },
  {
    text: "Suffolk, VA",
    value: "suffolk city:virginia",
  },
  {
    text: "Suffolk, MA",
    value: "suffolk city:massachusetts",
  },
  {
    text: "Suffolk, NY",
    value: "suffolk city:new york",
  },
  {
    text: "Sullivan, IN",
    value: "sullivan:indiana",
  },
  {
    text: "Sullivan, MO",
    value: "sullivan:missouri",
  },
  {
    text: "Sullivan, TN",
    value: "sullivan:tennessee",
  },
  {
    text: "Sullivan, PA",
    value: "sullivan:pennsylvania",
  },
  {
    text: "Sullivan, NY",
    value: "sullivan:new york",
  },
  {
    text: "Sullivan, NH",
    value: "sullivan:new hampshire",
  },
  {
    text: "Sully, SD",
    value: "sully:south dakota",
  },
  {
    text: "Summers, WV",
    value: "summers:west virginia",
  },
  {
    text: "Summit, OH",
    value: "summit:ohio",
  },
  {
    text: "Summit, CO",
    value: "summit:colorado",
  },
  {
    text: "Summit, UT",
    value: "summit:utah",
  },
  {
    text: "Sumner, KS",
    value: "sumner:kansas",
  },
  {
    text: "Sumner, TN",
    value: "sumner:tennessee",
  },
  {
    text: "Sumter, AL",
    value: "sumter:alabama",
  },
  {
    text: "Sumter, FL",
    value: "sumter:florida",
  },
  {
    text: "Sumter, GA",
    value: "sumter:georgia",
  },
  {
    text: "Sumter, SC",
    value: "sumter:south carolina",
  },
  {
    text: "Sunflower, MS",
    value: "sunflower:mississippi",
  },
  {
    text: "Surry, VA",
    value: "surry:virginia",
  },
  {
    text: "Surry, NC",
    value: "surry:north carolina",
  },
  {
    text: "Susquehanna, PA",
    value: "susquehanna:pennsylvania",
  },
  {
    text: "Sussex, VA",
    value: "sussex:virginia",
  },
  {
    text: "Sussex, DE",
    value: "sussex:delaware",
  },
  {
    text: "Sussex, NJ",
    value: "sussex:new jersey",
  },
  {
    text: "Sutter, CA",
    value: "sutter:california",
  },
  {
    text: "Sutton, TX",
    value: "sutton:texas",
  },
  {
    text: "Suwannee, FL",
    value: "suwannee:florida",
  },
  {
    text: "Swain, NC",
    value: "swain:north carolina",
  },
  {
    text: "Sweet Grass, MT",
    value: "sweet grass:montana",
  },
  {
    text: "Sweetwater, WY",
    value: "sweetwater:wyoming",
  },
  {
    text: "Swift, MN",
    value: "swift:minnesota",
  },
  {
    text: "Swisher, TX",
    value: "swisher:texas",
  },
  {
    text: "Switzerland, IN",
    value: "switzerland:indiana",
  },
  {
    text: "Talbot, MD",
    value: "talbot:maryland",
  },
  {
    text: "Talbot, GA",
    value: "talbot:georgia",
  },
  {
    text: "Taliaferro, GA",
    value: "taliaferro:georgia",
  },
  {
    text: "Talladega, AL",
    value: "talladega:alabama",
  },
  {
    text: "Talladega, AL",
    value: "talladega county:alabama",
  },
  {
    text: "Tallahatchie, MS",
    value: "tallahatchie:mississippi",
  },
  {
    text: "Tallapoosa, AL",
    value: "tallapoosa:alabama",
  },
  {
    text: "Tama, IA",
    value: "tama:iowa",
  },
  {
    text: "Taney, MO",
    value: "taney:missouri",
  },
  {
    text: "Tangipahoa, LA",
    value: "tangipahoa:louisiana",
  },
  {
    text: "Tangipahoa, LA",
    value: "tangipahoa parish:louisiana",
  },
  {
    text: "Taos, NM",
    value: "taos:new mexico",
  },
  {
    text: "Tarrant, TX",
    value: "tarrant:texas",
  },
  {
    text: "Tate, MS",
    value: "tate:mississippi",
  },
  {
    text: "Tattnall, GA",
    value: "tattnall:georgia",
  },
  {
    text: "Taylor, TX",
    value: "taylor:texas",
  },
  {
    text: "Taylor, WV",
    value: "taylor:west virginia",
  },
  {
    text: "Taylor, FL",
    value: "taylor:florida",
  },
  {
    text: "Taylor, KY",
    value: "taylor:kentucky",
  },
  {
    text: "Taylor, GA",
    value: "taylor:georgia",
  },
  {
    text: "Taylor, IA",
    value: "taylor:iowa",
  },
  {
    text: "Taylor, WI",
    value: "taylor:wisconsin",
  },
  {
    text: "Tazewell, VA",
    value: "tazewell:virginia",
  },
  {
    text: "Tazewell, IL",
    value: "tazewell:illinois",
  },
  {
    text: "Tehama, CA",
    value: "tehama:california",
  },
  {
    text: "Telfair, GA",
    value: "telfair:georgia",
  },
  {
    text: "Teller, CO",
    value: "teller:colorado",
  },
  {
    text: "Tensas, LA",
    value: "tensas:louisiana",
  },
  {
    text: "Terrebonne, LA",
    value: "terrebonne:louisiana",
  },
  {
    text: "Terrebonne, LA",
    value: "terrebonne parish:louisiana",
  },
  {
    text: "Terrell, TX",
    value: "terrell:texas",
  },
  {
    text: "Terrell, GA",
    value: "terrell:georgia",
  },
  {
    text: "Terry, TX",
    value: "terry:texas",
  },
  {
    text: "Teton, ID",
    value: "teton:idaho",
  },
  {
    text: "Teton, MT",
    value: "teton:montana",
  },
  {
    text: "Teton, WY",
    value: "teton:wyoming",
  },
  {
    text: "Texas, MO",
    value: "texas:missouri",
  },
  {
    text: "Texas, OK",
    value: "texas:oklahoma",
  },
  {
    text: "Thayer, NE",
    value: "thayer:nebraska",
  },
  {
    text: "Thomas, KS",
    value: "thomas:kansas",
  },
  {
    text: "Thomas, GA",
    value: "thomas:georgia",
  },
  {
    text: "Thomas, NE",
    value: "thomas:nebraska",
  },
  {
    text: "Throckmorton, TX",
    value: "throckmorton:texas",
  },
  {
    text: "Thurston, NE",
    value: "thurston:nebraska",
  },
  {
    text: "Thurston, WA",
    value: "thurston:washington",
  },
  {
    text: "Tift, GA",
    value: "tift:georgia",
  },
  {
    text: "Tillamook, OR",
    value: "tillamook:oregon",
  },
  {
    text: "Tillman, OK",
    value: "tillman:oklahoma",
  },
  {
    text: "Tioga, PA",
    value: "tioga:pennsylvania",
  },
  {
    text: "Tioga, NY",
    value: "tioga:new york",
  },
  {
    text: "Tippah, MS",
    value: "tippah:mississippi",
  },
  {
    text: "Tippecanoe, IN",
    value: "tippecanoe:indiana",
  },
  {
    text: "Tipton, IN",
    value: "tipton:indiana",
  },
  {
    text: "Tipton, TN",
    value: "tipton:tennessee",
  },
  {
    text: "Tishomingo, MS",
    value: "tishomingo:mississippi",
  },
  {
    text: "Titus, TX",
    value: "titus:texas",
  },
  {
    text: "Todd, KY",
    value: "todd:kentucky",
  },
  {
    text: "Todd, MN",
    value: "todd:minnesota",
  },
  {
    text: "Todd, SD",
    value: "todd:south dakota",
  },
  {
    text: "Tolland, CT",
    value: "tolland:connecticut",
  },
  {
    text: "Tom Green, TX",
    value: "tom green:texas",
  },
  {
    text: "Tompkins, NY",
    value: "tompkins:new york",
  },
  {
    text: "Tooele, UT",
    value: "tooele:utah",
  },
  {
    text: "Toole, MT",
    value: "toole:montana",
  },
  {
    text: "Toombs, GA",
    value: "toombs:georgia",
  },
  {
    text: "Torrance, NM",
    value: "torrance:new mexico",
  },
  {
    text: "Towner, ND",
    value: "towner:north dakota",
  },
  {
    text: "Towns, GA",
    value: "towns:georgia",
  },
  {
    text: "Traill, ND",
    value: "traill:north dakota",
  },
  {
    text: "Transylvania, NC",
    value: "transylvania:north carolina",
  },
  {
    text: "Traverse, MN",
    value: "traverse:minnesota",
  },
  {
    text: "Travis, TX",
    value: "travis:texas",
  },
  {
    text: "Treasure, MT",
    value: "treasure:montana",
  },
  {
    text: "Trego, KS",
    value: "trego:kansas",
  },
  {
    text: "Trempealeau, WI",
    value: "trempealeau:wisconsin",
  },
  {
    text: "Treutlen, GA",
    value: "treutlen:georgia",
  },
  {
    text: "Trigg, KY",
    value: "trigg:kentucky",
  },
  {
    text: "Trimble, KY",
    value: "trimble:kentucky",
  },
  {
    text: "Trinity, TX",
    value: "trinity:texas",
  },
  {
    text: "Trinity, CA",
    value: "trinity:california",
  },
  {
    text: "Tripp, SD",
    value: "tripp:south dakota",
  },
  {
    text: "Troup, GA",
    value: "troup:georgia",
  },
  {
    text: "Trousdale, TN",
    value: "trousdale:tennessee",
  },
  {
    text: "Trumbull, OH",
    value: "trumbull:ohio",
  },
  {
    text: "Tucker, WV",
    value: "tucker:west virginia",
  },
  {
    text: "Tulare, CA",
    value: "tulare:california",
  },
  {
    text: "Tulsa, OK",
    value: "tulsa:oklahoma",
  },
  {
    text: "Tunica, MS",
    value: "tunica:mississippi",
  },
  {
    text: "Tunica, MS",
    value: "tunica county:mississippi",
  },
  {
    text: "Tuolumne, CA",
    value: "tuolumne:california",
  },
  {
    text: "Turner, GA",
    value: "turner:georgia",
  },
  {
    text: "Turner, SD",
    value: "turner:south dakota",
  },
  {
    text: "Tuscaloosa, AL",
    value: "tuscaloosa:alabama",
  },
  {
    text: "Tuscarawas, OH",
    value: "tuscarawas:ohio",
  },
  {
    text: "Tuscola, MI",
    value: "tuscola:michigan",
  },
  {
    text: "Twiggs, GA",
    value: "twiggs:georgia",
  },
  {
    text: "Twin Falls, ID",
    value: "twin falls:idaho",
  },
  {
    text: "Tyler, TX",
    value: "tyler:texas",
  },
  {
    text: "Tyler, WV",
    value: "tyler:west virginia",
  },
  {
    text: "Tyrrell, NC",
    value: "tyrrell:north carolina",
  },
  {
    text: "Uinta, WY",
    value: "uinta:wyoming",
  },
  {
    text: "Uintah, UT",
    value: "uintah:utah",
  },
  {
    text: "Ulster, NY",
    value: "ulster:new york",
  },
  {
    text: "Umatilla, OR",
    value: "umatilla:oregon",
  },
  {
    text: "Unicoi, TN",
    value: "unicoi:tennessee",
  },
  {
    text: "Union, AR",
    value: "union:arkansas",
  },
  {
    text: "Union, FL",
    value: "union:florida",
  },
  {
    text: "Union, IL",
    value: "union:illinois",
  },
  {
    text: "Union, IN",
    value: "union:indiana",
  },
  {
    text: "Union, KY",
    value: "union:kentucky",
  },
  {
    text: "Union, LA",
    value: "union:louisiana",
  },
  {
    text: "Union, MS",
    value: "union:mississippi",
  },
  {
    text: "Union, NC",
    value: "union:north carolina",
  },
  {
    text: "Union, TN",
    value: "union:tennessee",
  },
  {
    text: "Union, GA",
    value: "union:georgia",
  },
  {
    text: "Union, NJ",
    value: "union:new jersey",
  },
  {
    text: "Union, OH",
    value: "union:ohio",
  },
  {
    text: "Union, PA",
    value: "union:pennsylvania",
  },
  {
    text: "Union, SC",
    value: "union:south carolina",
  },
  {
    text: "Union, IA",
    value: "union:iowa",
  },
  {
    text: "Union, SD",
    value: "union:south dakota",
  },
  {
    text: "Union, NM",
    value: "union:new mexico",
  },
  {
    text: "Union, OR",
    value: "union:oregon",
  },
  {
    text: "Unknown, AR",
    value: "unknown:arkansas",
  },
  {
    text: "Unknown, SD",
    value: "unknown:south dakota",
  },
  {
    text: "Unknown, CA",
    value: "unknown:california",
  },
  {
    text: "Unknown, AK",
    value: "unknown:alaska",
  },
  {
    text: "Upshur, TX",
    value: "upshur:texas",
  },
  {
    text: "Upshur, WV",
    value: "upshur:west virginia",
  },
  {
    text: "Upson, GA",
    value: "upson:georgia",
  },
  {
    text: "Upton, TX",
    value: "upton:texas",
  },
  {
    text: "Utah, UT",
    value: "utah:utah",
  },
  {
    text: "Uvalde, TX",
    value: "uvalde:texas",
  },
  {
    text: "Val Verde, TX",
    value: "val verde:texas",
  },
  {
    text: "Valdez-Cordova, AK",
    value: "valdez-cordova:alaska",
  },
  {
    text: "Valencia, NM",
    value: "valencia:new mexico",
  },
  {
    text: "Valley, NE",
    value: "valley:nebraska",
  },
  {
    text: "Valley, ID",
    value: "valley:idaho",
  },
  {
    text: "Valley, MT",
    value: "valley:montana",
  },
  {
    text: "Van Buren, AR",
    value: "van buren:arkansas",
  },
  {
    text: "Van Buren, TN",
    value: "van buren:tennessee",
  },
  {
    text: "Van Buren, IA",
    value: "van buren:iowa",
  },
  {
    text: "Van Buren, MI",
    value: "van buren:michigan",
  },
  {
    text: "Van Wert, OH",
    value: "van wert:ohio",
  },
  {
    text: "Van Zandt, TX",
    value: "van zandt:texas",
  },
  {
    text: "Vance, NC",
    value: "vance:north carolina",
  },
  {
    text: "Vanderburgh, IN",
    value: "vanderburgh:indiana",
  },
  {
    text: "Venango, PA",
    value: "venango:pennsylvania",
  },
  {
    text: "Ventura, CA",
    value: "ventura:california",
  },
  {
    text: "Vermilion, IL",
    value: "vermilion:illinois",
  },
  {
    text: "Vermilion, LA",
    value: "vermilion:louisiana",
  },
  {
    text: "Vermillion, IN",
    value: "vermillion:indiana",
  },
  {
    text: "Vernon, LA",
    value: "vernon:louisiana",
  },
  {
    text: "Vernon, MO",
    value: "vernon:missouri",
  },
  {
    text: "Vernon, WI",
    value: "vernon:wisconsin",
  },
  {
    text: "Victoria, TX",
    value: "victoria:texas",
  },
  {
    text: "Vigo, IN",
    value: "vigo:indiana",
  },
  {
    text: "Vilas, WI",
    value: "vilas:wisconsin",
  },
  {
    text: "Vinton, OH",
    value: "vinton:ohio",
  },
  {
    text: "Virginia Beach, VA",
    value: "virginia beach city:virginia",
  },
  {
    text: "Volusia, FL",
    value: "volusia:florida",
  },
  {
    text: "Wabash, IL",
    value: "wabash:illinois",
  },
  {
    text: "Wabash, IN",
    value: "wabash:indiana",
  },
  {
    text: "Wabasha, MN",
    value: "wabasha:minnesota",
  },
  {
    text: "Wabaunsee, KS",
    value: "wabaunsee:kansas",
  },
  {
    text: "Wadena, MN",
    value: "wadena:minnesota",
  },
  {
    text: "Wagoner, OK",
    value: "wagoner:oklahoma",
  },
  {
    text: "Wahkiakum, WA",
    value: "wahkiakum:washington",
  },
  {
    text: "Wake, NC",
    value: "wake:north carolina",
  },
  {
    text: "Wakulla, FL",
    value: "wakulla:florida",
  },
  {
    text: "Waldo, ME",
    value: "waldo:maine",
  },
  {
    text: "Walker, TX",
    value: "walker:texas",
  },
  {
    text: "Walker, AL",
    value: "walker:alabama",
  },
  {
    text: "Walker, GA",
    value: "walker:georgia",
  },
  {
    text: "Walla Walla, WA",
    value: "walla walla:washington",
  },
  {
    text: "Wallace, KS",
    value: "wallace:kansas",
  },
  {
    text: "Waller, TX",
    value: "waller:texas",
  },
  {
    text: "Wallowa, OR",
    value: "wallowa:oregon",
  },
  {
    text: "Walsh, ND",
    value: "walsh:north dakota",
  },
  {
    text: "Walthall, MS",
    value: "walthall:mississippi",
  },
  {
    text: "Walton, FL",
    value: "walton:florida",
  },
  {
    text: "Walton, GA",
    value: "walton:georgia",
  },
  {
    text: "Walworth, SD",
    value: "walworth:south dakota",
  },
  {
    text: "Walworth, WI",
    value: "walworth:wisconsin",
  },
  {
    text: "Wapello, IA",
    value: "wapello:iowa",
  },
  {
    text: "Ward, TX",
    value: "ward:texas",
  },
  {
    text: "Ward, ND",
    value: "ward:north dakota",
  },
  {
    text: "Ware, GA",
    value: "ware:georgia",
  },
  {
    text: "Warren, VA",
    value: "warren:virginia",
  },
  {
    text: "Warren, IL",
    value: "warren:illinois",
  },
  {
    text: "Warren, IN",
    value: "warren:indiana",
  },
  {
    text: "Warren, KY",
    value: "warren:kentucky",
  },
  {
    text: "Warren, MO",
    value: "warren:missouri",
  },
  {
    text: "Warren, MS",
    value: "warren:mississippi",
  },
  {
    text: "Warren, NC",
    value: "warren:north carolina",
  },
  {
    text: "Warren, TN",
    value: "warren:tennessee",
  },
  {
    text: "Warren, GA",
    value: "warren:georgia",
  },
  {
    text: "Warren, NJ",
    value: "warren:new jersey",
  },
  {
    text: "Warren, OH",
    value: "warren:ohio",
  },
  {
    text: "Warren, PA",
    value: "warren:pennsylvania",
  },
  {
    text: "Warren, IA",
    value: "warren:iowa",
  },
  {
    text: "Warren, NY",
    value: "warren:new york",
  },
  {
    text: "Warrick, IN",
    value: "warrick:indiana",
  },
  {
    text: "Wasatch, UT",
    value: "wasatch:utah",
  },
  {
    text: "Wasco, OR",
    value: "wasco:oregon",
  },
  {
    text: "Waseca, MN",
    value: "waseca:minnesota",
  },
  {
    text: "Washakie, WY",
    value: "washakie:wyoming",
  },
  {
    text: "Washburn, WI",
    value: "washburn:wisconsin",
  },
  {
    text: "Washington, TX",
    value: "washington:texas",
  },
  {
    text: "Washington, AL",
    value: "washington:alabama",
  },
  {
    text: "Washington, VA",
    value: "washington:virginia",
  },
  {
    text: "Washington, AR",
    value: "washington:arkansas",
  },
  {
    text: "Washington, FL",
    value: "washington:florida",
  },
  {
    text: "Washington, IL",
    value: "washington:illinois",
  },
  {
    text: "Washington, IN",
    value: "washington:indiana",
  },
  {
    text: "Washington, KS",
    value: "washington:kansas",
  },
  {
    text: "Washington, KY",
    value: "washington:kentucky",
  },
  {
    text: "Washington, LA",
    value: "washington:louisiana",
  },
  {
    text: "Washington, MD",
    value: "washington:maryland",
  },
  {
    text: "Washington, MO",
    value: "washington:missouri",
  },
  {
    text: "Washington, MS",
    value: "washington:mississippi",
  },
  {
    text: "Washington, NC",
    value: "washington:north carolina",
  },
  {
    text: "Washington, TN",
    value: "washington:tennessee",
  },
  {
    text: "Washington, GA",
    value: "washington:georgia",
  },
  {
    text: "Washington, OH",
    value: "washington:ohio",
  },
  {
    text: "Washington, OK",
    value: "washington:oklahoma",
  },
  {
    text: "Washington, PA",
    value: "washington:pennsylvania",
  },
  {
    text: "Washington, IA",
    value: "washington:iowa",
  },
  {
    text: "Washington, MN",
    value: "washington:minnesota",
  },
  {
    text: "Washington, NE",
    value: "washington:nebraska",
  },
  {
    text: "Washington, NY",
    value: "washington:new york",
  },
  {
    text: "Washington, WI",
    value: "washington:wisconsin",
  },
  {
    text: "Washington, ME",
    value: "washington:maine",
  },
  {
    text: "Washington, RI",
    value: "washington:rhode island",
  },
  {
    text: "Washington, VT",
    value: "washington:vermont",
  },
  {
    text: "Washington, CO",
    value: "washington:colorado",
  },
  {
    text: "Washington, UT",
    value: "washington:utah",
  },
  {
    text: "Washington, OR",
    value: "washington:oregon",
  },
  {
    text: "Washington, ID",
    value: "washington:idaho",
  },
  {
    text: "Washington, DC",
    value: "washington, d.c.:district of columbia",
  },
  {
    text: "Washita, OK",
    value: "washita:oklahoma",
  },
  {
    text: "Washoe, NV",
    value: "washoe:nevada",
  },
  {
    text: "Washtenaw, MI",
    value: "washtenaw:michigan",
  },
  {
    text: "Watauga, NC",
    value: "watauga:north carolina",
  },
  {
    text: "Watonwan, MN",
    value: "watonwan:minnesota",
  },
  {
    text: "Waukesha, WI",
    value: "waukesha:wisconsin",
  },
  {
    text: "Waupaca, WI",
    value: "waupaca:wisconsin",
  },
  {
    text: "Waushara, WI",
    value: "waushara:wisconsin",
  },
  {
    text: "Wayne, WV",
    value: "wayne:west virginia",
  },
  {
    text: "Wayne, IL",
    value: "wayne:illinois",
  },
  {
    text: "Wayne, IN",
    value: "wayne:indiana",
  },
  {
    text: "Wayne, KY",
    value: "wayne:kentucky",
  },
  {
    text: "Wayne, MO",
    value: "wayne:missouri",
  },
  {
    text: "Wayne, MS",
    value: "wayne:mississippi",
  },
  {
    text: "Wayne, NC",
    value: "wayne:north carolina",
  },
  {
    text: "Wayne, TN",
    value: "wayne:tennessee",
  },
  {
    text: "Wayne, GA",
    value: "wayne:georgia",
  },
  {
    text: "Wayne, OH",
    value: "wayne:ohio",
  },
  {
    text: "Wayne, PA",
    value: "wayne:pennsylvania",
  },
  {
    text: "Wayne, IA",
    value: "wayne:iowa",
  },
  {
    text: "Wayne, NE",
    value: "wayne:nebraska",
  },
  {
    text: "Wayne, NY",
    value: "wayne:new york",
  },
  {
    text: "Wayne, MI",
    value: "wayne:michigan",
  },
  {
    text: "Wayne, UT",
    value: "wayne:utah",
  },
  {
    text: "Waynesboro, VA",
    value: "waynesboro city:virginia",
  },
  {
    text: "Weakley, TN",
    value: "weakley:tennessee",
  },
  {
    text: "Webb, TX",
    value: "webb:texas",
  },
  {
    text: "Weber, UT",
    value: "weber:utah",
  },
  {
    text: "Webster, WV",
    value: "webster:west virginia",
  },
  {
    text: "Webster, KY",
    value: "webster:kentucky",
  },
  {
    text: "Webster, LA",
    value: "webster:louisiana",
  },
  {
    text: "Webster, MO",
    value: "webster:missouri",
  },
  {
    text: "Webster, MS",
    value: "webster:mississippi",
  },
  {
    text: "Webster, GA",
    value: "webster:georgia",
  },
  {
    text: "Webster, IA",
    value: "webster:iowa",
  },
  {
    text: "Webster, NE",
    value: "webster:nebraska",
  },
  {
    text: "Weld, CO",
    value: "weld:colorado",
  },
  {
    text: "Wells, IN",
    value: "wells:indiana",
  },
  {
    text: "Wells, ND",
    value: "wells:north dakota",
  },
  {
    text: "West Baton Rouge, LA",
    value: "west baton rouge:louisiana",
  },
  {
    text: "West Baton Rouge, LA",
    value: "west baton rouge parish:louisiana",
  },
  {
    text: "West Carroll, LA",
    value: "west carroll:louisiana",
  },
  {
    text: "West Feliciana, LA",
    value: "west feliciana:louisiana",
  },
  {
    text: "Westchester, NY",
    value: "westchester:new york",
  },
  {
    text: "Westmoreland, VA",
    value: "westmoreland:virginia",
  },
  {
    text: "Westmoreland, PA",
    value: "westmoreland:pennsylvania",
  },
  {
    text: "Weston, WY",
    value: "weston:wyoming",
  },
  {
    text: "Wetzel, WV",
    value: "wetzel:west virginia",
  },
  {
    text: "Wexford, MI",
    value: "wexford:michigan",
  },
  {
    text: "Wharton, TX",
    value: "wharton:texas",
  },
  {
    text: "Whatcom, WA",
    value: "whatcom:washington",
  },
  {
    text: "Wheatland, MT",
    value: "wheatland:montana",
  },
  {
    text: "Wheeler, TX",
    value: "wheeler:texas",
  },
  {
    text: "Wheeler, GA",
    value: "wheeler:georgia",
  },
  {
    text: "Wheeler, NE",
    value: "wheeler:nebraska",
  },
  {
    text: "Wheeler, OR",
    value: "wheeler:oregon",
  },
  {
    text: "White, AR",
    value: "white:arkansas",
  },
  {
    text: "White, IL",
    value: "white:illinois",
  },
  {
    text: "White, IN",
    value: "white:indiana",
  },
  {
    text: "White, TN",
    value: "white:tennessee",
  },
  {
    text: "White, GA",
    value: "white:georgia",
  },
  {
    text: "White Pine, NV",
    value: "white pine:nevada",
  },
  {
    text: "Whiteside, IL",
    value: "whiteside:illinois",
  },
  {
    text: "Whitfield, GA",
    value: "whitfield:georgia",
  },
  {
    text: "Whitley, IN",
    value: "whitley:indiana",
  },
  {
    text: "Whitley, KY",
    value: "whitley:kentucky",
  },
  {
    text: "Whitman, WA",
    value: "whitman:washington",
  },
  {
    text: "Wibaux, MT",
    value: "wibaux:montana",
  },
  {
    text: "Wichita, TX",
    value: "wichita:texas",
  },
  {
    text: "Wichita, KS",
    value: "wichita:kansas",
  },
  {
    text: "Wicomico, MD",
    value: "wicomico:maryland",
  },
  {
    text: "Wilbarger, TX",
    value: "wilbarger:texas",
  },
  {
    text: "Wilcox, AL",
    value: "wilcox:alabama",
  },
  {
    text: "Wilcox, GA",
    value: "wilcox:georgia",
  },
  {
    text: "Wilkes, NC",
    value: "wilkes:north carolina",
  },
  {
    text: "Wilkes, GA",
    value: "wilkes:georgia",
  },
  {
    text: "Wilkin, MN",
    value: "wilkin:minnesota",
  },
  {
    text: "Wilkinson, MS",
    value: "wilkinson:mississippi",
  },
  {
    text: "Wilkinson, GA",
    value: "wilkinson:georgia",
  },
  {
    text: "Will, IL",
    value: "will:illinois",
  },
  {
    text: "Willacy, TX",
    value: "willacy:texas",
  },
  {
    text: "Williams, OH",
    value: "williams:ohio",
  },
  {
    text: "Williams, ND",
    value: "williams:north dakota",
  },
  {
    text: "Williamsburg, VA",
    value: "williamsburg:virginia",
  },
  {
    text: "Williamsburg, SC",
    value: "williamsburg:south carolina",
  },
  {
    text: "Williamsburg, VA",
    value: "williamsburg city:virginia",
  },
  {
    text: "Williamsburg, SC",
    value: "williamsburg city:south carolina",
  },
  {
    text: "Williamson, TX",
    value: "williamson:texas",
  },
  {
    text: "Williamson, IL",
    value: "williamson:illinois",
  },
  {
    text: "Williamson, TN",
    value: "williamson:tennessee",
  },
  {
    text: "Wilson, TX",
    value: "wilson:texas",
  },
  {
    text: "Wilson, KS",
    value: "wilson:kansas",
  },
  {
    text: "Wilson, NC",
    value: "wilson:north carolina",
  },
  {
    text: "Wilson, TN",
    value: "wilson:tennessee",
  },
  {
    text: "Winchester, VA",
    value: "winchester city:virginia",
  },
  {
    text: "Windham, CT",
    value: "windham:connecticut",
  },
  {
    text: "Windham, VT",
    value: "windham:vermont",
  },
  {
    text: "Windsor, VT",
    value: "windsor:vermont",
  },
  {
    text: "Winkler, TX",
    value: "winkler:texas",
  },
  {
    text: "Winn, LA",
    value: "winn:louisiana",
  },
  {
    text: "Winnebago, IL",
    value: "winnebago:illinois",
  },
  {
    text: "Winnebago, IA",
    value: "winnebago:iowa",
  },
  {
    text: "Winnebago, WI",
    value: "winnebago:wisconsin",
  },
  {
    text: "Winneshiek, IA",
    value: "winneshiek:iowa",
  },
  {
    text: "Winona, MN",
    value: "winona:minnesota",
  },
  {
    text: "Winston, AL",
    value: "winston:alabama",
  },
  {
    text: "Winston, MS",
    value: "winston:mississippi",
  },
  {
    text: "Wirt, WV",
    value: "wirt:west virginia",
  },
  {
    text: "Wise, TX",
    value: "wise:texas",
  },
  {
    text: "Wise, VA",
    value: "wise:virginia",
  },
  {
    text: "Wolfe, KY",
    value: "wolfe:kentucky",
  },
  {
    text: "Wood, TX",
    value: "wood:texas",
  },
  {
    text: "Wood, WV",
    value: "wood:west virginia",
  },
  {
    text: "Wood, OH",
    value: "wood:ohio",
  },
  {
    text: "Wood, WI",
    value: "wood:wisconsin",
  },
  {
    text: "Woodbury, IA",
    value: "woodbury:iowa",
  },
  {
    text: "Woodford, IL",
    value: "woodford:illinois",
  },
  {
    text: "Woodford, KY",
    value: "woodford:kentucky",
  },
  {
    text: "Woodruff, AR",
    value: "woodruff:arkansas",
  },
  {
    text: "Woods, OK",
    value: "woods:oklahoma",
  },
  {
    text: "Woodson, KS",
    value: "woodson:kansas",
  },
  {
    text: "Woodward, OK",
    value: "woodward:oklahoma",
  },
  {
    text: "Worcester, MD",
    value: "worcester:maryland",
  },
  {
    text: "Worcester, MA",
    value: "worcester:massachusetts",
  },
  {
    text: "Worth, MO",
    value: "worth:missouri",
  },
  {
    text: "Worth, GA",
    value: "worth:georgia",
  },
  {
    text: "Worth, IA",
    value: "worth:iowa",
  },
  {
    text: "Wrangell, AK",
    value: "wrangell:alaska",
  },
  {
    text: "Wright, MO",
    value: "wright:missouri",
  },
  {
    text: "Wright, IA",
    value: "wright:iowa",
  },
  {
    text: "Wright, MN",
    value: "wright:minnesota",
  },
  {
    text: "Wyandot, OH",
    value: "wyandot:ohio",
  },
  {
    text: "Wyandotte, KS",
    value: "wyandotte:kansas",
  },
  {
    text: "Wyoming, WV",
    value: "wyoming:west virginia",
  },
  {
    text: "Wyoming, PA",
    value: "wyoming:pennsylvania",
  },
  {
    text: "Wyoming, NY",
    value: "wyoming:new york",
  },
  {
    text: "Wythe, VA",
    value: "wythe:virginia",
  },
  {
    text: "Yadkin, NC",
    value: "yadkin:north carolina",
  },
  {
    text: "Yakima, WA",
    value: "yakima:washington",
  },
  {
    text: "Yakutat, AK",
    value: "yakutat:alaska",
  },
  {
    text: "Yalobusha, MS",
    value: "yalobusha:mississippi",
  },
  {
    text: "Yamhill, OR",
    value: "yamhill:oregon",
  },
  {
    text: "Yancey, NC",
    value: "yancey:north carolina",
  },
  {
    text: "Yankton, SD",
    value: "yankton:south dakota",
  },
  {
    text: "Yates, NY",
    value: "yates:new york",
  },
  {
    text: "Yavapai, AZ",
    value: "yavapai:arizona",
  },
  {
    text: "Yazoo, MS",
    value: "yazoo:mississippi",
  },
  {
    text: "Yell, AR",
    value: "yell:arkansas",
  },
  {
    text: "Yellow Medicine, MN",
    value: "yellow medicine:minnesota",
  },
  {
    text: "Yellowstone, MT",
    value: "yellowstone:montana",
  },
  {
    text: "Yoakum, TX",
    value: "yoakum:texas",
  },
  {
    text: "Yolo, CA",
    value: "yolo:california",
  },
  {
    text: "York, VA",
    value: "york:virginia",
  },
  {
    text: "York, PA",
    value: "york:pennsylvania",
  },
  {
    text: "York, SC",
    value: "york:south carolina",
  },
  {
    text: "York, NE",
    value: "york:nebraska",
  },
  {
    text: "York, ME",
    value: "york:maine",
  },
  {
    text: "Young, TX",
    value: "young:texas",
  },
  {
    text: "Yuba, CA",
    value: "yuba:california",
  },
  {
    text: "Yukon-Koyukuk, AK",
    value: "yukon koyukuk:alaska",
  },
  {
    text: "Yukon-Koyukuk, AK",
    value: "yukon-koyukuk:alaska",
  },
  {
    text: "Yuma, AZ",
    value: "yuma:arizona",
  },
  {
    text: "Yuma, CO",
    value: "yuma:colorado",
  },
  {
    text: "Zapata, TX",
    value: "zapata:texas",
  },
  {
    text: "Zavala, TX",
    value: "zavala:texas",
  },
  {
    text: "Ziebach, SD",
    value: "ziebach:south dakota",
  },
];
